var _defs, _rect, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGraybg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1920 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".d{fill:none;}.e{opacity:.08;}.f{fill:#fff;}.g{fill:#ddd;}.h{opacity:.26;}.i{clip-path:url(#c);}.j{clip-path:url(#b);}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "d",
    x: 0,
    y: 0,
    width: 1920,
    height: 1080
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "d",
    x: 1976.97,
    y: 0,
    width: 1920,
    height: 1080
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "g",
    x: 0,
    y: 0,
    width: 1920,
    height: 1080
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "h"
  }, /*#__PURE__*/React.createElement("g", {
    className: "j"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M32.17,26.42c0,9.6-7.87,17.41-17.53,17.41S-2.89,36.04-2.89,26.42,4.98,9.01,14.64,9.01s17.53,7.81,17.53,17.41Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 56.64,
    cy: 39.97,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 85.12,
    cy: 39.97,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M109.36,11.06l-16.17,20.33c-.8,1.15-2.12,1.83-3.52,1.82H54.25c-2.32,0-4.19-1.76-4.19-3.94V13.91h-3.21c-2.15,0-4.22-.8-5.8-2.26-1.53-1.4-2.41-3.36-2.42-5.43,.03-.69,.61-1.23,1.3-1.21H105.83c3.32-.02,5.32,3.44,3.53,6.06Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 142.42,
    cy: 26.39,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M48.12,58.73v28.68c0,2.73-2.31,4.99-5.15,4.99H-24.82c-1.2,.02-2.19-.94-2.22-2.14v-1.01c0-6.21,4.39-11.47,10.33-13.02v-17.5c0-2.73,2.32-4.99,5.15-4.99H43c2.79-.02,5.07,2.2,5.12,4.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M98.04,74.99c0,9.6-7.87,17.41-17.53,17.41s-17.52-7.79-17.52-17.41,7.87-17.41,17.53-17.41,17.52,7.81,17.52,17.41Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 122.52,
    cy: 88.54,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 151,
    cy: 88.54,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M175.23,59.63l-16.17,20.34c-.81,1.14-2.12,1.81-3.52,1.8h-35.42c-2.32,0-4.19-1.76-4.19-3.94v-15.35h-3.21c-2.15,0-4.22-.8-5.8-2.26-1.53-1.4-2.41-3.37-2.42-5.44,.03-.69,.61-1.23,1.3-1.21h65.9c3.33,0,5.33,3.45,3.53,6.07Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 15.04,
    cy: 123.52,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M114,107.3v28.68c0,2.73-2.32,4.99-5.15,4.99H41.06c-1.2,.02-2.2-.94-2.22-2.14v-1c0-6.21,4.39-11.48,10.33-13.02v-17.5c0-2.73,2.32-4.99,5.15-4.99h54.55c2.81,0,5.13,2.24,5.13,4.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M163.92,123.55c0,9.6-7.87,17.41-17.53,17.41s-17.53-7.79-17.53-17.41,7.87-17.41,17.53-17.41,17.53,7.81,17.53,17.41Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 23.61,
    cy: 185.67,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M47.85,156.76l-16.17,20.33c-.81,1.14-2.12,1.81-3.52,1.8H-7.26c-2.32,0-4.19-1.76-4.19-3.94v-15.35h-3.21c-2.15,0-4.22-.8-5.8-2.27-1.53-1.4-2.41-3.37-2.42-5.44,.03-.69,.61-1.23,1.3-1.21H44.32c3.32,0,5.32,3.46,3.53,6.07Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 80.91,
    cy: 172.09,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M179.87,155.86v28.68c0,2.73-2.32,4.99-5.15,4.99H106.94c-1.2,.02-2.2-.94-2.22-2.14v-1.01c0-6.21,4.39-11.47,10.33-13.02v-17.5c0-2.73,2.31-4.99,5.15-4.99h54.56c2.8,0,5.12,2.24,5.12,4.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M36.53,220.68c0,9.6-7.87,17.41-17.53,17.41S1.47,230.3,1.47,220.68s7.87-17.41,17.53-17.41,17.53,7.81,17.53,17.41Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 61.01,
    cy: 234.24,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 89.48,
    cy: 234.24,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M113.72,205.33l-16.17,20.33c-.81,1.14-2.12,1.81-3.52,1.8H58.62c-2.32,0-4.2-1.76-4.2-3.94v-15.36h-3.21c-2.15,0-4.21-.8-5.79-2.26-1.53-1.4-2.41-3.38-2.42-5.45,.03-.69,.61-1.23,1.3-1.21H110.19c3.32,.02,5.32,3.47,3.53,6.08Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 146.79,
    cy: 220.65,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M52.48,253v28.68c0,2.73-2.32,4.99-5.15,4.99H-20.45c-1.2,.02-2.2-.94-2.22-2.14v-1.01c0-6.21,4.39-11.47,10.33-13.02v-17.5c0-2.73,2.31-4.99,5.15-4.99H47.35c2.81,0,5.13,2.24,5.13,4.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M102.41,269.25c0,9.6-7.87,17.41-17.53,17.41s-17.53-7.79-17.53-17.41,7.87-17.41,17.53-17.41,17.53,7.81,17.53,17.41Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 126.88,
    cy: 282.8,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 155.36,
    cy: 282.8,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M179.6,253.89l-16.17,20.33c-.8,1.15-2.12,1.83-3.52,1.82h-35.42c-2.32,0-4.19-1.76-4.19-3.94v-15.37h-3.21c-2.15,0-4.22-.8-5.8-2.26-1.53-1.4-2.41-3.38-2.42-5.45,.03-.69,.61-1.23,1.3-1.21h65.9c3.33,.02,5.32,3.47,3.53,6.08Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 19.4,
    cy: 317.78,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M118.36,301.56v28.68c0,2.73-2.32,4.99-5.15,4.99H45.42c-1.2,.02-2.2-.94-2.22-2.14v-1c0-6.21,4.39-11.48,10.33-13.02v-17.5c0-2.73,2.31-4.99,5.15-4.99h54.55c2.81,0,5.13,2.24,5.13,4.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M168.28,317.82c0,9.6-7.87,17.41-17.53,17.41s-17.53-7.79-17.53-17.41,7.87-17.41,17.53-17.41,17.53,7.81,17.53,17.41Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 142.3,
    cy: 26.39,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M241.26,10.16v28.68c0,2.73-2.32,4.99-5.15,4.99h-67.79c-1.2,.02-2.2-.94-2.22-2.14v-1c0-6.21,4.39-11.47,10.33-13.02V10.16c0-2.73,2.32-4.99,5.15-4.99h54.55c2.82,0,5.13,2.23,5.13,4.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M291.19,26.42c0,9.6-7.87,17.41-17.53,17.41s-17.53-7.79-17.53-17.41,7.87-17.41,17.53-17.41,17.53,7.81,17.53,17.41Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 315.66,
    cy: 39.97,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 344.14,
    cy: 39.97,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M368.37,11.06l-16.17,20.33c-.8,1.15-2.12,1.83-3.52,1.82h-35.42c-2.32,0-4.19-1.76-4.19-3.94V13.91h-3.21c-2.15,0-4.22-.8-5.8-2.26-1.53-1.4-2.41-3.36-2.42-5.43,.03-.69,.61-1.23,1.3-1.21h65.9c3.32-.02,5.32,3.44,3.53,6.06Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 401.44,
    cy: 26.39,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 122.4,
    cy: 88.54,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 150.87,
    cy: 88.54,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M175.11,59.63l-16.17,20.34c-.81,1.14-2.12,1.81-3.52,1.8h-35.42c-2.32,0-4.19-1.76-4.19-3.94v-15.35h-3.21c-2.15,0-4.22-.8-5.8-2.26-1.53-1.4-2.41-3.37-2.42-5.44,.03-.69,.61-1.23,1.3-1.21h65.9c3.32,0,5.32,3.45,3.53,6.07Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 208.18,
    cy: 74.95,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M307.14,58.73v28.68c0,2.73-2.31,4.99-5.15,4.99h-67.79c-1.2,.02-2.19-.94-2.22-2.14v-1.01c0-6.21,4.39-11.47,10.33-13.02v-17.5c0-2.73,2.32-4.99,5.15-4.99h54.56c2.79-.02,5.07,2.2,5.12,4.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M357.06,74.99c0,9.6-7.87,17.41-17.53,17.41s-17.52-7.79-17.52-17.41,7.87-17.41,17.53-17.41,17.52,7.81,17.52,17.41Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 381.54,
    cy: 88.54,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 410.01,
    cy: 88.54,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M434.25,59.63l-16.17,20.34c-.81,1.14-2.12,1.81-3.52,1.8h-35.42c-2.32,0-4.19-1.76-4.19-3.94v-15.35h-3.21c-2.15,0-4.22-.8-5.8-2.26-1.53-1.4-2.41-3.37-2.42-5.44,.03-.69,.61-1.23,1.3-1.21h65.9c3.33,0,5.33,3.45,3.53,6.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M163.8,123.55c0,9.6-7.87,17.41-17.53,17.41s-17.53-7.79-17.53-17.41,7.87-17.4,17.53-17.4,17.53,7.8,17.53,17.4Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 188.27,
    cy: 137.11,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 216.75,
    cy: 137.11,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M240.98,108.2l-16.17,20.33c-.81,1.14-2.12,1.82-3.52,1.8h-35.42c-2.32,0-4.19-1.76-4.19-3.94v-15.36h-3.21c-2.15,0-4.22-.8-5.79-2.26-1.53-1.4-2.41-3.38-2.42-5.45,.03-.69,.61-1.23,1.3-1.21h65.9c3.33,.02,5.32,3.47,3.53,6.08Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 274.05,
    cy: 123.52,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M373.01,107.3v28.68c0,2.73-2.32,4.99-5.15,4.99h-67.79c-1.2,.02-2.2-.94-2.22-2.14v-1c0-6.21,4.39-11.48,10.33-13.02v-17.5c0-2.73,2.32-4.99,5.15-4.99h54.55c2.81,0,5.13,2.24,5.13,4.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M422.94,123.55c0,9.6-7.87,17.41-17.53,17.41s-17.53-7.79-17.53-17.41,7.87-17.41,17.53-17.41,17.53,7.81,17.53,17.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M179.75,155.86v28.68c0,2.73-2.31,4.99-5.15,4.99H106.81c-1.2,.02-2.2-.94-2.22-2.14v-1.01c0-6.21,4.39-11.47,10.33-13.02v-17.5c0-2.73,2.32-4.99,5.15-4.99h54.55c2.79-.03,5.08,2.2,5.13,4.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M229.67,172.12c0,9.6-7.87,17.41-17.53,17.41s-17.53-7.79-17.53-17.41,7.87-17.41,17.53-17.41,17.53,7.81,17.53,17.41Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 254.15,
    cy: 185.67,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 282.63,
    cy: 185.67,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M306.86,156.76l-16.17,20.33c-.81,1.14-2.12,1.81-3.52,1.8h-35.42c-2.32,0-4.19-1.76-4.19-3.94v-15.35h-3.21c-2.15,0-4.22-.8-5.8-2.27-1.53-1.4-2.41-3.37-2.42-5.44,.03-.69,.61-1.23,1.3-1.21h65.9c3.32,0,5.32,3.46,3.53,6.07Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 339.93,
    cy: 172.09,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M438.89,155.86v28.68c0,2.73-2.32,4.99-5.15,4.99h-67.79c-1.2,.02-2.2-.94-2.22-2.14v-1.01c0-6.21,4.39-11.47,10.33-13.02v-17.5c0-2.73,2.31-4.99,5.15-4.99h54.56c2.8,0,5.12,2.24,5.12,4.99Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 146.66,
    cy: 220.65,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M245.62,204.43v28.68c0,2.73-2.31,4.99-5.15,4.99h-67.79c-1.2,.02-2.2-.94-2.22-2.14h0v-1c0-6.21,4.39-11.48,10.33-13.02v-17.5c0-2.73,2.32-4.99,5.15-4.99h54.55c2.82,0,5.13,2.24,5.13,4.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M295.55,220.68c0,9.6-7.87,17.41-17.53,17.41s-17.53-7.79-17.53-17.41,7.87-17.41,17.53-17.41,17.53,7.81,17.53,17.41Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 320.02,
    cy: 234.24,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 348.5,
    cy: 234.24,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M372.74,205.33l-16.17,20.33c-.81,1.14-2.12,1.81-3.52,1.8h-35.42c-2.32,0-4.2-1.76-4.2-3.94v-15.36h-3.21c-2.15,0-4.21-.8-5.79-2.26-1.53-1.4-2.41-3.38-2.42-5.45,.03-.69,.61-1.23,1.3-1.21h65.9c3.32,.02,5.32,3.47,3.53,6.08Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 405.8,
    cy: 220.65,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 126.76,
    cy: 282.8,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 155.24,
    cy: 282.8,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M179.47,253.89l-16.17,20.33c-.8,1.15-2.12,1.83-3.52,1.82h-35.41c-2.32,0-4.19-1.76-4.19-3.94v-15.37h-3.22c-2.15,0-4.22-.8-5.8-2.26-1.53-1.4-2.41-3.38-2.42-5.45,.03-.69,.61-1.23,1.3-1.21h65.91c3.32,.02,5.32,3.47,3.53,6.08Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 212.54,
    cy: 269.21,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M311.5,253v28.68c0,2.73-2.32,4.99-5.15,4.99h-67.79c-1.2,.02-2.2-.94-2.22-2.14v-1.01c0-6.21,4.39-11.47,10.33-13.02v-17.5c0-2.73,2.31-4.99,5.15-4.99h54.55c2.81,0,5.13,2.24,5.13,4.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M361.43,269.25c0,9.6-7.87,17.41-17.53,17.41s-17.53-7.79-17.53-17.41,7.87-17.41,17.53-17.41,17.53,7.81,17.53,17.41Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 385.9,
    cy: 282.8,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 414.38,
    cy: 282.8,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M438.62,253.89l-16.17,20.33c-.8,1.15-2.12,1.83-3.52,1.82h-35.42c-2.32,0-4.19-1.76-4.19-3.94v-15.37h-3.21c-2.15,0-4.22-.8-5.8-2.26-1.53-1.4-2.41-3.38-2.42-5.45,.03-.69,.61-1.23,1.3-1.21h65.9c3.33,.02,5.32,3.47,3.53,6.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M118.24,301.56v28.68c0,2.73-2.31,4.99-5.15,4.99H45.3c-1.2,.02-2.19-.94-2.22-2.14v-1c0-6.21,4.39-11.48,10.33-13.02v-17.5c0-2.73,2.32-4.99,5.15-4.99h54.55c2.82,0,5.13,2.24,5.13,4.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M168.16,317.82c0,9.6-7.87,17.41-17.53,17.41s-17.53-7.79-17.53-17.41,7.87-17.41,17.53-17.41,17.53,7.81,17.53,17.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M245.35,302.46l-16.17,20.33c-.8,1.15-2.12,1.83-3.52,1.82h-35.41c-2.32,0-4.19-1.76-4.19-3.94v-15.37h-3.22c-2.15,0-4.23-.81-5.8-2.27-1.53-1.4-2.41-3.37-2.42-5.44,.03-.69,.61-1.23,1.3-1.21h65.9c3.32,.02,5.32,3.46,3.53,6.08Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 278.41,
    cy: 317.78,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M377.38,301.56v28.68c0,2.73-2.32,4.99-5.15,4.99h-67.79c-1.2,.02-2.2-.94-2.22-2.14v-1c0-6.21,4.39-11.48,10.33-13.02v-17.5c0-2.73,2.31-4.99,5.15-4.99h54.55c2.81,0,5.13,2.24,5.13,4.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M427.3,317.82c0,9.6-7.87,17.41-17.53,17.41s-17.53-7.79-17.53-17.41,7.87-17.41,17.53-17.41,17.53,7.81,17.53,17.41Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 401.32,
    cy: 26.39,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M500.28,10.16v28.68c0,2.73-2.32,4.99-5.15,4.99h-67.79c-1.2,.02-2.2-.94-2.22-2.14v-1c0-6.21,4.39-11.47,10.33-13.02V10.16c0-2.73,2.32-4.99,5.15-4.99h54.55c2.82,0,5.13,2.23,5.13,4.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M550.21,26.42c0,9.6-7.87,17.41-17.53,17.41s-17.53-7.79-17.53-17.41,7.87-17.41,17.53-17.41,17.53,7.81,17.53,17.41Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 574.68,
    cy: 39.97,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 603.16,
    cy: 39.97,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M627.39,11.06l-16.17,20.33c-.8,1.15-2.12,1.83-3.52,1.82h-35.42c-2.32,0-4.19-1.76-4.19-3.94V13.91h-3.21c-2.15,0-4.22-.8-5.8-2.26-1.53-1.4-2.41-3.36-2.42-5.43,.03-.69,.61-1.23,1.3-1.21h65.9c3.32-.02,5.32,3.44,3.53,6.06Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 660.46,
    cy: 26.39,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 381.41,
    cy: 88.54,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 409.89,
    cy: 88.54,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M434.13,59.63l-16.17,20.34c-.81,1.14-2.12,1.81-3.52,1.8h-35.42c-2.32,0-4.19-1.76-4.19-3.94v-15.35h-3.21c-2.15,0-4.22-.8-5.8-2.26-1.53-1.4-2.41-3.37-2.42-5.44,.03-.69,.61-1.23,1.3-1.21h65.9c3.32,0,5.32,3.45,3.53,6.07Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 467.19,
    cy: 74.95,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M566.16,58.73v28.68c0,2.73-2.31,4.99-5.15,4.99h-67.79c-1.2,.02-2.19-.94-2.22-2.14v-1.01c0-6.21,4.39-11.47,10.33-13.02v-17.5c0-2.73,2.32-4.99,5.15-4.99h54.56c2.79-.02,5.07,2.2,5.12,4.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M616.08,74.99c0,9.6-7.87,17.41-17.53,17.41s-17.52-7.79-17.52-17.41,7.87-17.41,17.53-17.41,17.52,7.81,17.52,17.41Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 640.56,
    cy: 88.54,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 669.03,
    cy: 88.54,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M693.27,59.63l-16.17,20.34c-.81,1.14-2.12,1.81-3.52,1.8h-35.42c-2.32,0-4.19-1.76-4.19-3.94v-15.35h-3.21c-2.15,0-4.22-.8-5.8-2.26-1.53-1.4-2.41-3.37-2.42-5.44,.03-.69,.61-1.23,1.3-1.21h65.9c3.33,0,5.33,3.45,3.53,6.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M422.82,123.55c0,9.6-7.87,17.41-17.53,17.41s-17.53-7.79-17.53-17.41,7.87-17.4,17.53-17.4,17.53,7.8,17.53,17.4Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 447.29,
    cy: 137.11,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 475.77,
    cy: 137.11,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M500,108.2l-16.17,20.33c-.81,1.14-2.12,1.82-3.52,1.8h-35.42c-2.32,0-4.19-1.76-4.19-3.94v-15.36h-3.21c-2.15,0-4.22-.8-5.79-2.26-1.53-1.4-2.41-3.38-2.42-5.45,.03-.69,.61-1.23,1.3-1.21h65.9c3.33,.02,5.32,3.47,3.53,6.08Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 533.07,
    cy: 123.52,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M632.03,107.3v28.68c0,2.73-2.32,4.99-5.15,4.99h-67.79c-1.2,.02-2.2-.94-2.22-2.14v-1c0-6.21,4.39-11.48,10.33-13.02v-17.5c0-2.73,2.32-4.99,5.15-4.99h54.55c2.81,0,5.13,2.24,5.13,4.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M681.96,123.55c0,9.6-7.87,17.41-17.53,17.41s-17.53-7.79-17.53-17.41,7.87-17.41,17.53-17.41,17.53,7.81,17.53,17.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M438.77,155.86v28.68c0,2.73-2.31,4.99-5.15,4.99h-67.79c-1.2,.02-2.2-.94-2.22-2.14v-1.01c0-6.21,4.39-11.47,10.33-13.02v-17.5c0-2.73,2.32-4.99,5.15-4.99h54.55c2.79-.03,5.08,2.2,5.13,4.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M488.69,172.12c0,9.6-7.87,17.41-17.53,17.41s-17.53-7.79-17.53-17.41,7.87-17.41,17.53-17.41,17.53,7.81,17.53,17.41Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 513.17,
    cy: 185.67,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 541.65,
    cy: 185.67,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M565.88,156.76l-16.17,20.33c-.81,1.14-2.12,1.81-3.52,1.8h-35.42c-2.32,0-4.19-1.76-4.19-3.94v-15.35h-3.21c-2.15,0-4.22-.8-5.8-2.27-1.53-1.4-2.41-3.37-2.42-5.44,.03-.69,.61-1.23,1.3-1.21h65.9c3.32,0,5.32,3.46,3.53,6.07Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 598.95,
    cy: 172.09,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M697.91,155.86v28.68c0,2.73-2.32,4.99-5.15,4.99h-67.79c-1.2,.02-2.2-.94-2.22-2.14v-1.01c0-6.21,4.39-11.47,10.33-13.02v-17.5c0-2.73,2.31-4.99,5.15-4.99h54.56c2.8,0,5.12,2.24,5.12,4.99Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 405.68,
    cy: 220.65,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M504.64,204.43v28.68c0,2.73-2.31,4.99-5.15,4.99h-67.79c-1.2,.02-2.2-.94-2.22-2.14h0v-1c0-6.21,4.39-11.48,10.33-13.02v-17.5c0-2.73,2.32-4.99,5.15-4.99h54.55c2.82,0,5.13,2.24,5.13,4.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M554.57,220.68c0,9.6-7.87,17.41-17.53,17.41s-17.53-7.79-17.53-17.41,7.87-17.41,17.53-17.41,17.53,7.81,17.53,17.41Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 579.04,
    cy: 234.24,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 607.52,
    cy: 234.24,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M631.76,205.33l-16.17,20.33c-.81,1.14-2.12,1.81-3.52,1.8h-35.42c-2.32,0-4.2-1.76-4.2-3.94v-15.36h-3.21c-2.15,0-4.21-.8-5.79-2.26-1.53-1.4-2.41-3.38-2.42-5.45,.03-.69,.61-1.23,1.3-1.21h65.9c3.32,.02,5.32,3.47,3.53,6.08Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 664.82,
    cy: 220.65,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 385.78,
    cy: 282.8,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 414.26,
    cy: 282.8,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M438.49,253.89l-16.17,20.33c-.8,1.15-2.12,1.83-3.52,1.82h-35.41c-2.32,0-4.19-1.76-4.19-3.94v-15.37h-3.22c-2.15,0-4.22-.8-5.8-2.26-1.53-1.4-2.41-3.38-2.42-5.45,.03-.69,.61-1.23,1.3-1.21h65.91c3.32,.02,5.32,3.47,3.53,6.08Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 471.56,
    cy: 269.21,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M570.52,253v28.68c0,2.73-2.32,4.99-5.15,4.99h-67.79c-1.2,.02-2.2-.94-2.22-2.14v-1.01c0-6.21,4.39-11.47,10.33-13.02v-17.5c0-2.73,2.31-4.99,5.15-4.99h54.55c2.81,0,5.13,2.24,5.13,4.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M620.44,269.25c0,9.6-7.87,17.41-17.53,17.41s-17.53-7.79-17.53-17.41,7.87-17.41,17.53-17.41,17.53,7.81,17.53,17.41Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 644.92,
    cy: 282.8,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 673.4,
    cy: 282.8,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M697.64,253.89l-16.17,20.33c-.8,1.15-2.12,1.83-3.52,1.82h-35.42c-2.32,0-4.19-1.76-4.19-3.94v-15.37h-3.21c-2.15,0-4.22-.8-5.8-2.26-1.53-1.4-2.41-3.38-2.42-5.45,.03-.69,.61-1.23,1.3-1.21h65.9c3.33,.02,5.32,3.47,3.53,6.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M377.25,301.56v28.68c0,2.73-2.31,4.99-5.15,4.99h-67.79c-1.2,.02-2.19-.94-2.22-2.14v-1c0-6.21,4.39-11.48,10.33-13.02v-17.5c0-2.73,2.32-4.99,5.15-4.99h54.55c2.82,0,5.13,2.24,5.13,4.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M427.18,317.82c0,9.6-7.87,17.41-17.53,17.41s-17.53-7.79-17.53-17.41,7.87-17.41,17.53-17.41,17.53,7.81,17.53,17.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M504.37,302.46l-16.17,20.33c-.8,1.15-2.12,1.83-3.52,1.82h-35.41c-2.32,0-4.19-1.76-4.19-3.94v-15.37h-3.22c-2.15,0-4.23-.81-5.8-2.27-1.53-1.4-2.41-3.37-2.42-5.44,.03-.69,.61-1.23,1.3-1.21h65.9c3.32,.02,5.32,3.46,3.53,6.08Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 537.43,
    cy: 317.78,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M636.4,301.56v28.68c0,2.73-2.32,4.99-5.15,4.99h-67.79c-1.2,.02-2.2-.94-2.22-2.14v-1c0-6.21,4.39-11.48,10.33-13.02v-17.5c0-2.73,2.31-4.99,5.15-4.99h54.55c2.81,0,5.13,2.24,5.13,4.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M686.32,317.82c0,9.6-7.87,17.41-17.53,17.41s-17.53-7.79-17.53-17.41,7.87-17.41,17.53-17.41,17.53,7.81,17.53,17.41Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 660.34,
    cy: 26.39,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M759.3,10.16v28.68c0,2.73-2.32,4.99-5.15,4.99h-67.79c-1.2,.02-2.2-.94-2.22-2.14v-1c0-6.21,4.39-11.47,10.33-13.02V10.16c0-2.73,2.32-4.99,5.15-4.99h54.55c2.82,0,5.13,2.23,5.13,4.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M809.22,26.42c0,9.6-7.87,17.41-17.53,17.41s-17.53-7.79-17.53-17.41,7.87-17.41,17.53-17.41,17.53,7.81,17.53,17.41Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 833.7,
    cy: 39.97,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 862.18,
    cy: 39.97,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M886.41,11.06l-16.17,20.33c-.8,1.15-2.12,1.83-3.52,1.82h-35.42c-2.32,0-4.19-1.76-4.19-3.94V13.91h-3.21c-2.15,0-4.22-.8-5.8-2.26-1.53-1.4-2.41-3.36-2.42-5.43,.03-.69,.61-1.23,1.3-1.21h65.9c3.32-.02,5.32,3.44,3.53,6.06Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 919.48,
    cy: 26.39,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 640.43,
    cy: 88.54,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 668.91,
    cy: 88.54,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M693.15,59.63l-16.17,20.34c-.81,1.14-2.12,1.81-3.52,1.8h-35.42c-2.32,0-4.19-1.76-4.19-3.94v-15.35h-3.21c-2.15,0-4.22-.8-5.8-2.26-1.53-1.4-2.41-3.37-2.42-5.44,.03-.69,.61-1.23,1.3-1.21h65.9c3.32,0,5.32,3.45,3.53,6.07Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 726.21,
    cy: 74.95,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M825.17,58.73v28.68c0,2.73-2.31,4.99-5.15,4.99h-67.79c-1.2,.02-2.19-.94-2.22-2.14v-1.01c0-6.21,4.39-11.47,10.33-13.02v-17.5c0-2.73,2.32-4.99,5.15-4.99h54.56c2.79-.02,5.07,2.2,5.12,4.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M875.1,74.99c0,9.6-7.87,17.41-17.53,17.41s-17.52-7.79-17.52-17.41,7.87-17.41,17.53-17.41,17.52,7.81,17.52,17.41Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 899.57,
    cy: 88.54,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 928.05,
    cy: 88.54,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M952.29,59.63l-16.17,20.34c-.81,1.14-2.12,1.81-3.52,1.8h-35.42c-2.32,0-4.19-1.76-4.19-3.94v-15.35h-3.21c-2.15,0-4.22-.8-5.8-2.26-1.53-1.4-2.41-3.37-2.42-5.44,.03-.69,.61-1.23,1.3-1.21h65.9c3.33,0,5.33,3.45,3.53,6.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M681.83,123.55c0,9.6-7.87,17.41-17.53,17.41s-17.53-7.79-17.53-17.41,7.87-17.4,17.53-17.4,17.53,7.8,17.53,17.4Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 706.31,
    cy: 137.11,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 734.79,
    cy: 137.11,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M759.02,108.2l-16.17,20.33c-.81,1.14-2.12,1.82-3.52,1.8h-35.42c-2.32,0-4.19-1.76-4.19-3.94v-15.36h-3.21c-2.15,0-4.22-.8-5.79-2.26-1.53-1.4-2.41-3.38-2.42-5.45,.03-.69,.61-1.23,1.3-1.21h65.9c3.33,.02,5.32,3.47,3.53,6.08Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 792.09,
    cy: 123.52,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M891.05,107.3v28.68c0,2.73-2.32,4.99-5.15,4.99h-67.79c-1.2,.02-2.2-.94-2.22-2.14v-1c0-6.21,4.39-11.48,10.33-13.02v-17.5c0-2.73,2.32-4.99,5.15-4.99h54.55c2.81,0,5.13,2.24,5.13,4.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M940.97,123.55c0,9.6-7.87,17.41-17.53,17.41s-17.53-7.79-17.53-17.41,7.87-17.41,17.53-17.41,17.53,7.81,17.53,17.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M697.78,155.86v28.68c0,2.73-2.31,4.99-5.15,4.99h-67.79c-1.2,.02-2.2-.94-2.22-2.14v-1.01c0-6.21,4.39-11.47,10.33-13.02v-17.5c0-2.73,2.32-4.99,5.15-4.99h54.55c2.79-.03,5.08,2.2,5.13,4.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M747.71,172.12c0,9.6-7.87,17.41-17.53,17.41s-17.53-7.79-17.53-17.41,7.87-17.41,17.53-17.41,17.53,7.81,17.53,17.41Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 772.18,
    cy: 185.67,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 800.66,
    cy: 185.67,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M824.9,156.76l-16.17,20.33c-.81,1.14-2.12,1.81-3.52,1.8h-35.42c-2.32,0-4.19-1.76-4.19-3.94v-15.35h-3.21c-2.15,0-4.22-.8-5.8-2.27-1.53-1.4-2.41-3.37-2.42-5.44,.03-.69,.61-1.23,1.3-1.21h65.9c3.32,0,5.32,3.46,3.53,6.07Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 857.97,
    cy: 172.09,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M956.93,155.86v28.68c0,2.73-2.32,4.99-5.15,4.99h-67.79c-1.2,.02-2.2-.94-2.22-2.14v-1.01c0-6.21,4.39-11.47,10.33-13.02v-17.5c0-2.73,2.31-4.99,5.15-4.99h54.56c2.8,0,5.12,2.24,5.12,4.99Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 664.7,
    cy: 220.65,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M763.66,204.43v28.68c0,2.73-2.31,4.99-5.15,4.99h-67.79c-1.2,.02-2.2-.94-2.22-2.14h0v-1c0-6.21,4.39-11.48,10.33-13.02v-17.5c0-2.73,2.32-4.99,5.15-4.99h54.55c2.82,0,5.13,2.24,5.13,4.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M813.59,220.68c0,9.6-7.87,17.41-17.53,17.41s-17.53-7.79-17.53-17.41,7.87-17.41,17.53-17.41,17.53,7.81,17.53,17.41Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 838.06,
    cy: 234.24,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 866.54,
    cy: 234.24,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M890.77,205.33l-16.17,20.33c-.81,1.14-2.12,1.81-3.52,1.8h-35.42c-2.32,0-4.2-1.76-4.2-3.94v-15.36h-3.21c-2.15,0-4.21-.8-5.79-2.26-1.53-1.4-2.41-3.38-2.42-5.45,.03-.69,.61-1.23,1.3-1.21h65.9c3.32,.02,5.32,3.47,3.53,6.08Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 923.84,
    cy: 220.65,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 644.79,
    cy: 282.8,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 673.27,
    cy: 282.8,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M697.51,253.89l-16.17,20.33c-.8,1.15-2.12,1.83-3.52,1.82h-35.41c-2.32,0-4.19-1.76-4.19-3.94v-15.37h-3.22c-2.15,0-4.22-.8-5.8-2.26-1.53-1.4-2.41-3.38-2.42-5.45,.03-.69,.61-1.23,1.3-1.21h65.91c3.32,.02,5.32,3.47,3.53,6.08Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 730.58,
    cy: 269.21,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M829.54,253v28.68c0,2.73-2.32,4.99-5.15,4.99h-67.79c-1.2,.02-2.2-.94-2.22-2.14v-1.01c0-6.21,4.39-11.47,10.33-13.02v-17.5c0-2.73,2.31-4.99,5.15-4.99h54.55c2.81,0,5.13,2.24,5.13,4.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M879.46,269.25c0,9.6-7.87,17.41-17.53,17.41s-17.53-7.79-17.53-17.41,7.87-17.41,17.53-17.41,17.53,7.81,17.53,17.41Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 903.94,
    cy: 282.8,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 932.42,
    cy: 282.8,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M956.65,253.89l-16.17,20.33c-.8,1.15-2.12,1.83-3.52,1.82h-35.42c-2.32,0-4.19-1.76-4.19-3.94v-15.37h-3.21c-2.15,0-4.22-.8-5.8-2.26-1.53-1.4-2.41-3.38-2.42-5.45,.03-.69,.61-1.23,1.3-1.21h65.9c3.33,.02,5.32,3.47,3.53,6.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M636.27,301.56v28.68c0,2.73-2.31,4.99-5.15,4.99h-67.79c-1.2,.02-2.19-.94-2.22-2.14v-1c0-6.21,4.39-11.48,10.33-13.02v-17.5c0-2.73,2.32-4.99,5.15-4.99h54.55c2.82,0,5.13,2.24,5.13,4.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M686.2,317.82c0,9.6-7.87,17.41-17.53,17.41s-17.53-7.79-17.53-17.41,7.87-17.41,17.53-17.41,17.53,7.81,17.53,17.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M763.39,302.46l-16.17,20.33c-.8,1.15-2.12,1.83-3.52,1.82h-35.41c-2.32,0-4.19-1.76-4.19-3.94v-15.37h-3.22c-2.15,0-4.23-.81-5.8-2.27-1.53-1.4-2.41-3.37-2.42-5.44,.03-.69,.61-1.23,1.3-1.21h65.9c3.32,.02,5.32,3.46,3.53,6.08Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 796.45,
    cy: 317.78,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M895.41,301.56v28.68c0,2.73-2.32,4.99-5.15,4.99h-67.79c-1.2,.02-2.2-.94-2.22-2.14v-1c0-6.21,4.39-11.48,10.33-13.02v-17.5c0-2.73,2.31-4.99,5.15-4.99h54.55c2.81,0,5.13,2.24,5.13,4.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M945.34,317.82c0,9.6-7.87,17.41-17.53,17.41s-17.53-7.79-17.53-17.41,7.87-17.41,17.53-17.41,17.53,7.81,17.53,17.41Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 920.04,
    cy: 26.47,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1019.01,10.25v28.68c0,2.73-2.32,4.99-5.15,4.99h-67.79c-1.2,.02-2.2-.94-2.22-2.14v-1c0-6.21,4.39-11.47,10.33-13.02V10.25c0-2.73,2.32-4.99,5.15-4.99h54.55c2.82,0,5.13,2.23,5.13,4.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1068.93,26.51c0,9.6-7.87,17.41-17.53,17.41s-17.53-7.79-17.53-17.41,7.87-17.41,17.53-17.41,17.53,7.81,17.53,17.41Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1093.4,
    cy: 40.06,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1121.88,
    cy: 40.06,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1146.12,11.15l-16.17,20.33c-.8,1.15-2.12,1.83-3.52,1.82h-35.42c-2.32,0-4.19-1.76-4.19-3.94V13.99h-3.21c-2.15,0-4.22-.8-5.8-2.26-1.53-1.4-2.41-3.36-2.42-5.43,.03-.69,.61-1.23,1.3-1.21h65.9c3.32-.02,5.32,3.44,3.53,6.06Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1179.19,
    cy: 26.47,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 900.14,
    cy: 88.63,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 928.62,
    cy: 88.63,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M952.85,59.71l-16.17,20.34c-.81,1.14-2.12,1.81-3.52,1.8h-35.42c-2.32,0-4.19-1.76-4.19-3.94v-15.35h-3.21c-2.15,0-4.22-.8-5.8-2.26-1.53-1.4-2.41-3.37-2.42-5.44,.03-.69,.61-1.23,1.3-1.21h65.9c3.32,0,5.32,3.45,3.53,6.07Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 985.92,
    cy: 75.04,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1084.88,58.82v28.68c0,2.73-2.31,4.99-5.15,4.99h-67.79c-1.2,.02-2.19-.94-2.22-2.14v-1.01c0-6.21,4.39-11.47,10.33-13.02v-17.5c0-2.73,2.32-4.99,5.15-4.99h54.56c2.79-.02,5.07,2.2,5.12,4.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1134.81,75.07c0,9.6-7.87,17.41-17.53,17.41s-17.52-7.79-17.52-17.41,7.87-17.41,17.53-17.41,17.52,7.81,17.52,17.41Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1159.28,
    cy: 88.63,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1187.76,
    cy: 88.63,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1211.99,59.71l-16.17,20.34c-.81,1.14-2.12,1.81-3.52,1.8h-35.42c-2.32,0-4.19-1.76-4.19-3.94v-15.35h-3.21c-2.15,0-4.22-.8-5.8-2.26-1.53-1.4-2.41-3.37-2.42-5.44,.03-.69,.61-1.23,1.3-1.21h65.9c3.33,0,5.33,3.45,3.53,6.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M941.54,123.64c0,9.6-7.87,17.41-17.53,17.41s-17.53-7.79-17.53-17.41,7.87-17.4,17.53-17.4,17.53,7.8,17.53,17.4Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 966.02,
    cy: 137.19,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 994.49,
    cy: 137.19,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1018.73,108.28l-16.17,20.33c-.81,1.14-2.12,1.82-3.52,1.8h-35.42c-2.32,0-4.19-1.76-4.19-3.94v-15.36h-3.21c-2.15,0-4.22-.8-5.79-2.26-1.53-1.4-2.41-3.38-2.42-5.45,.03-.69,.61-1.23,1.3-1.21h65.9c3.33,.02,5.32,3.47,3.53,6.08Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1051.8,
    cy: 123.61,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1150.76,107.38v28.68c0,2.73-2.32,4.99-5.15,4.99h-67.79c-1.2,.02-2.2-.94-2.22-2.14v-1c0-6.21,4.39-11.48,10.33-13.02v-17.5c0-2.73,2.32-4.99,5.15-4.99h54.55c2.81,0,5.13,2.24,5.13,4.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1200.68,123.64c0,9.6-7.87,17.41-17.53,17.41s-17.53-7.79-17.53-17.41,7.87-17.41,17.53-17.41,17.53,7.81,17.53,17.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M957.49,155.95v28.68c0,2.73-2.31,4.99-5.15,4.99h-67.79c-1.2,.02-2.2-.94-2.22-2.14v-1.01c0-6.21,4.39-11.47,10.33-13.02v-17.5c0-2.73,2.32-4.99,5.15-4.99h54.55c2.79-.03,5.08,2.2,5.13,4.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1007.42,172.21c0,9.6-7.87,17.41-17.53,17.41s-17.53-7.79-17.53-17.41,7.87-17.41,17.53-17.41,17.53,7.81,17.53,17.41Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1031.89,
    cy: 185.76,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1060.37,
    cy: 185.76,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1084.61,156.85l-16.17,20.33c-.81,1.14-2.12,1.81-3.52,1.8h-35.42c-2.32,0-4.19-1.76-4.19-3.94v-15.35h-3.21c-2.15,0-4.22-.8-5.8-2.27-1.53-1.4-2.41-3.37-2.42-5.44,.03-.69,.61-1.23,1.3-1.21h65.9c3.32,0,5.32,3.46,3.53,6.07Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1117.67,
    cy: 172.17,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1216.63,155.95v28.68c0,2.73-2.32,4.99-5.15,4.99h-67.79c-1.2,.02-2.2-.94-2.22-2.14v-1.01c0-6.21,4.39-11.47,10.33-13.02v-17.5c0-2.73,2.31-4.99,5.15-4.99h54.56c2.8,0,5.12,2.24,5.12,4.99Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 924.41,
    cy: 220.74,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1023.37,204.51v28.68c0,2.73-2.31,4.99-5.15,4.99h-67.79c-1.2,.02-2.2-.94-2.22-2.14h0v-1c0-6.21,4.39-11.48,10.33-13.02v-17.5c0-2.73,2.32-4.99,5.15-4.99h54.55c2.82,0,5.13,2.24,5.13,4.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1073.29,220.77c0,9.6-7.87,17.41-17.53,17.41s-17.53-7.79-17.53-17.41,7.87-17.41,17.53-17.41,17.53,7.81,17.53,17.41Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1097.77,
    cy: 234.32,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1126.25,
    cy: 234.32,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1150.48,205.41l-16.17,20.33c-.81,1.14-2.12,1.81-3.52,1.8h-35.42c-2.32,0-4.2-1.76-4.2-3.94v-15.36h-3.21c-2.15,0-4.21-.8-5.79-2.26-1.53-1.4-2.41-3.38-2.42-5.45,.03-.69,.61-1.23,1.3-1.21h65.9c3.32,.02,5.32,3.47,3.53,6.08Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1183.55,
    cy: 220.74,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 904.5,
    cy: 282.89,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 932.98,
    cy: 282.89,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M957.22,253.98l-16.17,20.33c-.8,1.15-2.12,1.83-3.52,1.82h-35.41c-2.32,0-4.19-1.76-4.19-3.94v-15.37h-3.22c-2.15,0-4.22-.8-5.8-2.26-1.53-1.4-2.41-3.38-2.42-5.45,.03-.69,.61-1.23,1.3-1.21h65.91c3.32,.02,5.32,3.47,3.53,6.08Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 990.28,
    cy: 269.3,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1089.25,253.08v28.68c0,2.73-2.32,4.99-5.15,4.99h-67.79c-1.2,.02-2.2-.94-2.22-2.14v-1.01c0-6.21,4.39-11.47,10.33-13.02v-17.5c0-2.73,2.31-4.99,5.15-4.99h54.55c2.81,0,5.13,2.24,5.13,4.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1139.17,269.34c0,9.6-7.87,17.41-17.53,17.41s-17.53-7.79-17.53-17.41,7.87-17.41,17.53-17.41,17.53,7.81,17.53,17.41Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1163.65,
    cy: 282.89,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1192.12,
    cy: 282.89,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1216.36,253.98l-16.17,20.33c-.8,1.15-2.12,1.83-3.52,1.82h-35.42c-2.32,0-4.19-1.76-4.19-3.94v-15.37h-3.21c-2.15,0-4.22-.8-5.8-2.26-1.53-1.4-2.41-3.38-2.42-5.45,.03-.69,.61-1.23,1.3-1.21h65.9c3.33,.02,5.32,3.47,3.53,6.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M895.98,301.65v28.68c0,2.73-2.31,4.99-5.15,4.99h-67.79c-1.2,.02-2.19-.94-2.22-2.14v-1c0-6.21,4.39-11.48,10.33-13.02v-17.5c0-2.73,2.32-4.99,5.15-4.99h54.55c2.82,0,5.13,2.24,5.13,4.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M945.9,317.9c0,9.6-7.87,17.41-17.53,17.41s-17.53-7.79-17.53-17.41,7.87-17.41,17.53-17.41,17.53,7.81,17.53,17.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1023.09,302.55l-16.17,20.33c-.8,1.15-2.12,1.83-3.52,1.82h-35.41c-2.32,0-4.19-1.76-4.19-3.94v-15.37h-3.22c-2.15,0-4.23-.81-5.8-2.27-1.53-1.4-2.41-3.37-2.42-5.44,.03-.69,.61-1.23,1.3-1.21h65.9c3.32,.02,5.32,3.46,3.53,6.08Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1056.16,
    cy: 317.87,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1155.12,301.65v28.68c0,2.73-2.32,4.99-5.15,4.99h-67.79c-1.2,.02-2.2-.94-2.22-2.14v-1c0-6.21,4.39-11.48,10.33-13.02v-17.5c0-2.73,2.31-4.99,5.15-4.99h54.55c2.81,0,5.13,2.24,5.13,4.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1205.05,317.9c0,9.6-7.87,17.41-17.53,17.41s-17.53-7.79-17.53-17.41,7.87-17.41,17.53-17.41,17.53,7.81,17.53,17.41Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1179.06,
    cy: 26.47,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1278.02,10.25v28.68c0,2.73-2.32,4.99-5.15,4.99h-67.79c-1.2,.02-2.2-.94-2.22-2.14v-1c0-6.21,4.39-11.47,10.33-13.02V10.25c0-2.73,2.32-4.99,5.15-4.99h54.55c2.82,0,5.13,2.23,5.13,4.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1327.95,26.51c0,9.6-7.87,17.41-17.53,17.41s-17.53-7.79-17.53-17.41,7.87-17.41,17.53-17.41,17.53,7.81,17.53,17.41Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1352.42,
    cy: 40.06,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1380.9,
    cy: 40.06,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1405.14,11.15l-16.17,20.33c-.8,1.15-2.12,1.83-3.52,1.82h-35.42c-2.32,0-4.19-1.76-4.19-3.94V13.99h-3.21c-2.15,0-4.22-.8-5.8-2.26-1.53-1.4-2.41-3.36-2.42-5.43,.03-.69,.61-1.23,1.3-1.21h65.9c3.32-.02,5.32,3.44,3.53,6.06Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1438.2,
    cy: 26.47,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1159.16,
    cy: 88.63,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1187.64,
    cy: 88.63,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1211.87,59.71l-16.17,20.34c-.81,1.14-2.12,1.81-3.52,1.8h-35.42c-2.32,0-4.19-1.76-4.19-3.94v-15.35h-3.21c-2.15,0-4.22-.8-5.8-2.26-1.53-1.4-2.41-3.37-2.42-5.44,.03-.69,.61-1.23,1.3-1.21h65.9c3.32,0,5.32,3.45,3.53,6.07Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1244.94,
    cy: 75.04,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1343.9,58.82v28.68c0,2.73-2.31,4.99-5.15,4.99h-67.79c-1.2,.02-2.19-.94-2.22-2.14v-1.01c0-6.21,4.39-11.47,10.33-13.02v-17.5c0-2.73,2.32-4.99,5.15-4.99h54.56c2.79-.02,5.07,2.2,5.12,4.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1393.82,75.07c0,9.6-7.87,17.41-17.53,17.41s-17.52-7.79-17.52-17.41,7.87-17.41,17.53-17.41,17.52,7.81,17.52,17.41Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1418.3,
    cy: 88.63,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1446.78,
    cy: 88.63,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1471.01,59.71l-16.17,20.34c-.81,1.14-2.12,1.81-3.52,1.8h-35.42c-2.32,0-4.19-1.76-4.19-3.94v-15.35h-3.21c-2.15,0-4.22-.8-5.8-2.26-1.53-1.4-2.41-3.37-2.42-5.44,.03-.69,.61-1.23,1.3-1.21h65.9c3.33,0,5.33,3.45,3.53,6.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1200.56,123.64c0,9.6-7.87,17.41-17.53,17.41s-17.53-7.79-17.53-17.41,7.87-17.4,17.53-17.4,17.53,7.8,17.53,17.4Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1225.04,
    cy: 137.19,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1253.51,
    cy: 137.19,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1277.75,108.28l-16.17,20.33c-.81,1.14-2.12,1.82-3.52,1.8h-35.42c-2.32,0-4.19-1.76-4.19-3.94v-15.36h-3.21c-2.15,0-4.22-.8-5.79-2.26-1.53-1.4-2.41-3.38-2.42-5.45,.03-.69,.61-1.23,1.3-1.21h65.9c3.33,.02,5.32,3.47,3.53,6.08Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1310.82,
    cy: 123.61,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1409.78,107.38v28.68c0,2.73-2.32,4.99-5.15,4.99h-67.79c-1.2,.02-2.2-.94-2.22-2.14v-1c0-6.21,4.39-11.48,10.33-13.02v-17.5c0-2.73,2.32-4.99,5.15-4.99h54.55c2.81,0,5.13,2.24,5.13,4.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1459.7,123.64c0,9.6-7.87,17.41-17.53,17.41s-17.53-7.79-17.53-17.41,7.87-17.41,17.53-17.41,17.53,7.81,17.53,17.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1216.51,155.95v28.68c0,2.73-2.31,4.99-5.15,4.99h-67.79c-1.2,.02-2.2-.94-2.22-2.14v-1.01c0-6.21,4.39-11.47,10.33-13.02v-17.5c0-2.73,2.32-4.99,5.15-4.99h54.55c2.79-.03,5.08,2.2,5.13,4.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1266.43,172.21c0,9.6-7.87,17.41-17.53,17.41s-17.53-7.79-17.53-17.41,7.87-17.41,17.53-17.41,17.53,7.81,17.53,17.41Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1290.91,
    cy: 185.76,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1319.39,
    cy: 185.76,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1343.63,156.85l-16.17,20.33c-.81,1.14-2.12,1.81-3.52,1.8h-35.42c-2.32,0-4.19-1.76-4.19-3.94v-15.35h-3.21c-2.15,0-4.22-.8-5.8-2.27-1.53-1.4-2.41-3.37-2.42-5.44,.03-.69,.61-1.23,1.3-1.21h65.9c3.32,0,5.32,3.46,3.53,6.07Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1376.69,
    cy: 172.17,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1475.65,155.95v28.68c0,2.73-2.32,4.99-5.15,4.99h-67.79c-1.2,.02-2.2-.94-2.22-2.14v-1.01c0-6.21,4.39-11.47,10.33-13.02v-17.5c0-2.73,2.31-4.99,5.15-4.99h54.56c2.8,0,5.12,2.24,5.12,4.99Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1183.43,
    cy: 220.74,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1282.39,204.51v28.68c0,2.73-2.31,4.99-5.15,4.99h-67.79c-1.2,.02-2.2-.94-2.22-2.14h0v-1c0-6.21,4.39-11.48,10.33-13.02v-17.5c0-2.73,2.32-4.99,5.15-4.99h54.55c2.82,0,5.13,2.24,5.13,4.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1332.31,220.77c0,9.6-7.87,17.41-17.53,17.41s-17.53-7.79-17.53-17.41,7.87-17.41,17.53-17.41,17.53,7.81,17.53,17.41Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1356.79,
    cy: 234.32,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1385.26,
    cy: 234.32,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1409.5,205.41l-16.17,20.33c-.81,1.14-2.12,1.81-3.52,1.8h-35.42c-2.32,0-4.2-1.76-4.2-3.94v-15.36h-3.21c-2.15,0-4.21-.8-5.79-2.26-1.53-1.4-2.41-3.38-2.42-5.45,.03-.69,.61-1.23,1.3-1.21h65.9c3.32,.02,5.32,3.47,3.53,6.08Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1442.57,
    cy: 220.74,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1163.52,
    cy: 282.89,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1192,
    cy: 282.89,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1216.23,253.98l-16.17,20.33c-.8,1.15-2.12,1.83-3.52,1.82h-35.41c-2.32,0-4.19-1.76-4.19-3.94v-15.37h-3.22c-2.15,0-4.22-.8-5.8-2.26-1.53-1.4-2.41-3.38-2.42-5.45,.03-.69,.61-1.23,1.3-1.21h65.91c3.32,.02,5.32,3.47,3.53,6.08Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1249.3,
    cy: 269.3,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1348.26,253.08v28.68c0,2.73-2.32,4.99-5.15,4.99h-67.79c-1.2,.02-2.2-.94-2.22-2.14v-1.01c0-6.21,4.39-11.47,10.33-13.02v-17.5c0-2.73,2.31-4.99,5.15-4.99h54.55c2.81,0,5.13,2.24,5.13,4.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1398.19,269.34c0,9.6-7.87,17.41-17.53,17.41s-17.53-7.79-17.53-17.41,7.87-17.41,17.53-17.41,17.53,7.81,17.53,17.41Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1422.66,
    cy: 282.89,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1451.14,
    cy: 282.89,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1475.38,253.98l-16.17,20.33c-.8,1.15-2.12,1.83-3.52,1.82h-35.42c-2.32,0-4.19-1.76-4.19-3.94v-15.37h-3.21c-2.15,0-4.22-.8-5.8-2.26-1.53-1.4-2.41-3.38-2.42-5.45,.03-.69,.61-1.23,1.3-1.21h65.9c3.33,.02,5.32,3.47,3.53,6.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1155,301.65v28.68c0,2.73-2.31,4.99-5.15,4.99h-67.79c-1.2,.02-2.19-.94-2.22-2.14v-1c0-6.21,4.39-11.48,10.33-13.02v-17.5c0-2.73,2.32-4.99,5.15-4.99h54.55c2.82,0,5.13,2.24,5.13,4.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1204.92,317.9c0,9.6-7.87,17.41-17.53,17.41s-17.53-7.79-17.53-17.41,7.87-17.41,17.53-17.41,17.53,7.81,17.53,17.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1282.11,302.55l-16.17,20.33c-.8,1.15-2.12,1.83-3.52,1.82h-35.41c-2.32,0-4.19-1.76-4.19-3.94v-15.37h-3.22c-2.15,0-4.23-.81-5.8-2.27-1.53-1.4-2.41-3.37-2.42-5.44,.03-.69,.61-1.23,1.3-1.21h65.9c3.32,.02,5.32,3.46,3.53,6.08Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1315.18,
    cy: 317.87,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1414.14,301.65v28.68c0,2.73-2.32,4.99-5.15,4.99h-67.79c-1.2,.02-2.2-.94-2.22-2.14v-1c0-6.21,4.39-11.48,10.33-13.02v-17.5c0-2.73,2.31-4.99,5.15-4.99h54.55c2.81,0,5.13,2.24,5.13,4.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1464.06,317.9c0,9.6-7.87,17.41-17.53,17.41s-17.53-7.79-17.53-17.41,7.87-17.41,17.53-17.41,17.53,7.81,17.53,17.41Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1438.08,
    cy: 26.47,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1537.04,10.25v28.68c0,2.73-2.32,4.99-5.15,4.99h-67.79c-1.2,.02-2.2-.94-2.22-2.14v-1c0-6.21,4.39-11.47,10.33-13.02V10.25c0-2.73,2.32-4.99,5.15-4.99h54.55c2.82,0,5.13,2.23,5.13,4.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1586.97,26.51c0,9.6-7.87,17.41-17.53,17.41s-17.53-7.79-17.53-17.41,7.87-17.41,17.53-17.41,17.53,7.81,17.53,17.41Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1611.44,
    cy: 40.06,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1639.92,
    cy: 40.06,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1664.15,11.15l-16.17,20.33c-.8,1.15-2.12,1.83-3.52,1.82h-35.42c-2.32,0-4.19-1.76-4.19-3.94V13.99h-3.21c-2.15,0-4.22-.8-5.8-2.26-1.53-1.4-2.41-3.36-2.42-5.43,.03-.69,.61-1.23,1.3-1.21h65.9c3.32-.02,5.32,3.44,3.53,6.06Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1697.22,
    cy: 26.47,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1418.18,
    cy: 88.63,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1446.65,
    cy: 88.63,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1470.89,59.71l-16.17,20.34c-.81,1.14-2.12,1.81-3.52,1.8h-35.42c-2.32,0-4.19-1.76-4.19-3.94v-15.35h-3.21c-2.15,0-4.22-.8-5.8-2.26-1.53-1.4-2.41-3.37-2.42-5.44,.03-.69,.61-1.23,1.3-1.21h65.9c3.32,0,5.32,3.45,3.53,6.07Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1503.96,
    cy: 75.04,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1602.92,58.82v28.68c0,2.73-2.31,4.99-5.15,4.99h-67.79c-1.2,.02-2.19-.94-2.22-2.14v-1.01c0-6.21,4.39-11.47,10.33-13.02v-17.5c0-2.73,2.32-4.99,5.15-4.99h54.56c2.79-.02,5.07,2.2,5.12,4.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1652.84,75.07c0,9.6-7.87,17.41-17.53,17.41s-17.52-7.79-17.52-17.41,7.87-17.41,17.53-17.41,17.52,7.81,17.52,17.41Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1677.32,
    cy: 88.63,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1705.79,
    cy: 88.63,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1730.03,59.71l-16.17,20.34c-.81,1.14-2.12,1.81-3.52,1.8h-35.42c-2.32,0-4.19-1.76-4.19-3.94v-15.35h-3.21c-2.15,0-4.22-.8-5.8-2.26-1.53-1.4-2.41-3.37-2.42-5.44,.03-.69,.61-1.23,1.3-1.21h65.9c3.33,0,5.33,3.45,3.53,6.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1459.58,123.64c0,9.6-7.87,17.41-17.53,17.41s-17.53-7.79-17.53-17.41,7.87-17.4,17.53-17.4,17.53,7.8,17.53,17.4Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1484.05,
    cy: 137.19,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1512.53,
    cy: 137.19,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1536.76,108.28l-16.17,20.33c-.81,1.14-2.12,1.82-3.52,1.8h-35.42c-2.32,0-4.19-1.76-4.19-3.94v-15.36h-3.21c-2.15,0-4.22-.8-5.79-2.26-1.53-1.4-2.41-3.38-2.42-5.45,.03-.69,.61-1.23,1.3-1.21h65.9c3.33,.02,5.32,3.47,3.53,6.08Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1569.83,
    cy: 123.61,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1668.79,107.38v28.68c0,2.73-2.32,4.99-5.15,4.99h-67.79c-1.2,.02-2.2-.94-2.22-2.14v-1c0-6.21,4.39-11.48,10.33-13.02v-17.5c0-2.73,2.32-4.99,5.15-4.99h54.55c2.81,0,5.13,2.24,5.13,4.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1718.72,123.64c0,9.6-7.87,17.41-17.53,17.41s-17.53-7.79-17.53-17.41,7.87-17.41,17.53-17.41,17.53,7.81,17.53,17.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1475.53,155.95v28.68c0,2.73-2.31,4.99-5.15,4.99h-67.79c-1.2,.02-2.2-.94-2.22-2.14v-1.01c0-6.21,4.39-11.47,10.33-13.02v-17.5c0-2.73,2.32-4.99,5.15-4.99h54.55c2.79-.03,5.08,2.2,5.13,4.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1525.45,172.21c0,9.6-7.87,17.41-17.53,17.41s-17.53-7.79-17.53-17.41,7.87-17.41,17.53-17.41,17.53,7.81,17.53,17.41Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1549.93,
    cy: 185.76,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1578.41,
    cy: 185.76,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1602.64,156.85l-16.17,20.33c-.81,1.14-2.12,1.81-3.52,1.8h-35.42c-2.32,0-4.19-1.76-4.19-3.94v-15.35h-3.21c-2.15,0-4.22-.8-5.8-2.27-1.53-1.4-2.41-3.37-2.42-5.44,.03-.69,.61-1.23,1.3-1.21h65.9c3.32,0,5.32,3.46,3.53,6.07Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1635.71,
    cy: 172.17,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1734.67,155.95v28.68c0,2.73-2.32,4.99-5.15,4.99h-67.79c-1.2,.02-2.2-.94-2.22-2.14v-1.01c0-6.21,4.39-11.47,10.33-13.02v-17.5c0-2.73,2.31-4.99,5.15-4.99h54.56c2.8,0,5.12,2.24,5.12,4.99Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1442.44,
    cy: 220.74,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1541.4,204.51v28.68c0,2.73-2.31,4.99-5.15,4.99h-67.79c-1.2,.02-2.2-.94-2.22-2.14h0v-1c0-6.21,4.39-11.48,10.33-13.02v-17.5c0-2.73,2.32-4.99,5.15-4.99h54.55c2.82,0,5.13,2.24,5.13,4.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1591.33,220.77c0,9.6-7.87,17.41-17.53,17.41s-17.53-7.79-17.53-17.41,7.87-17.41,17.53-17.41,17.53,7.81,17.53,17.41Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1615.8,
    cy: 234.32,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1644.28,
    cy: 234.32,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1668.52,205.41l-16.17,20.33c-.81,1.14-2.12,1.81-3.52,1.8h-35.42c-2.32,0-4.2-1.76-4.2-3.94v-15.36h-3.21c-2.15,0-4.21-.8-5.79-2.26-1.53-1.4-2.41-3.38-2.42-5.45,.03-.69,.61-1.23,1.3-1.21h65.9c3.32,.02,5.32,3.47,3.53,6.08Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1701.58,
    cy: 220.74,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1422.54,
    cy: 282.89,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1451.02,
    cy: 282.89,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1475.25,253.98l-16.17,20.33c-.8,1.15-2.12,1.83-3.52,1.82h-35.41c-2.32,0-4.19-1.76-4.19-3.94v-15.37h-3.22c-2.15,0-4.22-.8-5.8-2.26-1.53-1.4-2.41-3.38-2.42-5.45,.03-.69,.61-1.23,1.3-1.21h65.91c3.32,.02,5.32,3.47,3.53,6.08Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1508.32,
    cy: 269.3,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1607.28,253.08v28.68c0,2.73-2.32,4.99-5.15,4.99h-67.79c-1.2,.02-2.2-.94-2.22-2.14v-1.01c0-6.21,4.39-11.47,10.33-13.02v-17.5c0-2.73,2.31-4.99,5.15-4.99h54.55c2.81,0,5.13,2.24,5.13,4.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1657.21,269.34c0,9.6-7.87,17.41-17.53,17.41s-17.53-7.79-17.53-17.41,7.87-17.41,17.53-17.41,17.53,7.81,17.53,17.41Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1681.68,
    cy: 282.89,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1710.16,
    cy: 282.89,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1734.4,253.98l-16.17,20.33c-.8,1.15-2.12,1.83-3.52,1.82h-35.42c-2.32,0-4.19-1.76-4.19-3.94v-15.37h-3.21c-2.15,0-4.22-.8-5.8-2.26-1.53-1.4-2.41-3.38-2.42-5.45,.03-.69,.61-1.23,1.3-1.21h65.9c3.33,.02,5.32,3.47,3.53,6.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1414.01,301.65v28.68c0,2.73-2.31,4.99-5.15,4.99h-67.79c-1.2,.02-2.19-.94-2.22-2.14v-1c0-6.21,4.39-11.48,10.33-13.02v-17.5c0-2.73,2.32-4.99,5.15-4.99h54.55c2.82,0,5.13,2.24,5.13,4.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1463.94,317.9c0,9.6-7.87,17.41-17.53,17.41s-17.53-7.79-17.53-17.41,7.87-17.41,17.53-17.41,17.53,7.81,17.53,17.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1541.13,302.55l-16.17,20.33c-.8,1.15-2.12,1.83-3.52,1.82h-35.41c-2.32,0-4.19-1.76-4.19-3.94v-15.37h-3.22c-2.15,0-4.23-.81-5.8-2.27-1.53-1.4-2.41-3.37-2.42-5.44,.03-.69,.61-1.23,1.3-1.21h65.9c3.32,.02,5.32,3.46,3.53,6.08Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1574.19,
    cy: 317.87,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1673.16,301.65v28.68c0,2.73-2.32,4.99-5.15,4.99h-67.79c-1.2,.02-2.2-.94-2.22-2.14v-1c0-6.21,4.39-11.48,10.33-13.02v-17.5c0-2.73,2.31-4.99,5.15-4.99h54.55c2.81,0,5.13,2.24,5.13,4.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1723.08,317.9c0,9.6-7.87,17.41-17.53,17.41s-17.53-7.79-17.53-17.41,7.87-17.41,17.53-17.41,17.53,7.81,17.53,17.41Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1697.1,
    cy: 26.47,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1796.06,10.25v28.68c0,2.73-2.32,4.99-5.15,4.99h-67.79c-1.2,.02-2.2-.94-2.22-2.14v-1c0-6.21,4.39-11.47,10.33-13.02V10.25c0-2.73,2.32-4.99,5.15-4.99h54.55c2.82,0,5.13,2.23,5.13,4.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1845.99,26.51c0,9.6-7.87,17.41-17.53,17.41s-17.53-7.79-17.53-17.41,7.87-17.41,17.53-17.41,17.53,7.81,17.53,17.41Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1870.46,
    cy: 40.06,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1898.94,
    cy: 40.06,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1923.17,11.15l-16.17,20.33c-.8,1.15-2.12,1.83-3.52,1.82h-35.42c-2.32,0-4.19-1.76-4.19-3.94V13.99h-3.21c-2.15,0-4.22-.8-5.8-2.26-1.53-1.4-2.41-3.36-2.42-5.43,.03-.69,.61-1.23,1.3-1.21h65.9c3.32-.02,5.32,3.44,3.53,6.06Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1677.19,
    cy: 88.63,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1705.67,
    cy: 88.63,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1729.91,59.71l-16.17,20.34c-.81,1.14-2.12,1.81-3.52,1.8h-35.42c-2.32,0-4.19-1.76-4.19-3.94v-15.35h-3.21c-2.15,0-4.22-.8-5.8-2.26-1.53-1.4-2.41-3.37-2.42-5.44,.03-.69,.61-1.23,1.3-1.21h65.9c3.32,0,5.32,3.45,3.53,6.07Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1762.97,
    cy: 75.04,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1861.94,58.82v28.68c0,2.73-2.31,4.99-5.15,4.99h-67.79c-1.2,.02-2.19-.94-2.22-2.14v-1.01c0-6.21,4.39-11.47,10.33-13.02v-17.5c0-2.73,2.32-4.99,5.15-4.99h54.56c2.79-.02,5.07,2.2,5.12,4.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1911.86,75.07c0,9.6-7.87,17.41-17.53,17.41s-17.52-7.79-17.52-17.41,7.87-17.41,17.53-17.41,17.52,7.81,17.52,17.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1989.05,59.71l-16.17,20.34c-.81,1.14-2.12,1.81-3.52,1.8h-35.42c-2.32,0-4.19-1.76-4.19-3.94v-15.35h-3.21c-2.15,0-4.22-.8-5.8-2.26-1.53-1.4-2.41-3.37-2.42-5.44,.03-.69,.61-1.23,1.3-1.21h65.9c3.33,0,5.33,3.45,3.53,6.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1718.6,123.64c0,9.6-7.87,17.41-17.53,17.41s-17.53-7.79-17.53-17.41,7.87-17.4,17.53-17.4,17.53,7.8,17.53,17.4Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1743.07,
    cy: 137.19,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1771.55,
    cy: 137.19,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1795.78,108.28l-16.17,20.33c-.81,1.14-2.12,1.82-3.52,1.8h-35.42c-2.32,0-4.19-1.76-4.19-3.94v-15.36h-3.21c-2.15,0-4.22-.8-5.79-2.26-1.53-1.4-2.41-3.38-2.42-5.45,.03-.69,.61-1.23,1.3-1.21h65.9c3.33,.02,5.32,3.47,3.53,6.08Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1828.85,
    cy: 123.61,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1927.81,107.38v28.68c0,2.73-2.32,4.99-5.15,4.99h-67.79c-1.2,.02-2.2-.94-2.22-2.14v-1c0-6.21,4.39-11.48,10.33-13.02v-17.5c0-2.73,2.32-4.99,5.15-4.99h54.55c2.81,0,5.13,2.24,5.13,4.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1734.55,155.95v28.68c0,2.73-2.31,4.99-5.15,4.99h-67.79c-1.2,.02-2.2-.94-2.22-2.14v-1.01c0-6.21,4.39-11.47,10.33-13.02v-17.5c0-2.73,2.32-4.99,5.15-4.99h54.55c2.79-.03,5.08,2.2,5.13,4.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1784.47,172.21c0,9.6-7.87,17.41-17.53,17.41s-17.53-7.79-17.53-17.41,7.87-17.41,17.53-17.41,17.53,7.81,17.53,17.41Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1808.95,
    cy: 185.76,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1837.43,
    cy: 185.76,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1861.66,156.85l-16.17,20.33c-.81,1.14-2.12,1.81-3.52,1.8h-35.42c-2.32,0-4.19-1.76-4.19-3.94v-15.35h-3.21c-2.15,0-4.22-.8-5.8-2.27-1.53-1.4-2.41-3.37-2.42-5.44,.03-.69,.61-1.23,1.3-1.21h65.9c3.32,0,5.32,3.46,3.53,6.07Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1894.73,
    cy: 172.17,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1993.69,155.95v28.68c0,2.73-2.32,4.99-5.15,4.99h-67.79c-1.2,.02-2.2-.94-2.22-2.14v-1.01c0-6.21,4.39-11.47,10.33-13.02v-17.5c0-2.73,2.31-4.99,5.15-4.99h54.56c2.8,0,5.12,2.24,5.12,4.99Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1701.46,
    cy: 220.74,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1800.42,204.51v28.68c0,2.73-2.31,4.99-5.15,4.99h-67.79c-1.2,.02-2.2-.94-2.22-2.14h0v-1c0-6.21,4.39-11.48,10.33-13.02v-17.5c0-2.73,2.32-4.99,5.15-4.99h54.55c2.82,0,5.13,2.24,5.13,4.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1850.35,220.77c0,9.6-7.87,17.41-17.53,17.41s-17.53-7.79-17.53-17.41,7.87-17.41,17.53-17.41,17.53,7.81,17.53,17.41Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1874.82,
    cy: 234.32,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1903.3,
    cy: 234.32,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1927.54,205.41l-16.17,20.33c-.81,1.14-2.12,1.81-3.52,1.8h-35.42c-2.32,0-4.2-1.76-4.2-3.94v-15.36h-3.21c-2.15,0-4.21-.8-5.79-2.26-1.53-1.4-2.41-3.38-2.42-5.45,.03-.69,.61-1.23,1.3-1.21h65.9c3.32,.02,5.32,3.47,3.53,6.08Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1681.56,
    cy: 282.89,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1710.04,
    cy: 282.89,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1734.27,253.98l-16.17,20.33c-.8,1.15-2.12,1.83-3.52,1.82h-35.41c-2.32,0-4.19-1.76-4.19-3.94v-15.37h-3.22c-2.15,0-4.22-.8-5.8-2.26-1.53-1.4-2.41-3.38-2.42-5.45,.03-.69,.61-1.23,1.3-1.21h65.91c3.32,.02,5.32,3.47,3.53,6.08Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1767.34,
    cy: 269.3,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1866.3,253.08v28.68c0,2.73-2.32,4.99-5.15,4.99h-67.79c-1.2,.02-2.2-.94-2.22-2.14v-1.01c0-6.21,4.39-11.47,10.33-13.02v-17.5c0-2.73,2.31-4.99,5.15-4.99h54.55c2.81,0,5.13,2.24,5.13,4.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1916.22,269.34c0,9.6-7.87,17.41-17.53,17.41s-17.53-7.79-17.53-17.41,7.87-17.41,17.53-17.41,17.53,7.81,17.53,17.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1673.03,301.65v28.68c0,2.73-2.31,4.99-5.15,4.99h-67.79c-1.2,.02-2.19-.94-2.22-2.14v-1c0-6.21,4.39-11.48,10.33-13.02v-17.5c0-2.73,2.32-4.99,5.15-4.99h54.55c2.82,0,5.13,2.24,5.13,4.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1722.96,317.9c0,9.6-7.87,17.41-17.53,17.41s-17.53-7.79-17.53-17.41,7.87-17.41,17.53-17.41,17.53,7.81,17.53,17.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1800.15,302.55l-16.17,20.33c-.8,1.15-2.12,1.83-3.52,1.82h-35.41c-2.32,0-4.19-1.76-4.19-3.94v-15.37h-3.22c-2.15,0-4.23-.81-5.8-2.27-1.53-1.4-2.41-3.37-2.42-5.44,.03-.69,.61-1.23,1.3-1.21h65.9c3.32,.02,5.32,3.46,3.53,6.08Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1833.21,
    cy: 317.87,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1932.18,301.65v28.68c0,2.73-2.32,4.99-5.15,4.99h-67.79c-1.2,.02-2.2-.94-2.22-2.14v-1c0-6.21,4.39-11.48,10.33-13.02v-17.5c0-2.73,2.31-4.99,5.15-4.99h54.55c2.81,0,5.13,2.24,5.13,4.99Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 19.38,
    cy: 317.27,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: -0.52,
    cy: 379.43,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 27.95,
    cy: 379.43,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M52.19,350.51l-16.17,20.34c-.81,1.14-2.12,1.81-3.52,1.8H-2.91c-2.32,0-4.19-1.76-4.19-3.94v-15.35h-3.21c-2.15,0-4.22-.8-5.8-2.26-1.53-1.4-2.41-3.37-2.42-5.44,.03-.69,.61-1.23,1.3-1.21H48.66c3.33,0,5.33,3.45,3.53,6.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M40.88,414.44c0,9.6-7.87,17.41-17.53,17.41s-17.53-7.79-17.53-17.41,7.87-17.41,17.53-17.41,17.53,7.81,17.53,17.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M56.83,446.75v28.68c0,2.73-2.32,4.99-5.15,4.99H-16.11c-1.2,.02-2.2-.94-2.22-2.14v-1.01c0-6.21,4.39-11.47,10.33-13.02v-17.5c0-2.73,2.31-4.99,5.15-4.99H51.71c2.8,0,5.12,2.24,5.12,4.99Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 23.74,
    cy: 511.54,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 3.84,
    cy: 573.69,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 32.32,
    cy: 573.69,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M56.56,544.78l-16.17,20.33c-.8,1.15-2.12,1.83-3.52,1.82H1.45c-2.32,0-4.19-1.76-4.19-3.94v-15.37h-3.21c-2.15,0-4.22-.8-5.8-2.26-1.53-1.4-2.41-3.38-2.42-5.45,.03-.69,.61-1.23,1.3-1.21H53.02c3.33,.02,5.32,3.47,3.53,6.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M45.24,608.7c0,9.6-7.87,17.41-17.53,17.41s-17.53-7.79-17.53-17.41,7.87-17.41,17.53-17.41,17.53,7.81,17.53,17.41Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 19.26,
    cy: 317.27,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M118.22,301.05v28.68c0,2.73-2.32,4.99-5.15,4.99H45.28c-1.2,.02-2.2-.94-2.22-2.14v-1c0-6.21,4.39-11.47,10.33-13.02v-17.5c0-2.73,2.32-4.99,5.15-4.99h54.55c2.82,0,5.13,2.23,5.13,4.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M168.15,317.31c0,9.6-7.87,17.41-17.53,17.41s-17.53-7.79-17.53-17.41,7.87-17.41,17.53-17.41,17.53,7.81,17.53,17.41Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 192.62,
    cy: 330.86,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 221.1,
    cy: 330.86,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M245.33,301.95l-16.17,20.33c-.8,1.15-2.12,1.83-3.52,1.82h-35.42c-2.32,0-4.19-1.76-4.19-3.94v-15.37h-3.21c-2.15,0-4.22-.8-5.8-2.26-1.53-1.4-2.41-3.36-2.42-5.43,.03-.69,.61-1.23,1.3-1.21h65.9c3.32-.02,5.32,3.44,3.53,6.06Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 278.4,
    cy: 317.27,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: -0.65,
    cy: 379.43,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 27.83,
    cy: 379.43,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M52.07,350.51l-16.17,20.34c-.81,1.14-2.12,1.81-3.52,1.8H-3.04c-2.32,0-4.19-1.76-4.19-3.94v-15.35h-3.21c-2.15,0-4.22-.8-5.8-2.26-1.53-1.4-2.41-3.37-2.42-5.44,.03-.69,.61-1.23,1.3-1.21H48.54c3.32,0,5.32,3.45,3.53,6.07Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 85.13,
    cy: 365.84,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M184.1,349.62v28.68c0,2.73-2.31,4.99-5.15,4.99H111.16c-1.2,.02-2.19-.94-2.22-2.14v-1.01c0-6.21,4.39-11.47,10.33-13.02v-17.5c0-2.73,2.32-4.99,5.15-4.99h54.56c2.79-.02,5.07,2.2,5.12,4.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M234.02,365.87c0,9.6-7.87,17.41-17.53,17.41s-17.52-7.79-17.52-17.41,7.87-17.41,17.53-17.41,17.52,7.81,17.52,17.41Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 258.5,
    cy: 379.43,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 286.97,
    cy: 379.43,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M311.21,350.51l-16.17,20.34c-.81,1.14-2.12,1.81-3.52,1.8h-35.42c-2.32,0-4.19-1.76-4.19-3.94v-15.35h-3.21c-2.15,0-4.22-.8-5.8-2.26-1.53-1.4-2.41-3.37-2.42-5.44,.03-.69,.61-1.23,1.3-1.21h65.9c3.33,0,5.33,3.45,3.53,6.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M40.76,414.44c0,9.6-7.87,17.41-17.53,17.41s-17.53-7.79-17.53-17.41,7.87-17.4,17.53-17.4,17.53,7.8,17.53,17.4Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 65.23,
    cy: 427.99,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 93.71,
    cy: 427.99,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M117.94,399.08l-16.17,20.33c-.81,1.14-2.12,1.82-3.52,1.8H62.84c-2.32,0-4.19-1.76-4.19-3.94v-15.36h-3.21c-2.15,0-4.22-.8-5.79-2.26-1.53-1.4-2.41-3.38-2.42-5.45,.03-.69,.61-1.23,1.3-1.21H114.42c3.33,.02,5.32,3.47,3.53,6.08Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 151.01,
    cy: 414.41,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M249.97,398.18v28.68c0,2.73-2.32,4.99-5.15,4.99h-67.79c-1.2,.02-2.2-.94-2.22-2.14v-1c0-6.21,4.39-11.48,10.33-13.02v-17.5c0-2.73,2.32-4.99,5.15-4.99h54.55c2.81,0,5.13,2.24,5.13,4.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M299.9,414.44c0,9.6-7.87,17.41-17.53,17.41s-17.53-7.79-17.53-17.41,7.87-17.41,17.53-17.41,17.53,7.81,17.53,17.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M56.71,446.75v28.68c0,2.73-2.31,4.99-5.15,4.99H-16.23c-1.2,.02-2.2-.94-2.22-2.14v-1.01c0-6.21,4.39-11.47,10.33-13.02v-17.5c0-2.73,2.32-4.99,5.15-4.99H51.57c2.79-.03,5.08,2.2,5.13,4.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M106.63,463.01c0,9.6-7.87,17.41-17.53,17.41s-17.53-7.79-17.53-17.41,7.87-17.41,17.53-17.41,17.53,7.81,17.53,17.41Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 131.11,
    cy: 476.56,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 159.59,
    cy: 476.56,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M183.82,447.65l-16.17,20.33c-.81,1.14-2.12,1.81-3.52,1.8h-35.42c-2.32,0-4.19-1.76-4.19-3.94v-15.35h-3.21c-2.15,0-4.22-.8-5.8-2.27-1.53-1.4-2.41-3.37-2.42-5.44,.03-.69,.61-1.23,1.3-1.21h65.9c3.32,0,5.32,3.46,3.53,6.07Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 216.89,
    cy: 462.97,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M315.85,446.75v28.68c0,2.73-2.32,4.99-5.15,4.99h-67.79c-1.2,.02-2.2-.94-2.22-2.14v-1.01c0-6.21,4.39-11.47,10.33-13.02v-17.5c0-2.73,2.31-4.99,5.15-4.99h54.56c2.8,0,5.12,2.24,5.12,4.99Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 23.62,
    cy: 511.54,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M122.58,495.31v28.68c0,2.73-2.31,4.99-5.15,4.99H49.65c-1.2,.02-2.2-.94-2.22-2.14h0v-1c0-6.21,4.39-11.48,10.33-13.02v-17.5c0-2.73,2.32-4.99,5.15-4.99h54.55c2.82,0,5.13,2.24,5.13,4.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M172.51,511.57c0,9.6-7.87,17.41-17.53,17.41s-17.53-7.79-17.53-17.41,7.87-17.41,17.53-17.41,17.53,7.81,17.53,17.41Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 196.98,
    cy: 525.12,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 225.46,
    cy: 525.12,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M249.7,496.21l-16.17,20.33c-.81,1.14-2.12,1.81-3.52,1.8h-35.42c-2.32,0-4.2-1.76-4.2-3.94v-15.36h-3.21c-2.15,0-4.21-.8-5.79-2.26-1.53-1.4-2.41-3.38-2.42-5.45,.03-.69,.61-1.23,1.3-1.21h65.9c3.32,.02,5.32,3.47,3.53,6.08Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 282.76,
    cy: 511.54,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 3.72,
    cy: 573.69,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 32.2,
    cy: 573.69,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M56.43,544.78l-16.17,20.33c-.8,1.15-2.12,1.83-3.52,1.82H1.33c-2.32,0-4.19-1.76-4.19-3.94v-15.37h-3.22c-2.15,0-4.22-.8-5.8-2.26-1.53-1.4-2.41-3.38-2.42-5.45,.03-.69,.61-1.23,1.3-1.21H52.9c3.32,.02,5.32,3.47,3.53,6.08Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 89.5,
    cy: 560.1,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M188.46,543.88v28.68c0,2.73-2.32,4.99-5.15,4.99H115.52c-1.2,.02-2.2-.94-2.22-2.14v-1.01c0-6.21,4.39-11.47,10.33-13.02v-17.5c0-2.73,2.31-4.99,5.15-4.99h54.55c2.81,0,5.13,2.24,5.13,4.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M238.38,560.14c0,9.6-7.87,17.41-17.53,17.41s-17.53-7.79-17.53-17.41,7.87-17.41,17.53-17.41,17.53,7.81,17.53,17.41Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 262.86,
    cy: 573.69,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 291.34,
    cy: 573.69,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M315.58,544.78l-16.17,20.33c-.8,1.15-2.12,1.83-3.52,1.82h-35.42c-2.32,0-4.19-1.76-4.19-3.94v-15.37h-3.21c-2.15,0-4.22-.8-5.8-2.26-1.53-1.4-2.41-3.38-2.42-5.45,.03-.69,.61-1.23,1.3-1.21h65.9c3.33,.02,5.32,3.47,3.53,6.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M45.12,608.7c0,9.6-7.87,17.41-17.53,17.41s-17.53-7.79-17.53-17.41,7.87-17.41,17.53-17.41,17.53,7.81,17.53,17.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M122.31,593.35l-16.17,20.33c-.8,1.15-2.12,1.83-3.52,1.82h-35.41c-2.32,0-4.19-1.76-4.19-3.94v-15.37h-3.22c-2.15,0-4.23-.81-5.8-2.27-1.53-1.4-2.41-3.37-2.42-5.44,.03-.69,.61-1.23,1.3-1.21H118.78c3.32,.02,5.32,3.46,3.53,6.08Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 155.37,
    cy: 608.67,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M254.34,592.45v28.68c0,2.73-2.32,4.99-5.15,4.99h-67.79c-1.2,.02-2.2-.94-2.22-2.14v-1c0-6.21,4.39-11.48,10.33-13.02v-17.5c0-2.73,2.31-4.99,5.15-4.99h54.55c2.81,0,5.13,2.24,5.13,4.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M304.26,608.7c0,9.6-7.87,17.41-17.53,17.41s-17.53-7.79-17.53-17.41,7.87-17.41,17.53-17.41,17.53,7.81,17.53,17.41Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 278.28,
    cy: 317.27,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M377.24,301.05v28.68c0,2.73-2.32,4.99-5.15,4.99h-67.79c-1.2,.02-2.2-.94-2.22-2.14v-1c0-6.21,4.39-11.47,10.33-13.02v-17.5c0-2.73,2.32-4.99,5.15-4.99h54.55c2.82,0,5.13,2.23,5.13,4.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M427.16,317.31c0,9.6-7.87,17.41-17.53,17.41s-17.53-7.79-17.53-17.41,7.87-17.41,17.53-17.41,17.53,7.81,17.53,17.41Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 451.64,
    cy: 330.86,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 480.12,
    cy: 330.86,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M504.35,301.95l-16.17,20.33c-.8,1.15-2.12,1.83-3.52,1.82h-35.42c-2.32,0-4.19-1.76-4.19-3.94v-15.37h-3.21c-2.15,0-4.22-.8-5.8-2.26-1.53-1.4-2.41-3.36-2.42-5.43,.03-.69,.61-1.23,1.3-1.21h65.9c3.32-.02,5.32,3.44,3.53,6.06Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 537.42,
    cy: 317.27,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 258.37,
    cy: 379.43,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 286.85,
    cy: 379.43,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M311.09,350.51l-16.17,20.34c-.81,1.14-2.12,1.81-3.52,1.8h-35.42c-2.32,0-4.19-1.76-4.19-3.94v-15.35h-3.21c-2.15,0-4.22-.8-5.8-2.26-1.53-1.4-2.41-3.37-2.42-5.44,.03-.69,.61-1.23,1.3-1.21h65.9c3.32,0,5.32,3.45,3.53,6.07Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 344.15,
    cy: 365.84,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M443.11,349.62v28.68c0,2.73-2.31,4.99-5.15,4.99h-67.79c-1.2,.02-2.19-.94-2.22-2.14v-1.01c0-6.21,4.39-11.47,10.33-13.02v-17.5c0-2.73,2.32-4.99,5.15-4.99h54.56c2.79-.02,5.07,2.2,5.12,4.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M493.04,365.87c0,9.6-7.87,17.41-17.53,17.41s-17.52-7.79-17.52-17.41,7.87-17.41,17.53-17.41,17.52,7.81,17.52,17.41Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 517.51,
    cy: 379.43,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 545.99,
    cy: 379.43,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M570.23,350.51l-16.17,20.34c-.81,1.14-2.12,1.81-3.52,1.8h-35.42c-2.32,0-4.19-1.76-4.19-3.94v-15.35h-3.21c-2.15,0-4.22-.8-5.8-2.26-1.53-1.4-2.41-3.37-2.42-5.44,.03-.69,.61-1.23,1.3-1.21h65.9c3.33,0,5.33,3.45,3.53,6.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M299.77,414.44c0,9.6-7.87,17.41-17.53,17.41s-17.53-7.79-17.53-17.41,7.87-17.4,17.53-17.4,17.53,7.8,17.53,17.4Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 324.25,
    cy: 427.99,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 352.73,
    cy: 427.99,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M376.96,399.08l-16.17,20.33c-.81,1.14-2.12,1.82-3.52,1.8h-35.42c-2.32,0-4.19-1.76-4.19-3.94v-15.36h-3.21c-2.15,0-4.22-.8-5.79-2.26-1.53-1.4-2.41-3.38-2.42-5.45,.03-.69,.61-1.23,1.3-1.21h65.9c3.33,.02,5.32,3.47,3.53,6.08Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 410.03,
    cy: 414.41,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M508.99,398.18v28.68c0,2.73-2.32,4.99-5.15,4.99h-67.79c-1.2,.02-2.2-.94-2.22-2.14v-1c0-6.21,4.39-11.48,10.33-13.02v-17.5c0-2.73,2.32-4.99,5.15-4.99h54.55c2.81,0,5.13,2.24,5.13,4.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M558.91,414.44c0,9.6-7.87,17.41-17.53,17.41s-17.53-7.79-17.53-17.41,7.87-17.41,17.53-17.41,17.53,7.81,17.53,17.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M315.72,446.75v28.68c0,2.73-2.31,4.99-5.15,4.99h-67.79c-1.2,.02-2.2-.94-2.22-2.14v-1.01c0-6.21,4.39-11.47,10.33-13.02v-17.5c0-2.73,2.32-4.99,5.15-4.99h54.55c2.79-.03,5.08,2.2,5.13,4.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M365.65,463.01c0,9.6-7.87,17.41-17.53,17.41s-17.53-7.79-17.53-17.41,7.87-17.41,17.53-17.41,17.53,7.81,17.53,17.41Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 390.12,
    cy: 476.56,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 418.6,
    cy: 476.56,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M442.84,447.65l-16.17,20.33c-.81,1.14-2.12,1.81-3.52,1.8h-35.42c-2.32,0-4.19-1.76-4.19-3.94v-15.35h-3.21c-2.15,0-4.22-.8-5.8-2.27-1.53-1.4-2.41-3.37-2.42-5.44,.03-.69,.61-1.23,1.3-1.21h65.9c3.32,0,5.32,3.46,3.53,6.07Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 475.91,
    cy: 462.97,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M574.87,446.75v28.68c0,2.73-2.32,4.99-5.15,4.99h-67.79c-1.2,.02-2.2-.94-2.22-2.14v-1.01c0-6.21,4.39-11.47,10.33-13.02v-17.5c0-2.73,2.31-4.99,5.15-4.99h54.56c2.8,0,5.12,2.24,5.12,4.99Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 282.64,
    cy: 511.54,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M381.6,495.31v28.68c0,2.73-2.31,4.99-5.15,4.99h-67.79c-1.2,.02-2.2-.94-2.22-2.14h0v-1c0-6.21,4.39-11.48,10.33-13.02v-17.5c0-2.73,2.32-4.99,5.15-4.99h54.55c2.82,0,5.13,2.24,5.13,4.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M431.52,511.57c0,9.6-7.87,17.41-17.53,17.41s-17.53-7.79-17.53-17.41,7.87-17.41,17.53-17.41,17.53,7.81,17.53,17.41Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 456,
    cy: 525.12,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 484.48,
    cy: 525.12,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M508.71,496.21l-16.17,20.33c-.81,1.14-2.12,1.81-3.52,1.8h-35.42c-2.32,0-4.2-1.76-4.2-3.94v-15.36h-3.21c-2.15,0-4.21-.8-5.79-2.26-1.53-1.4-2.41-3.38-2.42-5.45,.03-.69,.61-1.23,1.3-1.21h65.9c3.32,.02,5.32,3.47,3.53,6.08Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 541.78,
    cy: 511.54,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 262.73,
    cy: 573.69,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 291.21,
    cy: 573.69,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M315.45,544.78l-16.17,20.33c-.8,1.15-2.12,1.83-3.52,1.82h-35.41c-2.32,0-4.19-1.76-4.19-3.94v-15.37h-3.22c-2.15,0-4.22-.8-5.8-2.26-1.53-1.4-2.41-3.38-2.42-5.45,.03-.69,.61-1.23,1.3-1.21h65.91c3.32,.02,5.32,3.47,3.53,6.08Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 348.52,
    cy: 560.1,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M447.48,543.88v28.68c0,2.73-2.32,4.99-5.15,4.99h-67.79c-1.2,.02-2.2-.94-2.22-2.14v-1.01c0-6.21,4.39-11.47,10.33-13.02v-17.5c0-2.73,2.31-4.99,5.15-4.99h54.55c2.81,0,5.13,2.24,5.13,4.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M497.4,560.14c0,9.6-7.87,17.41-17.53,17.41s-17.53-7.79-17.53-17.41,7.87-17.41,17.53-17.41,17.53,7.81,17.53,17.41Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 521.88,
    cy: 573.69,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 550.36,
    cy: 573.69,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M574.59,544.78l-16.17,20.33c-.8,1.15-2.12,1.83-3.52,1.82h-35.42c-2.32,0-4.19-1.76-4.19-3.94v-15.37h-3.21c-2.15,0-4.22-.8-5.8-2.26-1.53-1.4-2.41-3.38-2.42-5.45,.03-.69,.61-1.23,1.3-1.21h65.9c3.33,.02,5.32,3.47,3.53,6.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M254.21,592.45v28.68c0,2.73-2.31,4.99-5.15,4.99h-67.79c-1.2,.02-2.19-.94-2.22-2.14v-1c0-6.21,4.39-11.48,10.33-13.02v-17.5c0-2.73,2.32-4.99,5.15-4.99h54.55c2.82,0,5.13,2.24,5.13,4.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M304.14,608.7c0,9.6-7.87,17.41-17.53,17.41s-17.53-7.79-17.53-17.41,7.87-17.41,17.53-17.41,17.53,7.81,17.53,17.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M381.33,593.35l-16.17,20.33c-.8,1.15-2.12,1.83-3.52,1.82h-35.41c-2.32,0-4.19-1.76-4.19-3.94v-15.37h-3.22c-2.15,0-4.23-.81-5.8-2.27-1.53-1.4-2.41-3.37-2.42-5.44,.03-.69,.61-1.23,1.3-1.21h65.9c3.32,.02,5.32,3.46,3.53,6.08Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 414.39,
    cy: 608.67,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M513.35,592.45v28.68c0,2.73-2.32,4.99-5.15,4.99h-67.79c-1.2,.02-2.2-.94-2.22-2.14v-1c0-6.21,4.39-11.48,10.33-13.02v-17.5c0-2.73,2.31-4.99,5.15-4.99h54.55c2.81,0,5.13,2.24,5.13,4.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M563.28,608.7c0,9.6-7.87,17.41-17.53,17.41s-17.53-7.79-17.53-17.41,7.87-17.41,17.53-17.41,17.53,7.81,17.53,17.41Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 537.29,
    cy: 317.27,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M636.26,301.05v28.68c0,2.73-2.32,4.99-5.15,4.99h-67.79c-1.2,.02-2.2-.94-2.22-2.14v-1c0-6.21,4.39-11.47,10.33-13.02v-17.5c0-2.73,2.32-4.99,5.15-4.99h54.55c2.82,0,5.13,2.23,5.13,4.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M686.18,317.31c0,9.6-7.87,17.41-17.53,17.41s-17.53-7.79-17.53-17.41,7.87-17.41,17.53-17.41,17.53,7.81,17.53,17.41Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 710.65,
    cy: 330.86,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 739.13,
    cy: 330.86,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M763.37,301.95l-16.17,20.33c-.8,1.15-2.12,1.83-3.52,1.82h-35.42c-2.32,0-4.19-1.76-4.19-3.94v-15.37h-3.21c-2.15,0-4.22-.8-5.8-2.26-1.53-1.4-2.41-3.36-2.42-5.43,.03-.69,.61-1.23,1.3-1.21h65.9c3.32-.02,5.32,3.44,3.53,6.06Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 796.44,
    cy: 317.27,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 517.39,
    cy: 379.43,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 545.87,
    cy: 379.43,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M570.1,350.51l-16.17,20.34c-.81,1.14-2.12,1.81-3.52,1.8h-35.42c-2.32,0-4.19-1.76-4.19-3.94v-15.35h-3.21c-2.15,0-4.22-.8-5.8-2.26-1.53-1.4-2.41-3.37-2.42-5.44,.03-.69,.61-1.23,1.3-1.21h65.9c3.32,0,5.32,3.45,3.53,6.07Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 603.17,
    cy: 365.84,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M702.13,349.62v28.68c0,2.73-2.31,4.99-5.15,4.99h-67.79c-1.2,.02-2.19-.94-2.22-2.14v-1.01c0-6.21,4.39-11.47,10.33-13.02v-17.5c0-2.73,2.32-4.99,5.15-4.99h54.56c2.79-.02,5.07,2.2,5.12,4.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M752.06,365.87c0,9.6-7.87,17.41-17.53,17.41s-17.52-7.79-17.52-17.41,7.87-17.41,17.53-17.41,17.52,7.81,17.52,17.41Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 776.53,
    cy: 379.43,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 805.01,
    cy: 379.43,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M829.25,350.51l-16.17,20.34c-.81,1.14-2.12,1.81-3.52,1.8h-35.42c-2.32,0-4.19-1.76-4.19-3.94v-15.35h-3.21c-2.15,0-4.22-.8-5.8-2.26-1.53-1.4-2.41-3.37-2.42-5.44,.03-.69,.61-1.23,1.3-1.21h65.9c3.33,0,5.33,3.45,3.53,6.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M558.79,414.44c0,9.6-7.87,17.41-17.53,17.41s-17.53-7.79-17.53-17.41,7.87-17.4,17.53-17.4,17.53,7.8,17.53,17.4Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 583.27,
    cy: 427.99,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 611.75,
    cy: 427.99,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M635.98,399.08l-16.17,20.33c-.81,1.14-2.12,1.82-3.52,1.8h-35.42c-2.32,0-4.19-1.76-4.19-3.94v-15.36h-3.21c-2.15,0-4.22-.8-5.79-2.26-1.53-1.4-2.41-3.38-2.42-5.45,.03-.69,.61-1.23,1.3-1.21h65.9c3.33,.02,5.32,3.47,3.53,6.08Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 669.05,
    cy: 414.41,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M768.01,398.18v28.68c0,2.73-2.32,4.99-5.15,4.99h-67.79c-1.2,.02-2.2-.94-2.22-2.14v-1c0-6.21,4.39-11.48,10.33-13.02v-17.5c0-2.73,2.32-4.99,5.15-4.99h54.55c2.81,0,5.13,2.24,5.13,4.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M817.93,414.44c0,9.6-7.87,17.41-17.53,17.41s-17.53-7.79-17.53-17.41,7.87-17.41,17.53-17.41,17.53,7.81,17.53,17.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M574.74,446.75v28.68c0,2.73-2.31,4.99-5.15,4.99h-67.79c-1.2,.02-2.2-.94-2.22-2.14v-1.01c0-6.21,4.39-11.47,10.33-13.02v-17.5c0-2.73,2.32-4.99,5.15-4.99h54.55c2.79-.03,5.08,2.2,5.13,4.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M624.67,463.01c0,9.6-7.87,17.41-17.53,17.41s-17.53-7.79-17.53-17.41,7.87-17.41,17.53-17.41,17.53,7.81,17.53,17.41Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 649.14,
    cy: 476.56,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 677.62,
    cy: 476.56,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M701.86,447.65l-16.17,20.33c-.81,1.14-2.12,1.81-3.52,1.8h-35.42c-2.32,0-4.19-1.76-4.19-3.94v-15.35h-3.21c-2.15,0-4.22-.8-5.8-2.27-1.53-1.4-2.41-3.37-2.42-5.44,.03-.69,.61-1.23,1.3-1.21h65.9c3.32,0,5.32,3.46,3.53,6.07Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 734.92,
    cy: 462.97,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M833.89,446.75v28.68c0,2.73-2.32,4.99-5.15,4.99h-67.79c-1.2,.02-2.2-.94-2.22-2.14v-1.01c0-6.21,4.39-11.47,10.33-13.02v-17.5c0-2.73,2.31-4.99,5.15-4.99h54.56c2.8,0,5.12,2.24,5.12,4.99Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 541.66,
    cy: 511.54,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M640.62,495.31v28.68c0,2.73-2.31,4.99-5.15,4.99h-67.79c-1.2,.02-2.2-.94-2.22-2.14h0v-1c0-6.21,4.39-11.48,10.33-13.02v-17.5c0-2.73,2.32-4.99,5.15-4.99h54.55c2.82,0,5.13,2.24,5.13,4.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M690.54,511.57c0,9.6-7.87,17.41-17.53,17.41s-17.53-7.79-17.53-17.41,7.87-17.41,17.53-17.41,17.53,7.81,17.53,17.41Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 715.02,
    cy: 525.12,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 743.5,
    cy: 525.12,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M767.73,496.21l-16.17,20.33c-.81,1.14-2.12,1.81-3.52,1.8h-35.42c-2.32,0-4.2-1.76-4.2-3.94v-15.36h-3.21c-2.15,0-4.21-.8-5.79-2.26-1.53-1.4-2.41-3.38-2.42-5.45,.03-.69,.61-1.23,1.3-1.21h65.9c3.32,.02,5.32,3.47,3.53,6.08Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 800.8,
    cy: 511.54,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 521.75,
    cy: 573.69,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 550.23,
    cy: 573.69,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M574.47,544.78l-16.17,20.33c-.8,1.15-2.12,1.83-3.52,1.82h-35.41c-2.32,0-4.19-1.76-4.19-3.94v-15.37h-3.22c-2.15,0-4.22-.8-5.8-2.26-1.53-1.4-2.41-3.38-2.42-5.45,.03-.69,.61-1.23,1.3-1.21h65.91c3.32,.02,5.32,3.47,3.53,6.08Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 607.53,
    cy: 560.1,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M706.5,543.88v28.68c0,2.73-2.32,4.99-5.15,4.99h-67.79c-1.2,.02-2.2-.94-2.22-2.14v-1.01c0-6.21,4.39-11.47,10.33-13.02v-17.5c0-2.73,2.31-4.99,5.15-4.99h54.55c2.81,0,5.13,2.24,5.13,4.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M756.42,560.14c0,9.6-7.87,17.41-17.53,17.41s-17.53-7.79-17.53-17.41,7.87-17.41,17.53-17.41,17.53,7.81,17.53,17.41Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 780.9,
    cy: 573.69,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 809.37,
    cy: 573.69,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M833.61,544.78l-16.17,20.33c-.8,1.15-2.12,1.83-3.52,1.82h-35.42c-2.32,0-4.19-1.76-4.19-3.94v-15.37h-3.21c-2.15,0-4.22-.8-5.8-2.26-1.53-1.4-2.41-3.38-2.42-5.45,.03-.69,.61-1.23,1.3-1.21h65.9c3.33,.02,5.32,3.47,3.53,6.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M513.23,592.45v28.68c0,2.73-2.31,4.99-5.15,4.99h-67.79c-1.2,.02-2.19-.94-2.22-2.14v-1c0-6.21,4.39-11.48,10.33-13.02v-17.5c0-2.73,2.32-4.99,5.15-4.99h54.55c2.82,0,5.13,2.24,5.13,4.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M563.15,608.7c0,9.6-7.87,17.41-17.53,17.41s-17.53-7.79-17.53-17.41,7.87-17.41,17.53-17.41,17.53,7.81,17.53,17.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M640.34,593.35l-16.17,20.33c-.8,1.15-2.12,1.83-3.52,1.82h-35.41c-2.32,0-4.19-1.76-4.19-3.94v-15.37h-3.22c-2.15,0-4.23-.81-5.8-2.27-1.53-1.4-2.41-3.37-2.42-5.44,.03-.69,.61-1.23,1.3-1.21h65.9c3.32,.02,5.32,3.46,3.53,6.08Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 673.41,
    cy: 608.67,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M772.37,592.45v28.68c0,2.73-2.32,4.99-5.15,4.99h-67.79c-1.2,.02-2.2-.94-2.22-2.14v-1c0-6.21,4.39-11.48,10.33-13.02v-17.5c0-2.73,2.31-4.99,5.15-4.99h54.55c2.81,0,5.13,2.24,5.13,4.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M822.3,608.7c0,9.6-7.87,17.41-17.53,17.41s-17.53-7.79-17.53-17.41,7.87-17.41,17.53-17.41,17.53,7.81,17.53,17.41Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 796.49,
    cy: 317.27,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M895.45,301.05v28.68c0,2.73-2.32,4.99-5.15,4.99h-67.79c-1.2,.02-2.2-.94-2.22-2.14v-1c0-6.21,4.39-11.47,10.33-13.02v-17.5c0-2.73,2.32-4.99,5.15-4.99h54.55c2.82,0,5.13,2.23,5.13,4.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M945.37,317.31c0,9.6-7.87,17.41-17.53,17.41s-17.53-7.79-17.53-17.41,7.87-17.41,17.53-17.41,17.53,7.81,17.53,17.41Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 969.85,
    cy: 330.86,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 998.33,
    cy: 330.86,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1022.56,301.95l-16.17,20.33c-.8,1.15-2.12,1.83-3.52,1.82h-35.42c-2.32,0-4.19-1.76-4.19-3.94v-15.37h-3.21c-2.15,0-4.22-.8-5.8-2.26-1.53-1.4-2.41-3.36-2.42-5.43,.03-.69,.61-1.23,1.3-1.21h65.9c3.32-.02,5.32,3.44,3.53,6.06Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1055.63,
    cy: 317.27,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 776.58,
    cy: 379.43,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 805.06,
    cy: 379.43,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M829.3,350.51l-16.17,20.34c-.81,1.14-2.12,1.81-3.52,1.8h-35.42c-2.32,0-4.19-1.76-4.19-3.94v-15.35h-3.21c-2.15,0-4.22-.8-5.8-2.26-1.53-1.4-2.41-3.37-2.42-5.44,.03-.69,.61-1.23,1.3-1.21h65.9c3.32,0,5.32,3.45,3.53,6.07Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 862.36,
    cy: 365.84,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M961.32,349.62v28.68c0,2.73-2.31,4.99-5.15,4.99h-67.79c-1.2,.02-2.19-.94-2.22-2.14v-1.01c0-6.21,4.39-11.47,10.33-13.02v-17.5c0-2.73,2.32-4.99,5.15-4.99h54.56c2.79-.02,5.07,2.2,5.12,4.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1011.25,365.87c0,9.6-7.87,17.41-17.53,17.41s-17.52-7.79-17.52-17.41,7.87-17.41,17.53-17.41,17.52,7.81,17.52,17.41Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1035.72,
    cy: 379.43,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1064.2,
    cy: 379.43,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1088.44,350.51l-16.17,20.34c-.81,1.14-2.12,1.81-3.52,1.8h-35.42c-2.32,0-4.19-1.76-4.19-3.94v-15.35h-3.21c-2.15,0-4.22-.8-5.8-2.26-1.53-1.4-2.41-3.37-2.42-5.44,.03-.69,.61-1.23,1.3-1.21h65.9c3.33,0,5.33,3.45,3.53,6.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M817.98,414.44c0,9.6-7.87,17.41-17.53,17.41s-17.53-7.79-17.53-17.41,7.87-17.4,17.53-17.4,17.53,7.8,17.53,17.4Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 842.46,
    cy: 427.99,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 870.94,
    cy: 427.99,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M895.17,399.08l-16.17,20.33c-.81,1.14-2.12,1.82-3.52,1.8h-35.42c-2.32,0-4.19-1.76-4.19-3.94v-15.36h-3.21c-2.15,0-4.22-.8-5.79-2.26-1.53-1.4-2.41-3.38-2.42-5.45,.03-.69,.61-1.23,1.3-1.21h65.9c3.33,.02,5.32,3.47,3.53,6.08Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 928.24,
    cy: 414.41,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1027.2,398.18v28.68c0,2.73-2.32,4.99-5.15,4.99h-67.79c-1.2,.02-2.2-.94-2.22-2.14v-1c0-6.21,4.39-11.48,10.33-13.02v-17.5c0-2.73,2.32-4.99,5.15-4.99h54.55c2.81,0,5.13,2.24,5.13,4.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1077.12,414.44c0,9.6-7.87,17.41-17.53,17.41s-17.53-7.79-17.53-17.41,7.87-17.41,17.53-17.41,17.53,7.81,17.53,17.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M833.93,446.75v28.68c0,2.73-2.31,4.99-5.15,4.99h-67.79c-1.2,.02-2.2-.94-2.22-2.14v-1.01c0-6.21,4.39-11.47,10.33-13.02v-17.5c0-2.73,2.32-4.99,5.15-4.99h54.55c2.79-.03,5.08,2.2,5.13,4.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M883.86,463.01c0,9.6-7.87,17.41-17.53,17.41s-17.53-7.79-17.53-17.41,7.87-17.41,17.53-17.41,17.53,7.81,17.53,17.41Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 908.33,
    cy: 476.56,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 936.81,
    cy: 476.56,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M961.05,447.65l-16.17,20.33c-.81,1.14-2.12,1.81-3.52,1.8h-35.42c-2.32,0-4.19-1.76-4.19-3.94v-15.35h-3.21c-2.15,0-4.22-.8-5.8-2.27-1.53-1.4-2.41-3.37-2.42-5.44,.03-.69,.61-1.23,1.3-1.21h65.9c3.32,0,5.32,3.46,3.53,6.07Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 994.12,
    cy: 462.97,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1093.08,446.75v28.68c0,2.73-2.32,4.99-5.15,4.99h-67.79c-1.2,.02-2.2-.94-2.22-2.14v-1.01c0-6.21,4.39-11.47,10.33-13.02v-17.5c0-2.73,2.31-4.99,5.15-4.99h54.56c2.8,0,5.12,2.24,5.12,4.99Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 800.85,
    cy: 511.54,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M899.81,495.31v28.68c0,2.73-2.31,4.99-5.15,4.99h-67.79c-1.2,.02-2.2-.94-2.22-2.14h0v-1c0-6.21,4.39-11.48,10.33-13.02v-17.5c0-2.73,2.32-4.99,5.15-4.99h54.55c2.82,0,5.13,2.24,5.13,4.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M949.73,511.57c0,9.6-7.87,17.41-17.53,17.41s-17.53-7.79-17.53-17.41,7.87-17.41,17.53-17.41,17.53,7.81,17.53,17.41Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 974.21,
    cy: 525.12,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1002.69,
    cy: 525.12,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1026.92,496.21l-16.17,20.33c-.81,1.14-2.12,1.81-3.52,1.8h-35.42c-2.32,0-4.2-1.76-4.2-3.94v-15.36h-3.21c-2.15,0-4.21-.8-5.79-2.26-1.53-1.4-2.41-3.38-2.42-5.45,.03-.69,.61-1.23,1.3-1.21h65.9c3.32,.02,5.32,3.47,3.53,6.08Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1059.99,
    cy: 511.54,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 780.94,
    cy: 573.69,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 809.42,
    cy: 573.69,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M833.66,544.78l-16.17,20.33c-.8,1.15-2.12,1.83-3.52,1.82h-35.41c-2.32,0-4.19-1.76-4.19-3.94v-15.37h-3.22c-2.15,0-4.22-.8-5.8-2.26-1.53-1.4-2.41-3.38-2.42-5.45,.03-.69,.61-1.23,1.3-1.21h65.91c3.32,.02,5.32,3.47,3.53,6.08Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 866.73,
    cy: 560.1,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M965.69,543.88v28.68c0,2.73-2.32,4.99-5.15,4.99h-67.79c-1.2,.02-2.2-.94-2.22-2.14v-1.01c0-6.21,4.39-11.47,10.33-13.02v-17.5c0-2.73,2.31-4.99,5.15-4.99h54.55c2.81,0,5.13,2.24,5.13,4.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1015.61,560.14c0,9.6-7.87,17.41-17.53,17.41s-17.53-7.79-17.53-17.41,7.87-17.41,17.53-17.41,17.53,7.81,17.53,17.41Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1040.09,
    cy: 573.69,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1068.57,
    cy: 573.69,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1092.8,544.78l-16.17,20.33c-.8,1.15-2.12,1.83-3.52,1.82h-35.42c-2.32,0-4.19-1.76-4.19-3.94v-15.37h-3.21c-2.15,0-4.22-.8-5.8-2.26-1.53-1.4-2.41-3.38-2.42-5.45,.03-.69,.61-1.23,1.3-1.21h65.9c3.33,.02,5.32,3.47,3.53,6.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M772.42,592.45v28.68c0,2.73-2.31,4.99-5.15,4.99h-67.79c-1.2,.02-2.19-.94-2.22-2.14v-1c0-6.21,4.39-11.48,10.33-13.02v-17.5c0-2.73,2.32-4.99,5.15-4.99h54.55c2.82,0,5.13,2.24,5.13,4.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M822.35,608.7c0,9.6-7.87,17.41-17.53,17.41s-17.53-7.79-17.53-17.41,7.87-17.41,17.53-17.41,17.53,7.81,17.53,17.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M899.54,593.35l-16.17,20.33c-.8,1.15-2.12,1.83-3.52,1.82h-35.41c-2.32,0-4.19-1.76-4.19-3.94v-15.37h-3.22c-2.15,0-4.23-.81-5.8-2.27-1.53-1.4-2.41-3.37-2.42-5.44,.03-.69,.61-1.23,1.3-1.21h65.9c3.32,.02,5.32,3.46,3.53,6.08Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 932.6,
    cy: 608.67,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1031.56,592.45v28.68c0,2.73-2.32,4.99-5.15,4.99h-67.79c-1.2,.02-2.2-.94-2.22-2.14v-1c0-6.21,4.39-11.48,10.33-13.02v-17.5c0-2.73,2.31-4.99,5.15-4.99h54.55c2.81,0,5.13,2.24,5.13,4.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1081.49,608.7c0,9.6-7.87,17.41-17.53,17.41s-17.53-7.79-17.53-17.41,7.87-17.41,17.53-17.41,17.53,7.81,17.53,17.41Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1055.42,
    cy: 317.27,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1154.39,301.05v28.68c0,2.73-2.32,4.99-5.15,4.99h-67.79c-1.2,.02-2.2-.94-2.22-2.14v-1c0-6.21,4.39-11.47,10.33-13.02v-17.5c0-2.73,2.32-4.99,5.15-4.99h54.55c2.82,0,5.13,2.23,5.13,4.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1204.31,317.31c0,9.6-7.87,17.41-17.53,17.41s-17.53-7.79-17.53-17.41,7.87-17.41,17.53-17.41,17.53,7.81,17.53,17.41Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1228.78,
    cy: 330.86,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1257.26,
    cy: 330.86,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1281.5,301.95l-16.17,20.33c-.8,1.15-2.12,1.83-3.52,1.82h-35.42c-2.32,0-4.19-1.76-4.19-3.94v-15.37h-3.21c-2.15,0-4.22-.8-5.8-2.26-1.53-1.4-2.41-3.36-2.42-5.43,.03-.69,.61-1.23,1.3-1.21h65.9c3.32-.02,5.32,3.44,3.53,6.06Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1314.57,
    cy: 317.27,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1035.52,
    cy: 379.43,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1064,
    cy: 379.43,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1088.23,350.51l-16.17,20.34c-.81,1.14-2.12,1.81-3.52,1.8h-35.42c-2.32,0-4.19-1.76-4.19-3.94v-15.35h-3.21c-2.15,0-4.22-.8-5.8-2.26-1.53-1.4-2.41-3.37-2.42-5.44,.03-.69,.61-1.23,1.3-1.21h65.9c3.32,0,5.32,3.45,3.53,6.07Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1121.3,
    cy: 365.84,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1220.26,349.62v28.68c0,2.73-2.31,4.99-5.15,4.99h-67.79c-1.2,.02-2.19-.94-2.22-2.14v-1.01c0-6.21,4.39-11.47,10.33-13.02v-17.5c0-2.73,2.32-4.99,5.15-4.99h54.56c2.79-.02,5.07,2.2,5.12,4.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1270.19,365.87c0,9.6-7.87,17.41-17.53,17.41s-17.52-7.79-17.52-17.41,7.87-17.41,17.53-17.41,17.52,7.81,17.52,17.41Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1294.66,
    cy: 379.43,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1323.14,
    cy: 379.43,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1347.37,350.51l-16.17,20.34c-.81,1.14-2.12,1.81-3.52,1.8h-35.42c-2.32,0-4.19-1.76-4.19-3.94v-15.35h-3.21c-2.15,0-4.22-.8-5.8-2.26-1.53-1.4-2.41-3.37-2.42-5.44,.03-.69,.61-1.23,1.3-1.21h65.9c3.33,0,5.33,3.45,3.53,6.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1076.92,414.44c0,9.6-7.87,17.41-17.53,17.41s-17.53-7.79-17.53-17.41,7.87-17.4,17.53-17.4,17.53,7.8,17.53,17.4Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1101.4,
    cy: 427.99,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1129.87,
    cy: 427.99,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1154.11,399.08l-16.17,20.33c-.81,1.14-2.12,1.82-3.52,1.8h-35.42c-2.32,0-4.19-1.76-4.19-3.94v-15.36h-3.21c-2.15,0-4.22-.8-5.79-2.26-1.53-1.4-2.41-3.38-2.42-5.45,.03-.69,.61-1.23,1.3-1.21h65.9c3.33,.02,5.32,3.47,3.53,6.08Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1187.18,
    cy: 414.4,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1286.14,398.18v28.68c0,2.73-2.32,4.99-5.15,4.99h-67.79c-1.2,.02-2.2-.94-2.22-2.14v-1c0-6.21,4.39-11.48,10.33-13.02v-17.5c0-2.73,2.32-4.99,5.15-4.99h54.55c2.81,0,5.13,2.24,5.13,4.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1336.06,414.44c0,9.6-7.87,17.41-17.53,17.41s-17.53-7.79-17.53-17.41,7.87-17.41,17.53-17.41,17.53,7.81,17.53,17.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1092.87,446.75v28.68c0,2.73-2.31,4.99-5.15,4.99h-67.79c-1.2,.02-2.2-.94-2.22-2.14v-1.01c0-6.21,4.39-11.47,10.33-13.02v-17.5c0-2.73,2.32-4.99,5.15-4.99h54.55c2.79-.03,5.08,2.2,5.13,4.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1142.8,463.01c0,9.6-7.87,17.41-17.53,17.41s-17.53-7.79-17.53-17.41,7.87-17.41,17.53-17.41,17.53,7.81,17.53,17.41Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1167.27,
    cy: 476.56,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1195.75,
    cy: 476.56,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1219.99,447.65l-16.17,20.33c-.81,1.14-2.12,1.81-3.52,1.8h-35.42c-2.32,0-4.19-1.76-4.19-3.94v-15.35h-3.21c-2.15,0-4.22-.8-5.8-2.27-1.53-1.4-2.41-3.37-2.42-5.44,.03-.69,.61-1.23,1.3-1.21h65.9c3.32,0,5.32,3.46,3.53,6.07Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1253.05,
    cy: 462.97,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1352.02,446.75v28.68c0,2.73-2.32,4.99-5.15,4.99h-67.79c-1.2,.02-2.2-.94-2.22-2.14v-1.01c0-6.21,4.39-11.47,10.33-13.02v-17.5c0-2.73,2.31-4.99,5.15-4.99h54.56c2.8,0,5.12,2.24,5.12,4.99Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1059.79,
    cy: 511.54,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1158.75,495.31v28.68c0,2.73-2.31,4.99-5.15,4.99h-67.79c-1.2,.02-2.2-.94-2.22-2.14h0v-1c0-6.21,4.39-11.48,10.33-13.02v-17.5c0-2.73,2.32-4.99,5.15-4.99h54.55c2.82,0,5.13,2.24,5.13,4.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1208.67,511.57c0,9.6-7.87,17.41-17.53,17.41s-17.53-7.79-17.53-17.41,7.87-17.41,17.53-17.41,17.53,7.81,17.53,17.41Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1233.15,
    cy: 525.12,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1261.63,
    cy: 525.12,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1285.86,496.21l-16.17,20.33c-.81,1.14-2.12,1.81-3.52,1.8h-35.42c-2.32,0-4.2-1.76-4.2-3.94v-15.36h-3.21c-2.15,0-4.21-.8-5.79-2.26-1.53-1.4-2.41-3.38-2.42-5.45,.03-.69,.61-1.23,1.3-1.21h65.9c3.32,.02,5.32,3.47,3.53,6.08Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1318.93,
    cy: 511.54,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1039.88,
    cy: 573.69,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1068.36,
    cy: 573.69,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1092.6,544.78l-16.17,20.33c-.8,1.15-2.12,1.83-3.52,1.82h-35.41c-2.32,0-4.19-1.76-4.19-3.94v-15.37h-3.22c-2.15,0-4.22-.8-5.8-2.26-1.53-1.4-2.41-3.38-2.42-5.45,.03-.69,.61-1.23,1.3-1.21h65.91c3.32,.02,5.32,3.47,3.53,6.08Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1125.66,
    cy: 560.1,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1224.63,543.88v28.68c0,2.73-2.32,4.99-5.15,4.99h-67.79c-1.2,.02-2.2-.94-2.22-2.14v-1.01c0-6.21,4.39-11.47,10.33-13.02v-17.5c0-2.73,2.31-4.99,5.15-4.99h54.55c2.81,0,5.13,2.24,5.13,4.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1274.55,560.14c0,9.6-7.87,17.41-17.53,17.41s-17.53-7.79-17.53-17.41,7.87-17.41,17.53-17.41,17.53,7.81,17.53,17.41Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1299.03,
    cy: 573.69,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1327.5,
    cy: 573.69,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1351.74,544.78l-16.17,20.33c-.8,1.15-2.12,1.83-3.52,1.82h-35.42c-2.32,0-4.19-1.76-4.19-3.94v-15.37h-3.21c-2.15,0-4.22-.8-5.8-2.26-1.53-1.4-2.41-3.38-2.42-5.45,.03-.69,.61-1.23,1.3-1.21h65.9c3.33,.02,5.32,3.47,3.53,6.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1031.36,592.45v28.68c0,2.73-2.31,4.99-5.15,4.99h-67.79c-1.2,.02-2.19-.94-2.22-2.14v-1c0-6.21,4.39-11.48,10.33-13.02v-17.5c0-2.73,2.32-4.99,5.15-4.99h54.55c2.82,0,5.13,2.24,5.13,4.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1081.28,608.7c0,9.6-7.87,17.41-17.53,17.41s-17.53-7.79-17.53-17.41,7.87-17.41,17.53-17.41,17.53,7.81,17.53,17.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1158.47,593.35l-16.17,20.33c-.8,1.15-2.12,1.83-3.52,1.82h-35.41c-2.32,0-4.19-1.76-4.19-3.94v-15.37h-3.22c-2.15,0-4.23-.81-5.8-2.27-1.53-1.4-2.41-3.37-2.42-5.44,.03-.69,.61-1.23,1.3-1.21h65.9c3.32,.02,5.32,3.46,3.53,6.08Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1191.54,
    cy: 608.67,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1290.5,592.45v28.68c0,2.73-2.32,4.99-5.15,4.99h-67.79c-1.2,.02-2.2-.94-2.22-2.14v-1c0-6.21,4.39-11.48,10.33-13.02v-17.5c0-2.73,2.31-4.99,5.15-4.99h54.55c2.81,0,5.13,2.24,5.13,4.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1340.43,608.7c0,9.6-7.87,17.41-17.53,17.41s-17.53-7.79-17.53-17.41,7.87-17.41,17.53-17.41,17.53,7.81,17.53,17.41Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1314.44,
    cy: 317.27,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1413.41,301.05v28.68c0,2.73-2.32,4.99-5.15,4.99h-67.79c-1.2,.02-2.2-.94-2.22-2.14v-1c0-6.21,4.39-11.47,10.33-13.02v-17.5c0-2.73,2.32-4.99,5.15-4.99h54.55c2.82,0,5.13,2.23,5.13,4.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1463.33,317.31c0,9.6-7.87,17.41-17.53,17.41s-17.53-7.79-17.53-17.41,7.87-17.41,17.53-17.41,17.53,7.81,17.53,17.41Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1487.8,
    cy: 330.86,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1516.28,
    cy: 330.86,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1540.52,301.95l-16.17,20.33c-.8,1.15-2.12,1.83-3.52,1.82h-35.42c-2.32,0-4.19-1.76-4.19-3.94v-15.37h-3.21c-2.15,0-4.22-.8-5.8-2.26-1.53-1.4-2.41-3.36-2.42-5.43,.03-.69,.61-1.23,1.3-1.21h65.9c3.32-.02,5.32,3.44,3.53,6.06Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1573.58,
    cy: 317.27,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1294.54,
    cy: 379.43,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1323.02,
    cy: 379.43,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1347.25,350.51l-16.17,20.34c-.81,1.14-2.12,1.81-3.52,1.8h-35.42c-2.32,0-4.19-1.76-4.19-3.94v-15.35h-3.21c-2.15,0-4.22-.8-5.8-2.26-1.53-1.4-2.41-3.37-2.42-5.44,.03-.69,.61-1.23,1.3-1.21h65.9c3.32,0,5.32,3.45,3.53,6.07Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1380.32,
    cy: 365.84,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1479.28,349.62v28.68c0,2.73-2.31,4.99-5.15,4.99h-67.79c-1.2,.02-2.19-.94-2.22-2.14v-1.01c0-6.21,4.39-11.47,10.33-13.02v-17.5c0-2.73,2.32-4.99,5.15-4.99h54.56c2.79-.02,5.07,2.2,5.12,4.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1529.2,365.87c0,9.6-7.87,17.41-17.53,17.41s-17.52-7.79-17.52-17.41,7.87-17.41,17.53-17.41,17.52,7.81,17.52,17.41Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1553.68,
    cy: 379.43,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1582.16,
    cy: 379.43,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1606.39,350.51l-16.17,20.34c-.81,1.14-2.12,1.81-3.52,1.8h-35.42c-2.32,0-4.19-1.76-4.19-3.94v-15.35h-3.21c-2.15,0-4.22-.8-5.8-2.26-1.53-1.4-2.41-3.37-2.42-5.44,.03-.69,.61-1.23,1.3-1.21h65.9c3.33,0,5.33,3.45,3.53,6.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1335.94,414.44c0,9.6-7.87,17.41-17.53,17.41s-17.53-7.79-17.53-17.41,7.87-17.4,17.53-17.4,17.53,7.8,17.53,17.4Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1360.42,
    cy: 427.99,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1388.89,
    cy: 427.99,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1413.13,399.08l-16.17,20.33c-.81,1.14-2.12,1.82-3.52,1.8h-35.42c-2.32,0-4.19-1.76-4.19-3.94v-15.36h-3.21c-2.15,0-4.22-.8-5.79-2.26-1.53-1.4-2.41-3.38-2.42-5.45,.03-.69,.61-1.23,1.3-1.21h65.9c3.33,.02,5.32,3.47,3.53,6.08Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1446.2,
    cy: 414.4,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1545.16,398.18v28.68c0,2.73-2.32,4.99-5.15,4.99h-67.79c-1.2,.02-2.2-.94-2.22-2.14v-1c0-6.21,4.39-11.48,10.33-13.02v-17.5c0-2.73,2.32-4.99,5.15-4.99h54.55c2.81,0,5.13,2.24,5.13,4.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1595.08,414.44c0,9.6-7.87,17.41-17.53,17.41s-17.53-7.79-17.53-17.41,7.87-17.41,17.53-17.41,17.53,7.81,17.53,17.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1351.89,446.75v28.68c0,2.73-2.31,4.99-5.15,4.99h-67.79c-1.2,.02-2.2-.94-2.22-2.14v-1.01c0-6.21,4.39-11.47,10.33-13.02v-17.5c0-2.73,2.32-4.99,5.15-4.99h54.55c2.79-.03,5.08,2.2,5.13,4.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1401.81,463.01c0,9.6-7.87,17.41-17.53,17.41s-17.53-7.79-17.53-17.41,7.87-17.41,17.53-17.41,17.53,7.81,17.53,17.41Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1426.29,
    cy: 476.56,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1454.77,
    cy: 476.56,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1479.01,447.65l-16.17,20.33c-.81,1.14-2.12,1.81-3.52,1.8h-35.42c-2.32,0-4.19-1.76-4.19-3.94v-15.35h-3.21c-2.15,0-4.22-.8-5.8-2.27-1.53-1.4-2.41-3.37-2.42-5.44,.03-.69,.61-1.23,1.3-1.21h65.9c3.32,0,5.32,3.46,3.53,6.07Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1512.07,
    cy: 462.97,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1611.03,446.75v28.68c0,2.73-2.32,4.99-5.15,4.99h-67.79c-1.2,.02-2.2-.94-2.22-2.14v-1.01c0-6.21,4.39-11.47,10.33-13.02v-17.5c0-2.73,2.31-4.99,5.15-4.99h54.56c2.8,0,5.12,2.24,5.12,4.99Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1318.81,
    cy: 511.54,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1417.77,495.31v28.68c0,2.73-2.31,4.99-5.15,4.99h-67.79c-1.2,.02-2.2-.94-2.22-2.14h0v-1c0-6.21,4.39-11.48,10.33-13.02v-17.5c0-2.73,2.32-4.99,5.15-4.99h54.55c2.82,0,5.13,2.24,5.13,4.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1467.69,511.57c0,9.6-7.87,17.41-17.53,17.41s-17.53-7.79-17.53-17.41,7.87-17.41,17.53-17.41,17.53,7.81,17.53,17.41Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1492.17,
    cy: 525.12,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1520.64,
    cy: 525.12,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1544.88,496.21l-16.17,20.33c-.81,1.14-2.12,1.81-3.52,1.8h-35.42c-2.32,0-4.2-1.76-4.2-3.94v-15.36h-3.21c-2.15,0-4.21-.8-5.79-2.26-1.53-1.4-2.41-3.38-2.42-5.45,.03-.69,.61-1.23,1.3-1.21h65.9c3.32,.02,5.32,3.47,3.53,6.08Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1577.95,
    cy: 511.54,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1298.9,
    cy: 573.69,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1327.38,
    cy: 573.69,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1351.61,544.78l-16.17,20.33c-.8,1.15-2.12,1.83-3.52,1.82h-35.41c-2.32,0-4.19-1.76-4.19-3.94v-15.37h-3.22c-2.15,0-4.22-.8-5.8-2.26-1.53-1.4-2.41-3.38-2.42-5.45,.03-.69,.61-1.23,1.3-1.21h65.91c3.32,.02,5.32,3.47,3.53,6.08Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1384.68,
    cy: 560.1,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1483.64,543.88v28.68c0,2.73-2.32,4.99-5.15,4.99h-67.79c-1.2,.02-2.2-.94-2.22-2.14v-1.01c0-6.21,4.39-11.47,10.33-13.02v-17.5c0-2.73,2.31-4.99,5.15-4.99h54.55c2.81,0,5.13,2.24,5.13,4.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1533.57,560.14c0,9.6-7.87,17.41-17.53,17.41s-17.53-7.79-17.53-17.41,7.87-17.41,17.53-17.41,17.53,7.81,17.53,17.41Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1558.04,
    cy: 573.69,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1586.52,
    cy: 573.69,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1610.76,544.78l-16.17,20.33c-.8,1.15-2.12,1.83-3.52,1.82h-35.42c-2.32,0-4.19-1.76-4.19-3.94v-15.37h-3.21c-2.15,0-4.22-.8-5.8-2.26-1.53-1.4-2.41-3.38-2.42-5.45,.03-.69,.61-1.23,1.3-1.21h65.9c3.33,.02,5.32,3.47,3.53,6.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1290.38,592.45v28.68c0,2.73-2.31,4.99-5.15,4.99h-67.79c-1.2,.02-2.19-.94-2.22-2.14v-1c0-6.21,4.39-11.48,10.33-13.02v-17.5c0-2.73,2.32-4.99,5.15-4.99h54.55c2.82,0,5.13,2.24,5.13,4.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1340.3,608.7c0,9.6-7.87,17.41-17.53,17.41s-17.53-7.79-17.53-17.41,7.87-17.41,17.53-17.41,17.53,7.81,17.53,17.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1417.49,593.35l-16.17,20.33c-.8,1.15-2.12,1.83-3.52,1.82h-35.41c-2.32,0-4.19-1.76-4.19-3.94v-15.37h-3.22c-2.15,0-4.23-.81-5.8-2.27-1.53-1.4-2.41-3.37-2.42-5.44,.03-.69,.61-1.23,1.3-1.21h65.9c3.32,.02,5.32,3.46,3.53,6.08Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1450.56,
    cy: 608.67,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1549.52,592.45v28.68c0,2.73-2.32,4.99-5.15,4.99h-67.79c-1.2,.02-2.2-.94-2.22-2.14v-1c0-6.21,4.39-11.48,10.33-13.02v-17.5c0-2.73,2.31-4.99,5.15-4.99h54.55c2.81,0,5.13,2.24,5.13,4.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1599.44,608.7c0,9.6-7.87,17.41-17.53,17.41s-17.53-7.79-17.53-17.41,7.87-17.41,17.53-17.41,17.53,7.81,17.53,17.41Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1573.46,
    cy: 317.27,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1672.42,301.05v28.68c0,2.73-2.32,4.99-5.15,4.99h-67.79c-1.2,.02-2.2-.94-2.22-2.14v-1c0-6.21,4.39-11.47,10.33-13.02v-17.5c0-2.73,2.32-4.99,5.15-4.99h54.55c2.82,0,5.13,2.23,5.13,4.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1722.35,317.31c0,9.6-7.87,17.41-17.53,17.41s-17.53-7.79-17.53-17.41,7.87-17.41,17.53-17.41,17.53,7.81,17.53,17.41Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1746.82,
    cy: 330.86,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1775.3,
    cy: 330.86,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1799.53,301.95l-16.17,20.33c-.8,1.15-2.12,1.83-3.52,1.82h-35.42c-2.32,0-4.19-1.76-4.19-3.94v-15.37h-3.21c-2.15,0-4.22-.8-5.8-2.26-1.53-1.4-2.41-3.36-2.42-5.43,.03-.69,.61-1.23,1.3-1.21h65.9c3.32-.02,5.32,3.44,3.53,6.06Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1832.6,
    cy: 317.27,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1553.56,
    cy: 379.43,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1582.03,
    cy: 379.43,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1606.27,350.51l-16.17,20.34c-.81,1.14-2.12,1.81-3.52,1.8h-35.42c-2.32,0-4.19-1.76-4.19-3.94v-15.35h-3.21c-2.15,0-4.22-.8-5.8-2.26-1.53-1.4-2.41-3.37-2.42-5.44,.03-.69,.61-1.23,1.3-1.21h65.9c3.32,0,5.32,3.45,3.53,6.07Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1639.34,
    cy: 365.84,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1738.3,349.62v28.68c0,2.73-2.31,4.99-5.15,4.99h-67.79c-1.2,.02-2.19-.94-2.22-2.14v-1.01c0-6.21,4.39-11.47,10.33-13.02v-17.5c0-2.73,2.32-4.99,5.15-4.99h54.56c2.79-.02,5.07,2.2,5.12,4.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1788.22,365.87c0,9.6-7.87,17.41-17.53,17.41s-17.52-7.79-17.52-17.41,7.87-17.41,17.53-17.41,17.52,7.81,17.52,17.41Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1812.7,
    cy: 379.43,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1841.17,
    cy: 379.43,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1865.41,350.51l-16.17,20.34c-.81,1.14-2.12,1.81-3.52,1.8h-35.42c-2.32,0-4.19-1.76-4.19-3.94v-15.35h-3.21c-2.15,0-4.22-.8-5.8-2.26-1.53-1.4-2.41-3.37-2.42-5.44,.03-.69,.61-1.23,1.3-1.21h65.9c3.33,0,5.33,3.45,3.53,6.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1594.96,414.44c0,9.6-7.87,17.41-17.53,17.41s-17.53-7.79-17.53-17.41,7.87-17.4,17.53-17.4,17.53,7.8,17.53,17.4Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1619.43,
    cy: 427.99,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1647.91,
    cy: 427.99,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1672.14,399.08l-16.17,20.33c-.81,1.14-2.12,1.82-3.52,1.8h-35.42c-2.32,0-4.19-1.76-4.19-3.94v-15.36h-3.21c-2.15,0-4.22-.8-5.79-2.26-1.53-1.4-2.41-3.38-2.42-5.45,.03-.69,.61-1.23,1.3-1.21h65.9c3.33,.02,5.32,3.47,3.53,6.08Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1705.21,
    cy: 414.4,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1804.17,398.18v28.68c0,2.73-2.32,4.99-5.15,4.99h-67.79c-1.2,.02-2.2-.94-2.22-2.14v-1c0-6.21,4.39-11.48,10.33-13.02v-17.5c0-2.73,2.32-4.99,5.15-4.99h54.55c2.81,0,5.13,2.24,5.13,4.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1854.1,414.44c0,9.6-7.87,17.41-17.53,17.41s-17.53-7.79-17.53-17.41,7.87-17.41,17.53-17.41,17.53,7.81,17.53,17.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1610.91,446.75v28.68c0,2.73-2.31,4.99-5.15,4.99h-67.79c-1.2,.02-2.2-.94-2.22-2.14v-1.01c0-6.21,4.39-11.47,10.33-13.02v-17.5c0-2.73,2.32-4.99,5.15-4.99h54.55c2.79-.03,5.08,2.2,5.13,4.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1660.83,463.01c0,9.6-7.87,17.41-17.53,17.41s-17.53-7.79-17.53-17.41,7.87-17.41,17.53-17.41,17.53,7.81,17.53,17.41Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1685.31,
    cy: 476.56,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1713.79,
    cy: 476.56,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1738.02,447.65l-16.17,20.33c-.81,1.14-2.12,1.81-3.52,1.8h-35.42c-2.32,0-4.19-1.76-4.19-3.94v-15.35h-3.21c-2.15,0-4.22-.8-5.8-2.27-1.53-1.4-2.41-3.37-2.42-5.44,.03-.69,.61-1.23,1.3-1.21h65.9c3.32,0,5.32,3.46,3.53,6.07Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1771.09,
    cy: 462.97,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1870.05,446.75v28.68c0,2.73-2.32,4.99-5.15,4.99h-67.79c-1.2,.02-2.2-.94-2.22-2.14v-1.01c0-6.21,4.39-11.47,10.33-13.02v-17.5c0-2.73,2.31-4.99,5.15-4.99h54.56c2.8,0,5.12,2.24,5.12,4.99Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1577.82,
    cy: 511.54,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1676.78,495.31v28.68c0,2.73-2.31,4.99-5.15,4.99h-67.79c-1.2,.02-2.2-.94-2.22-2.14h0v-1c0-6.21,4.39-11.48,10.33-13.02v-17.5c0-2.73,2.32-4.99,5.15-4.99h54.55c2.82,0,5.13,2.24,5.13,4.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1726.71,511.57c0,9.6-7.87,17.41-17.53,17.41s-17.53-7.79-17.53-17.41,7.87-17.41,17.53-17.41,17.53,7.81,17.53,17.41Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1751.18,
    cy: 525.12,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1779.66,
    cy: 525.12,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1803.9,496.21l-16.17,20.33c-.81,1.14-2.12,1.81-3.52,1.8h-35.42c-2.32,0-4.2-1.76-4.2-3.94v-15.36h-3.21c-2.15,0-4.21-.8-5.79-2.26-1.53-1.4-2.41-3.38-2.42-5.45,.03-.69,.61-1.23,1.3-1.21h65.9c3.32,.02,5.32,3.47,3.53,6.08Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1836.96,
    cy: 511.54,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1557.92,
    cy: 573.69,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1586.4,
    cy: 573.69,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1610.63,544.78l-16.17,20.33c-.8,1.15-2.12,1.83-3.52,1.82h-35.41c-2.32,0-4.19-1.76-4.19-3.94v-15.37h-3.22c-2.15,0-4.22-.8-5.8-2.26-1.53-1.4-2.41-3.38-2.42-5.45,.03-.69,.61-1.23,1.3-1.21h65.91c3.32,.02,5.32,3.47,3.53,6.08Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1643.7,
    cy: 560.1,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1742.66,543.88v28.68c0,2.73-2.32,4.99-5.15,4.99h-67.79c-1.2,.02-2.2-.94-2.22-2.14v-1.01c0-6.21,4.39-11.47,10.33-13.02v-17.5c0-2.73,2.31-4.99,5.15-4.99h54.55c2.81,0,5.13,2.24,5.13,4.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1792.59,560.14c0,9.6-7.87,17.41-17.53,17.41s-17.53-7.79-17.53-17.41,7.87-17.41,17.53-17.41,17.53,7.81,17.53,17.41Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1817.06,
    cy: 573.69,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1845.54,
    cy: 573.69,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1869.78,544.78l-16.17,20.33c-.8,1.15-2.12,1.83-3.52,1.82h-35.42c-2.32,0-4.19-1.76-4.19-3.94v-15.37h-3.21c-2.15,0-4.22-.8-5.8-2.26-1.53-1.4-2.41-3.38-2.42-5.45,.03-.69,.61-1.23,1.3-1.21h65.9c3.33,.02,5.32,3.47,3.53,6.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1549.4,592.45v28.68c0,2.73-2.31,4.99-5.15,4.99h-67.79c-1.2,.02-2.19-.94-2.22-2.14v-1c0-6.21,4.39-11.48,10.33-13.02v-17.5c0-2.73,2.32-4.99,5.15-4.99h54.55c2.82,0,5.13,2.24,5.13,4.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1599.32,608.7c0,9.6-7.87,17.41-17.53,17.41s-17.53-7.79-17.53-17.41,7.87-17.41,17.53-17.41,17.53,7.81,17.53,17.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1676.51,593.35l-16.17,20.33c-.8,1.15-2.12,1.83-3.52,1.82h-35.41c-2.32,0-4.19-1.76-4.19-3.94v-15.37h-3.22c-2.15,0-4.23-.81-5.8-2.27-1.53-1.4-2.41-3.37-2.42-5.44,.03-.69,.61-1.23,1.3-1.21h65.9c3.32,.02,5.32,3.46,3.53,6.08Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1709.57,
    cy: 608.67,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1808.54,592.45v28.68c0,2.73-2.32,4.99-5.15,4.99h-67.79c-1.2,.02-2.2-.94-2.22-2.14v-1c0-6.21,4.39-11.48,10.33-13.02v-17.5c0-2.73,2.31-4.99,5.15-4.99h54.55c2.81,0,5.13,2.24,5.13,4.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1858.46,608.7c0,9.6-7.87,17.41-17.53,17.41s-17.53-7.79-17.53-17.41,7.87-17.41,17.53-17.41,17.53,7.81,17.53,17.41Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1832.48,
    cy: 317.27,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1931.44,301.05v28.68c0,2.73-2.32,4.99-5.15,4.99h-67.79c-1.2,.02-2.2-.94-2.22-2.14v-1c0-6.21,4.39-11.47,10.33-13.02v-17.5c0-2.73,2.32-4.99,5.15-4.99h54.55c2.82,0,5.13,2.23,5.13,4.99Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1812.57,
    cy: 379.43,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1841.05,
    cy: 379.43,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1865.29,350.51l-16.17,20.34c-.81,1.14-2.12,1.81-3.52,1.8h-35.42c-2.32,0-4.19-1.76-4.19-3.94v-15.35h-3.21c-2.15,0-4.22-.8-5.8-2.26-1.53-1.4-2.41-3.37-2.42-5.44,.03-.69,.61-1.23,1.3-1.21h65.9c3.32,0,5.32,3.45,3.53,6.07Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1898.35,
    cy: 365.84,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1853.98,414.44c0,9.6-7.87,17.41-17.53,17.41s-17.53-7.79-17.53-17.41,7.87-17.4,17.53-17.4,17.53,7.8,17.53,17.4Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1878.45,
    cy: 427.99,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1906.93,
    cy: 427.99,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1931.16,399.08l-16.17,20.33c-.81,1.14-2.12,1.82-3.52,1.8h-35.42c-2.32,0-4.19-1.76-4.19-3.94v-15.36h-3.21c-2.15,0-4.22-.8-5.79-2.26-1.53-1.4-2.41-3.38-2.42-5.45,.03-.69,.61-1.23,1.3-1.21h65.9c3.33,.02,5.32,3.47,3.53,6.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1869.93,446.75v28.68c0,2.73-2.31,4.99-5.15,4.99h-67.79c-1.2,.02-2.2-.94-2.22-2.14v-1.01c0-6.21,4.39-11.47,10.33-13.02v-17.5c0-2.73,2.32-4.99,5.15-4.99h54.55c2.79-.03,5.08,2.2,5.13,4.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1919.85,463.01c0,9.6-7.87,17.41-17.53,17.41s-17.53-7.79-17.53-17.41,7.87-17.41,17.53-17.41,17.53,7.81,17.53,17.41Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1836.84,
    cy: 511.54,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1935.8,495.31v28.68c0,2.73-2.31,4.99-5.15,4.99h-67.79c-1.2,.02-2.2-.94-2.22-2.14h0v-1c0-6.21,4.39-11.48,10.33-13.02v-17.5c0-2.73,2.32-4.99,5.15-4.99h54.55c2.82,0,5.13,2.24,5.13,4.99Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1816.94,
    cy: 573.69,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1845.42,
    cy: 573.69,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1869.65,544.78l-16.17,20.33c-.8,1.15-2.12,1.83-3.52,1.82h-35.41c-2.32,0-4.19-1.76-4.19-3.94v-15.37h-3.22c-2.15,0-4.22-.8-5.8-2.26-1.53-1.4-2.41-3.38-2.42-5.45,.03-.69,.61-1.23,1.3-1.21h65.91c3.32,.02,5.32,3.47,3.53,6.08Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1902.72,
    cy: 560.1,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1808.41,592.45v28.68c0,2.73-2.31,4.99-5.15,4.99h-67.79c-1.2,.02-2.19-.94-2.22-2.14v-1c0-6.21,4.39-11.48,10.33-13.02v-17.5c0-2.73,2.32-4.99,5.15-4.99h54.55c2.82,0,5.13,2.24,5.13,4.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1858.34,608.7c0,9.6-7.87,17.41-17.53,17.41s-17.53-7.79-17.53-17.41,7.87-17.41,17.53-17.41,17.53,7.81,17.53,17.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1935.53,593.35l-16.17,20.33c-.8,1.15-2.12,1.83-3.52,1.82h-35.41c-2.32,0-4.19-1.76-4.19-3.94v-15.37h-3.22c-2.15,0-4.23-.81-5.8-2.27-1.53-1.4-2.41-3.37-2.42-5.44,.03-.69,.61-1.23,1.3-1.21h65.9c3.32,.02,5.32,3.46,3.53,6.08Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 932.63,
    cy: 608.44,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1031.6,592.21v28.68c0,2.73-2.32,4.99-5.15,4.99h-67.79c-1.2,.02-2.2-.94-2.22-2.14v-1c0-6.21,4.39-11.47,10.33-13.02v-17.5c0-2.73,2.32-4.99,5.15-4.99h54.55c2.82,0,5.13,2.23,5.13,4.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1081.52,608.47c0,9.6-7.87,17.41-17.53,17.41s-17.53-7.79-17.53-17.41,7.87-17.41,17.53-17.41,17.53,7.81,17.53,17.41Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1106,
    cy: 622.02,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1134.48,
    cy: 622.02,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1158.71,593.11l-16.17,20.33c-.8,1.15-2.12,1.83-3.52,1.82h-35.42c-2.32,0-4.19-1.76-4.19-3.94v-15.37h-3.21c-2.15,0-4.22-.8-5.8-2.26-1.53-1.4-2.41-3.36-2.42-5.43,.03-.69,.61-1.23,1.3-1.21h65.9c3.32-.02,5.32,3.44,3.53,6.06Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1191.78,
    cy: 608.44,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 912.73,
    cy: 670.59,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 941.21,
    cy: 670.59,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M965.45,641.68l-16.17,20.34c-.81,1.14-2.12,1.81-3.52,1.8h-35.42c-2.32,0-4.19-1.76-4.19-3.94v-15.35h-3.21c-2.15,0-4.22-.8-5.8-2.26-1.53-1.4-2.41-3.37-2.42-5.44,.03-.69,.61-1.23,1.3-1.21h65.9c3.32,0,5.32,3.45,3.53,6.07Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 998.51,
    cy: 657,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1097.47,640.78v28.68c0,2.73-2.31,4.99-5.15,4.99h-67.79c-1.2,.02-2.19-.94-2.22-2.14v-1.01c0-6.21,4.39-11.47,10.33-13.02v-17.5c0-2.73,2.32-4.99,5.15-4.99h54.56c2.79-.02,5.07,2.2,5.12,4.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1147.4,657.04c0,9.6-7.87,17.41-17.53,17.41s-17.52-7.79-17.52-17.41,7.87-17.41,17.53-17.41,17.52,7.81,17.52,17.41Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1171.87,
    cy: 670.59,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1200.35,
    cy: 670.59,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1224.59,641.68l-16.17,20.34c-.81,1.14-2.12,1.81-3.52,1.8h-35.42c-2.32,0-4.19-1.76-4.19-3.94v-15.35h-3.21c-2.15,0-4.22-.8-5.8-2.26-1.53-1.4-2.41-3.37-2.42-5.44,.03-.69,.61-1.23,1.3-1.21h65.9c3.33,0,5.33,3.45,3.53,6.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M954.13,705.6c0,9.6-7.87,17.41-17.53,17.41s-17.53-7.79-17.53-17.41,7.87-17.4,17.53-17.4,17.53,7.8,17.53,17.4Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 978.61,
    cy: 719.16,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1007.09,
    cy: 719.16,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1031.32,690.25l-16.17,20.33c-.81,1.14-2.12,1.82-3.52,1.8h-35.42c-2.32,0-4.19-1.76-4.19-3.94v-15.36h-3.21c-2.15,0-4.22-.8-5.79-2.26-1.53-1.4-2.41-3.38-2.42-5.45,.03-.69,.61-1.23,1.3-1.21h65.9c3.33,.02,5.32,3.47,3.53,6.08Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1064.39,
    cy: 705.57,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1163.35,689.35v28.68c0,2.73-2.32,4.99-5.15,4.99h-67.79c-1.2,.02-2.2-.94-2.22-2.14v-1c0-6.21,4.39-11.48,10.33-13.02v-17.5c0-2.73,2.32-4.99,5.15-4.99h54.55c2.81,0,5.13,2.24,5.13,4.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1213.27,705.6c0,9.6-7.87,17.41-17.53,17.41s-17.53-7.79-17.53-17.41,7.87-17.41,17.53-17.41,17.53,7.81,17.53,17.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M970.08,737.91v28.68c0,2.73-2.31,4.99-5.15,4.99h-67.79c-1.2,.02-2.2-.94-2.22-2.14v-1.01c0-6.21,4.39-11.47,10.33-13.02v-17.5c0-2.73,2.32-4.99,5.15-4.99h54.55c2.79-.03,5.08,2.2,5.13,4.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1020.01,754.17c0,9.6-7.87,17.41-17.53,17.41s-17.53-7.79-17.53-17.41,7.87-17.41,17.53-17.41,17.53,7.81,17.53,17.41Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1044.48,
    cy: 767.72,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1072.96,
    cy: 767.72,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1097.2,738.81l-16.17,20.33c-.81,1.14-2.12,1.81-3.52,1.8h-35.42c-2.32,0-4.19-1.76-4.19-3.94v-15.35h-3.21c-2.15,0-4.22-.8-5.8-2.27-1.53-1.4-2.41-3.37-2.42-5.44,.03-.69,.61-1.23,1.3-1.21h65.9c3.32,0,5.32,3.46,3.53,6.07Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1130.27,
    cy: 754.14,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1229.23,737.91v28.68c0,2.73-2.32,4.99-5.15,4.99h-67.79c-1.2,.02-2.2-.94-2.22-2.14v-1.01c0-6.21,4.39-11.47,10.33-13.02v-17.5c0-2.73,2.31-4.99,5.15-4.99h54.56c2.8,0,5.12,2.24,5.12,4.99Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 937,
    cy: 802.7,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1035.96,786.48v28.68c0,2.73-2.31,4.99-5.15,4.99h-67.79c-1.2,.02-2.2-.94-2.22-2.14h0v-1c0-6.21,4.39-11.48,10.33-13.02v-17.5c0-2.73,2.32-4.99,5.15-4.99h54.55c2.82,0,5.13,2.24,5.13,4.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1085.88,802.73c0,9.6-7.87,17.41-17.53,17.41s-17.53-7.79-17.53-17.41,7.87-17.41,17.53-17.41,17.53,7.81,17.53,17.41Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1110.36,
    cy: 816.29,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1138.84,
    cy: 816.29,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1163.07,787.38l-16.17,20.33c-.81,1.14-2.12,1.81-3.52,1.8h-35.42c-2.32,0-4.2-1.76-4.2-3.94v-15.36h-3.21c-2.15,0-4.21-.8-5.79-2.26-1.53-1.4-2.41-3.38-2.42-5.45,.03-.69,.61-1.23,1.3-1.21h65.9c3.32,.02,5.32,3.47,3.53,6.08Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1196.14,
    cy: 802.7,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 917.09,
    cy: 864.85,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 945.57,
    cy: 864.85,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M969.81,835.94l-16.17,20.33c-.8,1.15-2.12,1.83-3.52,1.82h-35.41c-2.32,0-4.19-1.76-4.19-3.94v-15.37h-3.22c-2.15,0-4.22-.8-5.8-2.26-1.53-1.4-2.41-3.38-2.42-5.45,.03-.69,.61-1.23,1.3-1.21h65.91c3.32,.02,5.32,3.47,3.53,6.08Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1002.88,
    cy: 851.26,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1101.84,835.04v28.68c0,2.73-2.32,4.99-5.15,4.99h-67.79c-1.2,.02-2.2-.94-2.22-2.14v-1.01c0-6.21,4.39-11.47,10.33-13.02v-17.5c0-2.73,2.31-4.99,5.15-4.99h54.55c2.81,0,5.13,2.24,5.13,4.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1151.76,851.3c0,9.6-7.87,17.41-17.53,17.41s-17.53-7.79-17.53-17.41,7.87-17.41,17.53-17.41,17.53,7.81,17.53,17.41Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1176.24,
    cy: 864.85,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1204.71,
    cy: 864.85,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1228.95,835.94l-16.17,20.33c-.8,1.15-2.12,1.83-3.52,1.82h-35.42c-2.32,0-4.19-1.76-4.19-3.94v-15.37h-3.21c-2.15,0-4.22-.8-5.8-2.26-1.53-1.4-2.41-3.38-2.42-5.45,.03-.69,.61-1.23,1.3-1.21h65.9c3.33,.02,5.32,3.47,3.53,6.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M908.57,883.61v28.68c0,2.73-2.31,4.99-5.15,4.99h-67.79c-1.2,.02-2.19-.94-2.22-2.14v-1c0-6.21,4.39-11.48,10.33-13.02v-17.5c0-2.73,2.32-4.99,5.15-4.99h54.55c2.82,0,5.13,2.24,5.13,4.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M958.49,899.86c0,9.6-7.87,17.41-17.53,17.41s-17.53-7.79-17.53-17.41,7.87-17.41,17.53-17.41,17.53,7.81,17.53,17.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1035.68,884.51l-16.17,20.33c-.8,1.15-2.12,1.83-3.52,1.82h-35.41c-2.32,0-4.19-1.76-4.19-3.94v-15.37h-3.22c-2.15,0-4.23-.81-5.8-2.27-1.53-1.4-2.41-3.37-2.42-5.44,.03-.69,.61-1.23,1.3-1.21h65.9c3.32,.02,5.32,3.46,3.53,6.08Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1068.75,
    cy: 899.83,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1167.71,883.61v28.68c0,2.73-2.32,4.99-5.15,4.99h-67.79c-1.2,.02-2.2-.94-2.22-2.14v-1c0-6.21,4.39-11.48,10.33-13.02v-17.5c0-2.73,2.31-4.99,5.15-4.99h54.55c2.81,0,5.13,2.24,5.13,4.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1217.64,899.86c0,9.6-7.87,17.41-17.53,17.41s-17.53-7.79-17.53-17.41,7.87-17.41,17.53-17.41,17.53,7.81,17.53,17.41Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1191.65,
    cy: 608.44,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1290.62,592.21v28.68c0,2.73-2.32,4.99-5.15,4.99h-67.79c-1.2,.02-2.2-.94-2.22-2.14v-1c0-6.21,4.39-11.47,10.33-13.02v-17.5c0-2.73,2.32-4.99,5.15-4.99h54.55c2.82,0,5.13,2.23,5.13,4.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1340.54,608.47c0,9.6-7.87,17.41-17.53,17.41s-17.53-7.79-17.53-17.41,7.87-17.41,17.53-17.41,17.53,7.81,17.53,17.41Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1365.01,
    cy: 622.02,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1393.49,
    cy: 622.02,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1417.73,593.11l-16.17,20.33c-.8,1.15-2.12,1.83-3.52,1.82h-35.42c-2.32,0-4.19-1.76-4.19-3.94v-15.37h-3.21c-2.15,0-4.22-.8-5.8-2.26-1.53-1.4-2.41-3.36-2.42-5.43,.03-.69,.61-1.23,1.3-1.21h65.9c3.32-.02,5.32,3.44,3.53,6.06Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1450.8,
    cy: 608.44,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1171.75,
    cy: 670.59,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1200.23,
    cy: 670.59,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1224.46,641.68l-16.17,20.34c-.81,1.14-2.12,1.81-3.52,1.8h-35.42c-2.32,0-4.19-1.76-4.19-3.94v-15.35h-3.21c-2.15,0-4.22-.8-5.8-2.26-1.53-1.4-2.41-3.37-2.42-5.44,.03-.69,.61-1.23,1.3-1.21h65.9c3.32,0,5.32,3.45,3.53,6.07Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1257.53,
    cy: 657,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1356.49,640.78v28.68c0,2.73-2.31,4.99-5.15,4.99h-67.79c-1.2,.02-2.19-.94-2.22-2.14v-1.01c0-6.21,4.39-11.47,10.33-13.02v-17.5c0-2.73,2.32-4.99,5.15-4.99h54.56c2.79-.02,5.07,2.2,5.12,4.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1406.41,657.04c0,9.6-7.87,17.41-17.53,17.41s-17.52-7.79-17.52-17.41,7.87-17.41,17.53-17.41,17.52,7.81,17.52,17.41Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1430.89,
    cy: 670.59,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1459.37,
    cy: 670.59,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1483.6,641.68l-16.17,20.34c-.81,1.14-2.12,1.81-3.52,1.8h-35.42c-2.32,0-4.19-1.76-4.19-3.94v-15.35h-3.21c-2.15,0-4.22-.8-5.8-2.26-1.53-1.4-2.41-3.37-2.42-5.44,.03-.69,.61-1.23,1.3-1.21h65.9c3.33,0,5.33,3.45,3.53,6.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1213.15,705.6c0,9.6-7.87,17.41-17.53,17.41s-17.53-7.79-17.53-17.41,7.87-17.4,17.53-17.4,17.53,7.8,17.53,17.4Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1237.63,
    cy: 719.16,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1266.1,
    cy: 719.16,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1290.34,690.25l-16.17,20.33c-.81,1.14-2.12,1.82-3.52,1.8h-35.42c-2.32,0-4.19-1.76-4.19-3.94v-15.36h-3.21c-2.15,0-4.22-.8-5.79-2.26-1.53-1.4-2.41-3.38-2.42-5.45,.03-.69,.61-1.23,1.3-1.21h65.9c3.33,.02,5.32,3.47,3.53,6.08Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1323.41,
    cy: 705.57,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1422.37,689.35v28.68c0,2.73-2.32,4.99-5.15,4.99h-67.79c-1.2,.02-2.2-.94-2.22-2.14v-1c0-6.21,4.39-11.48,10.33-13.02v-17.5c0-2.73,2.32-4.99,5.15-4.99h54.55c2.81,0,5.13,2.24,5.13,4.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1472.29,705.6c0,9.6-7.87,17.41-17.53,17.41s-17.53-7.79-17.53-17.41,7.87-17.41,17.53-17.41,17.53,7.81,17.53,17.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1229.1,737.91v28.68c0,2.73-2.31,4.99-5.15,4.99h-67.79c-1.2,.02-2.2-.94-2.22-2.14v-1.01c0-6.21,4.39-11.47,10.33-13.02v-17.5c0-2.73,2.32-4.99,5.15-4.99h54.55c2.79-.03,5.08,2.2,5.13,4.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1279.03,754.17c0,9.6-7.87,17.41-17.53,17.41s-17.53-7.79-17.53-17.41,7.87-17.41,17.53-17.41,17.53,7.81,17.53,17.41Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1303.5,
    cy: 767.72,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1331.98,
    cy: 767.72,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1356.22,738.81l-16.17,20.33c-.81,1.14-2.12,1.81-3.52,1.8h-35.42c-2.32,0-4.19-1.76-4.19-3.94v-15.35h-3.21c-2.15,0-4.22-.8-5.8-2.27-1.53-1.4-2.41-3.37-2.42-5.44,.03-.69,.61-1.23,1.3-1.21h65.9c3.32,0,5.32,3.46,3.53,6.07Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1389.28,
    cy: 754.14,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1488.24,737.91v28.68c0,2.73-2.32,4.99-5.15,4.99h-67.79c-1.2,.02-2.2-.94-2.22-2.14v-1.01c0-6.21,4.39-11.47,10.33-13.02v-17.5c0-2.73,2.31-4.99,5.15-4.99h54.56c2.8,0,5.12,2.24,5.12,4.99Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1196.02,
    cy: 802.7,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1294.98,786.48v28.68c0,2.73-2.31,4.99-5.15,4.99h-67.79c-1.2,.02-2.2-.94-2.22-2.14h0v-1c0-6.21,4.39-11.48,10.33-13.02v-17.5c0-2.73,2.32-4.99,5.15-4.99h54.55c2.82,0,5.13,2.24,5.13,4.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1344.9,802.73c0,9.6-7.87,17.41-17.53,17.41s-17.53-7.79-17.53-17.41,7.87-17.41,17.53-17.41,17.53,7.81,17.53,17.41Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1369.38,
    cy: 816.29,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1397.86,
    cy: 816.29,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1422.09,787.38l-16.17,20.33c-.81,1.14-2.12,1.81-3.52,1.8h-35.42c-2.32,0-4.2-1.76-4.2-3.94v-15.36h-3.21c-2.15,0-4.21-.8-5.79-2.26-1.53-1.4-2.41-3.38-2.42-5.45,.03-.69,.61-1.23,1.3-1.21h65.9c3.32,.02,5.32,3.47,3.53,6.08Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1455.16,
    cy: 802.7,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1176.11,
    cy: 864.85,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1204.59,
    cy: 864.85,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1228.83,835.94l-16.17,20.33c-.8,1.15-2.12,1.83-3.52,1.82h-35.41c-2.32,0-4.19-1.76-4.19-3.94v-15.37h-3.22c-2.15,0-4.22-.8-5.8-2.26-1.53-1.4-2.41-3.38-2.42-5.45,.03-.69,.61-1.23,1.3-1.21h65.91c3.32,.02,5.32,3.47,3.53,6.08Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1261.89,
    cy: 851.26,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1360.85,835.04v28.68c0,2.73-2.32,4.99-5.15,4.99h-67.79c-1.2,.02-2.2-.94-2.22-2.14v-1.01c0-6.21,4.39-11.47,10.33-13.02v-17.5c0-2.73,2.31-4.99,5.15-4.99h54.55c2.81,0,5.13,2.24,5.13,4.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1410.78,851.3c0,9.6-7.87,17.41-17.53,17.41s-17.53-7.79-17.53-17.41,7.87-17.41,17.53-17.41,17.53,7.81,17.53,17.41Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1435.26,
    cy: 864.85,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1463.73,
    cy: 864.85,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1487.97,835.94l-16.17,20.33c-.8,1.15-2.12,1.83-3.52,1.82h-35.42c-2.32,0-4.19-1.76-4.19-3.94v-15.37h-3.21c-2.15,0-4.22-.8-5.8-2.26-1.53-1.4-2.41-3.38-2.42-5.45,.03-.69,.61-1.23,1.3-1.21h65.9c3.33,.02,5.32,3.47,3.53,6.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1167.59,883.61v28.68c0,2.73-2.31,4.99-5.15,4.99h-67.79c-1.2,.02-2.19-.94-2.22-2.14v-1c0-6.21,4.39-11.48,10.33-13.02v-17.5c0-2.73,2.32-4.99,5.15-4.99h54.55c2.82,0,5.13,2.24,5.13,4.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1217.51,899.86c0,9.6-7.87,17.41-17.53,17.41s-17.53-7.79-17.53-17.41,7.87-17.41,17.53-17.41,17.53,7.81,17.53,17.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1294.7,884.51l-16.17,20.33c-.8,1.15-2.12,1.83-3.52,1.82h-35.41c-2.32,0-4.19-1.76-4.19-3.94v-15.37h-3.22c-2.15,0-4.23-.81-5.8-2.27-1.53-1.4-2.41-3.37-2.42-5.44,.03-.69,.61-1.23,1.3-1.21h65.9c3.32,.02,5.32,3.46,3.53,6.08Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1327.77,
    cy: 899.83,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1426.73,883.61v28.68c0,2.73-2.32,4.99-5.15,4.99h-67.79c-1.2,.02-2.2-.94-2.22-2.14v-1c0-6.21,4.39-11.48,10.33-13.02v-17.5c0-2.73,2.31-4.99,5.15-4.99h54.55c2.81,0,5.13,2.24,5.13,4.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1476.66,899.86c0,9.6-7.87,17.41-17.53,17.41s-17.53-7.79-17.53-17.41,7.87-17.41,17.53-17.41,17.53,7.81,17.53,17.41Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1450.67,
    cy: 608.44,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1549.63,592.21v28.68c0,2.73-2.32,4.99-5.15,4.99h-67.79c-1.2,.02-2.2-.94-2.22-2.14v-1c0-6.21,4.39-11.47,10.33-13.02v-17.5c0-2.73,2.32-4.99,5.15-4.99h54.55c2.82,0,5.13,2.23,5.13,4.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1599.56,608.47c0,9.6-7.87,17.41-17.53,17.41s-17.53-7.79-17.53-17.41,7.87-17.41,17.53-17.41,17.53,7.81,17.53,17.41Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1624.03,
    cy: 622.02,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1652.51,
    cy: 622.02,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1676.75,593.11l-16.17,20.33c-.8,1.15-2.12,1.83-3.52,1.82h-35.42c-2.32,0-4.19-1.76-4.19-3.94v-15.37h-3.21c-2.15,0-4.22-.8-5.8-2.26-1.53-1.4-2.41-3.36-2.42-5.43,.03-.69,.61-1.23,1.3-1.21h65.9c3.32-.02,5.32,3.44,3.53,6.06Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1709.81,
    cy: 608.44,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1430.77,
    cy: 670.59,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1459.25,
    cy: 670.59,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1483.48,641.68l-16.17,20.34c-.81,1.14-2.12,1.81-3.52,1.8h-35.42c-2.32,0-4.19-1.76-4.19-3.94v-15.35h-3.21c-2.15,0-4.22-.8-5.8-2.26-1.53-1.4-2.41-3.37-2.42-5.44,.03-.69,.61-1.23,1.3-1.21h65.9c3.32,0,5.32,3.45,3.53,6.07Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1516.55,
    cy: 657,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1615.51,640.78v28.68c0,2.73-2.31,4.99-5.15,4.99h-67.79c-1.2,.02-2.19-.94-2.22-2.14v-1.01c0-6.21,4.39-11.47,10.33-13.02v-17.5c0-2.73,2.32-4.99,5.15-4.99h54.56c2.79-.02,5.07,2.2,5.12,4.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1665.43,657.04c0,9.6-7.87,17.41-17.53,17.41s-17.52-7.79-17.52-17.41,7.87-17.41,17.53-17.41,17.52,7.81,17.52,17.41Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1689.91,
    cy: 670.59,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1718.39,
    cy: 670.59,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1742.62,641.68l-16.17,20.34c-.81,1.14-2.12,1.81-3.52,1.8h-35.42c-2.32,0-4.19-1.76-4.19-3.94v-15.35h-3.21c-2.15,0-4.22-.8-5.8-2.26-1.53-1.4-2.41-3.37-2.42-5.44,.03-.69,.61-1.23,1.3-1.21h65.9c3.33,0,5.33,3.45,3.53,6.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1472.17,705.6c0,9.6-7.87,17.41-17.53,17.41s-17.53-7.79-17.53-17.41,7.87-17.4,17.53-17.4,17.53,7.8,17.53,17.4Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1496.65,
    cy: 719.16,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1525.12,
    cy: 719.16,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1549.36,690.25l-16.17,20.33c-.81,1.14-2.12,1.82-3.52,1.8h-35.42c-2.32,0-4.19-1.76-4.19-3.94v-15.36h-3.21c-2.15,0-4.22-.8-5.79-2.26-1.53-1.4-2.41-3.38-2.42-5.45,.03-.69,.61-1.23,1.3-1.21h65.9c3.33,.02,5.32,3.47,3.53,6.08Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1582.42,
    cy: 705.57,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1681.39,689.35v28.68c0,2.73-2.32,4.99-5.15,4.99h-67.79c-1.2,.02-2.2-.94-2.22-2.14v-1c0-6.21,4.39-11.48,10.33-13.02v-17.5c0-2.73,2.32-4.99,5.15-4.99h54.55c2.81,0,5.13,2.24,5.13,4.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1731.31,705.6c0,9.6-7.87,17.41-17.53,17.41s-17.53-7.79-17.53-17.41,7.87-17.41,17.53-17.41,17.53,7.81,17.53,17.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1488.12,737.91v28.68c0,2.73-2.31,4.99-5.15,4.99h-67.79c-1.2,.02-2.2-.94-2.22-2.14v-1.01c0-6.21,4.39-11.47,10.33-13.02v-17.5c0-2.73,2.32-4.99,5.15-4.99h54.55c2.79-.03,5.08,2.2,5.13,4.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1538.04,754.17c0,9.6-7.87,17.41-17.53,17.41s-17.53-7.79-17.53-17.41,7.87-17.41,17.53-17.41,17.53,7.81,17.53,17.41Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1562.52,
    cy: 767.72,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1591,
    cy: 767.72,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1615.24,738.81l-16.17,20.33c-.81,1.14-2.12,1.81-3.52,1.8h-35.42c-2.32,0-4.19-1.76-4.19-3.94v-15.35h-3.21c-2.15,0-4.22-.8-5.8-2.27-1.53-1.4-2.41-3.37-2.42-5.44,.03-.69,.61-1.23,1.3-1.21h65.9c3.32,0,5.32,3.46,3.53,6.07Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1648.3,
    cy: 754.14,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1747.26,737.91v28.68c0,2.73-2.32,4.99-5.15,4.99h-67.79c-1.2,.02-2.2-.94-2.22-2.14v-1.01c0-6.21,4.39-11.47,10.33-13.02v-17.5c0-2.73,2.31-4.99,5.15-4.99h54.56c2.8,0,5.12,2.24,5.12,4.99Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1455.03,
    cy: 802.7,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1554,786.48v28.68c0,2.73-2.31,4.99-5.15,4.99h-67.79c-1.2,.02-2.2-.94-2.22-2.14h0v-1c0-6.21,4.39-11.48,10.33-13.02v-17.5c0-2.73,2.32-4.99,5.15-4.99h54.55c2.82,0,5.13,2.24,5.13,4.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1603.92,802.73c0,9.6-7.87,17.41-17.53,17.41s-17.53-7.79-17.53-17.41,7.87-17.41,17.53-17.41,17.53,7.81,17.53,17.41Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1628.4,
    cy: 816.29,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1656.87,
    cy: 816.29,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1681.11,787.38l-16.17,20.33c-.81,1.14-2.12,1.81-3.52,1.8h-35.42c-2.32,0-4.2-1.76-4.2-3.94v-15.36h-3.21c-2.15,0-4.21-.8-5.79-2.26-1.53-1.4-2.41-3.38-2.42-5.45,.03-.69,.61-1.23,1.3-1.21h65.9c3.32,.02,5.32,3.47,3.53,6.08Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1714.18,
    cy: 802.7,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1435.13,
    cy: 864.85,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1463.61,
    cy: 864.85,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1487.84,835.94l-16.17,20.33c-.8,1.15-2.12,1.83-3.52,1.82h-35.41c-2.32,0-4.19-1.76-4.19-3.94v-15.37h-3.22c-2.15,0-4.22-.8-5.8-2.26-1.53-1.4-2.41-3.38-2.42-5.45,.03-.69,.61-1.23,1.3-1.21h65.91c3.32,.02,5.32,3.47,3.53,6.08Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1520.91,
    cy: 851.26,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1619.87,835.04v28.68c0,2.73-2.32,4.99-5.15,4.99h-67.79c-1.2,.02-2.2-.94-2.22-2.14v-1.01c0-6.21,4.39-11.47,10.33-13.02v-17.5c0-2.73,2.31-4.99,5.15-4.99h54.55c2.81,0,5.13,2.24,5.13,4.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1669.8,851.3c0,9.6-7.87,17.41-17.53,17.41s-17.53-7.79-17.53-17.41,7.87-17.41,17.53-17.41,17.53,7.81,17.53,17.41Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1694.27,
    cy: 864.85,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1722.75,
    cy: 864.85,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1746.99,835.94l-16.17,20.33c-.8,1.15-2.12,1.83-3.52,1.82h-35.42c-2.32,0-4.19-1.76-4.19-3.94v-15.37h-3.21c-2.15,0-4.22-.8-5.8-2.26-1.53-1.4-2.41-3.38-2.42-5.45,.03-.69,.61-1.23,1.3-1.21h65.9c3.33,.02,5.32,3.47,3.53,6.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1426.61,883.61v28.68c0,2.73-2.31,4.99-5.15,4.99h-67.79c-1.2,.02-2.19-.94-2.22-2.14v-1c0-6.21,4.39-11.48,10.33-13.02v-17.5c0-2.73,2.32-4.99,5.15-4.99h54.55c2.82,0,5.13,2.24,5.13,4.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1476.53,899.86c0,9.6-7.87,17.41-17.53,17.41s-17.53-7.79-17.53-17.41,7.87-17.41,17.53-17.41,17.53,7.81,17.53,17.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1553.72,884.51l-16.17,20.33c-.8,1.15-2.12,1.83-3.52,1.82h-35.41c-2.32,0-4.19-1.76-4.19-3.94v-15.37h-3.22c-2.15,0-4.23-.81-5.8-2.27-1.53-1.4-2.41-3.37-2.42-5.44,.03-.69,.61-1.23,1.3-1.21h65.9c3.32,.02,5.32,3.46,3.53,6.08Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1586.79,
    cy: 899.83,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1685.75,883.61v28.68c0,2.73-2.32,4.99-5.15,4.99h-67.79c-1.2,.02-2.2-.94-2.22-2.14v-1c0-6.21,4.39-11.48,10.33-13.02v-17.5c0-2.73,2.31-4.99,5.15-4.99h54.55c2.81,0,5.13,2.24,5.13,4.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1735.67,899.86c0,9.6-7.87,17.41-17.53,17.41s-17.53-7.79-17.53-17.41,7.87-17.41,17.53-17.41,17.53,7.81,17.53,17.41Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1709.69,
    cy: 608.44,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1808.65,592.21v28.68c0,2.73-2.32,4.99-5.15,4.99h-67.79c-1.2,.02-2.2-.94-2.22-2.14v-1c0-6.21,4.39-11.47,10.33-13.02v-17.5c0-2.73,2.32-4.99,5.15-4.99h54.55c2.82,0,5.13,2.23,5.13,4.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1858.58,608.47c0,9.6-7.87,17.41-17.53,17.41s-17.53-7.79-17.53-17.41,7.87-17.41,17.53-17.41,17.53,7.81,17.53,17.41Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1883.05,
    cy: 622.02,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1911.53,
    cy: 622.02,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1935.76,593.11l-16.17,20.33c-.8,1.15-2.12,1.83-3.52,1.82h-35.42c-2.32,0-4.19-1.76-4.19-3.94v-15.37h-3.21c-2.15,0-4.22-.8-5.8-2.26-1.53-1.4-2.41-3.36-2.42-5.43,.03-.69,.61-1.23,1.3-1.21h65.9c3.32-.02,5.32,3.44,3.53,6.06Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1689.79,
    cy: 670.59,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1718.26,
    cy: 670.59,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1742.5,641.68l-16.17,20.34c-.81,1.14-2.12,1.81-3.52,1.8h-35.42c-2.32,0-4.19-1.76-4.19-3.94v-15.35h-3.21c-2.15,0-4.22-.8-5.8-2.26-1.53-1.4-2.41-3.37-2.42-5.44,.03-.69,.61-1.23,1.3-1.21h65.9c3.32,0,5.32,3.45,3.53,6.07Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1775.57,
    cy: 657,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1874.53,640.78v28.68c0,2.73-2.31,4.99-5.15,4.99h-67.79c-1.2,.02-2.19-.94-2.22-2.14v-1.01c0-6.21,4.39-11.47,10.33-13.02v-17.5c0-2.73,2.32-4.99,5.15-4.99h54.56c2.79-.02,5.07,2.2,5.12,4.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1924.45,657.04c0,9.6-7.87,17.41-17.53,17.41s-17.52-7.79-17.52-17.41,7.87-17.41,17.53-17.41,17.52,7.81,17.52,17.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1731.19,705.6c0,9.6-7.87,17.41-17.53,17.41s-17.53-7.79-17.53-17.41,7.87-17.4,17.53-17.4,17.53,7.8,17.53,17.4Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1755.66,
    cy: 719.16,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1784.14,
    cy: 719.16,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1808.37,690.25l-16.17,20.33c-.81,1.14-2.12,1.82-3.52,1.8h-35.42c-2.32,0-4.19-1.76-4.19-3.94v-15.36h-3.21c-2.15,0-4.22-.8-5.79-2.26-1.53-1.4-2.41-3.38-2.42-5.45,.03-.69,.61-1.23,1.3-1.21h65.9c3.33,.02,5.32,3.47,3.53,6.08Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1841.44,
    cy: 705.57,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1940.4,689.35v28.68c0,2.73-2.32,4.99-5.15,4.99h-67.79c-1.2,.02-2.2-.94-2.22-2.14v-1c0-6.21,4.39-11.48,10.33-13.02v-17.5c0-2.73,2.32-4.99,5.15-4.99h54.55c2.81,0,5.13,2.24,5.13,4.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1747.14,737.91v28.68c0,2.73-2.31,4.99-5.15,4.99h-67.79c-1.2,.02-2.2-.94-2.22-2.14v-1.01c0-6.21,4.39-11.47,10.33-13.02v-17.5c0-2.73,2.32-4.99,5.15-4.99h54.55c2.79-.03,5.08,2.2,5.13,4.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1797.06,754.17c0,9.6-7.87,17.41-17.53,17.41s-17.53-7.79-17.53-17.41,7.87-17.41,17.53-17.41,17.53,7.81,17.53,17.41Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1821.54,
    cy: 767.72,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1850.02,
    cy: 767.72,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1874.25,738.81l-16.17,20.33c-.81,1.14-2.12,1.81-3.52,1.8h-35.42c-2.32,0-4.19-1.76-4.19-3.94v-15.35h-3.21c-2.15,0-4.22-.8-5.8-2.27-1.53-1.4-2.41-3.37-2.42-5.44,.03-.69,.61-1.23,1.3-1.21h65.9c3.32,0,5.32,3.46,3.53,6.07Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1907.32,
    cy: 754.14,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1714.05,
    cy: 802.7,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1813.01,786.48v28.68c0,2.73-2.31,4.99-5.15,4.99h-67.79c-1.2,.02-2.2-.94-2.22-2.14h0v-1c0-6.21,4.39-11.48,10.33-13.02v-17.5c0-2.73,2.32-4.99,5.15-4.99h54.55c2.82,0,5.13,2.24,5.13,4.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1862.94,802.73c0,9.6-7.87,17.41-17.53,17.41s-17.53-7.79-17.53-17.41,7.87-17.41,17.53-17.41,17.53,7.81,17.53,17.41Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1887.41,
    cy: 816.29,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1915.89,
    cy: 816.29,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1940.13,787.38l-16.17,20.33c-.81,1.14-2.12,1.81-3.52,1.8h-35.42c-2.32,0-4.2-1.76-4.2-3.94v-15.36h-3.21c-2.15,0-4.21-.8-5.79-2.26-1.53-1.4-2.41-3.38-2.42-5.45,.03-.69,.61-1.23,1.3-1.21h65.9c3.32,.02,5.32,3.47,3.53,6.08Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1694.15,
    cy: 864.85,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1722.63,
    cy: 864.85,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1746.86,835.94l-16.17,20.33c-.8,1.15-2.12,1.83-3.52,1.82h-35.41c-2.32,0-4.19-1.76-4.19-3.94v-15.37h-3.22c-2.15,0-4.22-.8-5.8-2.26-1.53-1.4-2.41-3.38-2.42-5.45,.03-.69,.61-1.23,1.3-1.21h65.91c3.32,.02,5.32,3.47,3.53,6.08Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1779.93,
    cy: 851.26,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1878.89,835.04v28.68c0,2.73-2.32,4.99-5.15,4.99h-67.79c-1.2,.02-2.2-.94-2.22-2.14v-1.01c0-6.21,4.39-11.47,10.33-13.02v-17.5c0-2.73,2.31-4.99,5.15-4.99h54.55c2.81,0,5.13,2.24,5.13,4.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1928.82,851.3c0,9.6-7.87,17.41-17.53,17.41s-17.53-7.79-17.53-17.41,7.87-17.41,17.53-17.41,17.53,7.81,17.53,17.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1685.62,883.61v28.68c0,2.73-2.31,4.99-5.15,4.99h-67.79c-1.2,.02-2.19-.94-2.22-2.14v-1c0-6.21,4.39-11.48,10.33-13.02v-17.5c0-2.73,2.32-4.99,5.15-4.99h54.55c2.82,0,5.13,2.24,5.13,4.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1735.55,899.86c0,9.6-7.87,17.41-17.53,17.41s-17.53-7.79-17.53-17.41,7.87-17.41,17.53-17.41,17.53,7.81,17.53,17.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1812.74,884.51l-16.17,20.33c-.8,1.15-2.12,1.83-3.52,1.82h-35.41c-2.32,0-4.19-1.76-4.19-3.94v-15.37h-3.22c-2.15,0-4.23-.81-5.8-2.27-1.53-1.4-2.41-3.37-2.42-5.44,.03-.69,.61-1.23,1.3-1.21h65.9c3.32,.02,5.32,3.46,3.53,6.08Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1845.8,
    cy: 899.83,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1944.77,883.61v28.68c0,2.73-2.32,4.99-5.15,4.99h-67.79c-1.2,.02-2.2-.94-2.22-2.14v-1c0-6.21,4.39-11.48,10.33-13.02v-17.5c0-2.73,2.31-4.99,5.15-4.99h54.55c2.81,0,5.13,2.24,5.13,4.99Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1944.82,883.61v28.68c0,2.73-2.31,4.99-5.15,4.99h-67.79c-1.2,.02-2.19-.94-2.22-2.14v-1c0-6.21,4.39-11.48,10.33-13.02v-17.5c0-2.73,2.32-4.99,5.15-4.99h54.55c2.82,0,5.13,2.24,5.13,4.99Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1068.71,
    cy: 899.8,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1167.67,883.58v28.68c0,2.73-2.32,4.99-5.15,4.99h-67.79c-1.2,.02-2.2-.94-2.22-2.14v-1c0-6.21,4.39-11.47,10.33-13.02v-17.5c0-2.73,2.32-4.99,5.15-4.99h54.55c2.82,0,5.13,2.23,5.13,4.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1217.6,899.84c0,9.6-7.87,17.41-17.53,17.41s-17.53-7.79-17.53-17.41,7.87-17.41,17.53-17.41,17.53,7.81,17.53,17.41Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1242.07,
    cy: 913.39,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1270.55,
    cy: 913.39,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1294.79,884.48l-16.17,20.33c-.8,1.15-2.12,1.83-3.52,1.82h-35.42c-2.32,0-4.19-1.76-4.19-3.94v-15.37h-3.21c-2.15,0-4.22-.8-5.8-2.26-1.53-1.4-2.41-3.36-2.42-5.43,.03-.69,.61-1.23,1.3-1.21h65.9c3.32-.02,5.32,3.44,3.53,6.06Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1327.85,
    cy: 899.8,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1048.81,
    cy: 961.95,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1077.29,
    cy: 961.95,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1101.52,933.04l-16.17,20.34c-.81,1.14-2.12,1.81-3.52,1.8h-35.42c-2.32,0-4.19-1.76-4.19-3.94v-15.35h-3.21c-2.15,0-4.22-.8-5.8-2.26-1.53-1.4-2.41-3.37-2.42-5.44,.03-.69,.61-1.23,1.3-1.21h65.9c3.32,0,5.32,3.45,3.53,6.07Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1134.59,
    cy: 948.37,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1233.55,932.14v28.68c0,2.73-2.31,4.99-5.15,4.99h-67.79c-1.2,.02-2.19-.94-2.22-2.14v-1.01c0-6.21,4.39-11.47,10.33-13.02v-17.5c0-2.73,2.32-4.99,5.15-4.99h54.56c2.79-.02,5.07,2.2,5.12,4.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1283.47,948.4c0,9.6-7.87,17.41-17.53,17.41s-17.52-7.79-17.52-17.41,7.87-17.41,17.53-17.41,17.52,7.81,17.52,17.41Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1307.95,
    cy: 961.95,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1336.43,
    cy: 961.95,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1360.66,933.04l-16.17,20.34c-.81,1.14-2.12,1.81-3.52,1.8h-35.42c-2.32,0-4.19-1.76-4.19-3.94v-15.35h-3.21c-2.15,0-4.22-.8-5.8-2.26-1.53-1.4-2.41-3.37-2.42-5.44,.03-.69,.61-1.23,1.3-1.21h65.9c3.33,0,5.33,3.45,3.53,6.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1090.21,996.96c0,9.6-7.87,17.41-17.53,17.41s-17.53-7.79-17.53-17.41,7.87-17.4,17.53-17.4,17.53,7.8,17.53,17.4Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1114.69,
    cy: 1010.52,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1143.16,
    cy: 1010.52,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1167.4,981.61l-16.17,20.33c-.81,1.14-2.12,1.82-3.52,1.8h-35.42c-2.32,0-4.19-1.76-4.19-3.94v-15.36h-3.21c-2.15,0-4.22-.8-5.79-2.26-1.53-1.4-2.41-3.38-2.42-5.45,.03-.69,.61-1.23,1.3-1.21h65.9c3.33,.02,5.32,3.47,3.53,6.08Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1200.46,
    cy: 996.93,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1299.43,980.71v28.68c0,2.73-2.32,4.99-5.15,4.99h-67.79c-1.2,.02-2.2-.94-2.22-2.14v-1c0-6.21,4.39-11.48,10.33-13.02v-17.5c0-2.73,2.32-4.99,5.15-4.99h54.55c2.81,0,5.13,2.24,5.13,4.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1349.35,996.96c0,9.6-7.87,17.41-17.53,17.41s-17.53-7.79-17.53-17.41,7.87-17.41,17.53-17.41,17.53,7.81,17.53,17.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1106.16,1029.28v28.68c0,2.73-2.31,4.99-5.15,4.99h-67.79c-1.2,.02-2.2-.94-2.22-2.14v-1.01c0-6.21,4.39-11.47,10.33-13.02v-17.5c0-2.73,2.32-4.99,5.15-4.99h54.55c2.79-.03,5.08,2.2,5.13,4.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1156.08,1045.53c0,9.6-7.87,17.41-17.53,17.41s-17.53-7.79-17.53-17.41,7.87-17.41,17.53-17.41,17.53,7.81,17.53,17.41Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1180.56,
    cy: 1059.09,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1209.04,
    cy: 1059.09,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1233.28,1030.17l-16.17,20.33c-.81,1.14-2.12,1.81-3.52,1.8h-35.42c-2.32,0-4.19-1.76-4.19-3.94v-15.35h-3.21c-2.15,0-4.22-.8-5.8-2.27-1.53-1.4-2.41-3.37-2.42-5.44,.03-.69,.61-1.23,1.3-1.21h65.9c3.32,0,5.32,3.46,3.53,6.07Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1266.34,
    cy: 1045.5,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1365.3,1029.28v28.68c0,2.73-2.32,4.99-5.15,4.99h-67.79c-1.2,.02-2.2-.94-2.22-2.14v-1.01c0-6.21,4.39-11.47,10.33-13.02v-17.5c0-2.73,2.31-4.99,5.15-4.99h54.56c2.8,0,5.12,2.24,5.12,4.99Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1073.08,
    cy: 1094.06,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1172.04,1077.84v28.68c0,2.73-2.31,4.99-5.15,4.99h-67.79c-1.2,.02-2.2-.94-2.22-2.14h0v-1c0-6.21,4.39-11.48,10.33-13.02v-17.5c0-2.73,2.32-4.99,5.15-4.99h54.55c2.82,0,5.13,2.24,5.13,4.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1221.96,1094.1c0,9.6-7.87,17.41-17.53,17.41s-17.53-7.79-17.53-17.41,7.87-17.41,17.53-17.41,17.53,7.81,17.53,17.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1299.15,1078.74l-16.17,20.33c-.81,1.14-2.12,1.81-3.52,1.8h-35.42c-2.32,0-4.2-1.76-4.2-3.94v-15.36h-3.21c-2.15,0-4.21-.8-5.79-2.26-1.53-1.4-2.41-3.38-2.42-5.45,.03-.69,.61-1.23,1.3-1.21h65.9c3.32,.02,5.32,3.47,3.53,6.08Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1332.22,
    cy: 1094.06,
    rx: 17.53,
    ry: 17.41
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1327.73,
    cy: 899.8,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1426.69,883.58v28.68c0,2.73-2.32,4.99-5.15,4.99h-67.79c-1.2,.02-2.2-.94-2.22-2.14v-1c0-6.21,4.39-11.47,10.33-13.02v-17.5c0-2.73,2.32-4.99,5.15-4.99h54.55c2.82,0,5.13,2.23,5.13,4.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1476.62,899.84c0,9.6-7.87,17.41-17.53,17.41s-17.53-7.79-17.53-17.41,7.87-17.41,17.53-17.41,17.53,7.81,17.53,17.41Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1501.09,
    cy: 913.39,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1529.57,
    cy: 913.39,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1553.8,884.48l-16.17,20.33c-.8,1.15-2.12,1.83-3.52,1.82h-35.42c-2.32,0-4.19-1.76-4.19-3.94v-15.37h-3.21c-2.15,0-4.22-.8-5.8-2.26-1.53-1.4-2.41-3.36-2.42-5.43,.03-.69,.61-1.23,1.3-1.21h65.9c3.32-.02,5.32,3.44,3.53,6.06Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1586.87,
    cy: 899.8,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1307.83,
    cy: 961.95,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1336.3,
    cy: 961.95,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1360.54,933.04l-16.17,20.34c-.81,1.14-2.12,1.81-3.52,1.8h-35.42c-2.32,0-4.19-1.76-4.19-3.94v-15.35h-3.21c-2.15,0-4.22-.8-5.8-2.26-1.53-1.4-2.41-3.37-2.42-5.44,.03-.69,.61-1.23,1.3-1.21h65.9c3.32,0,5.32,3.45,3.53,6.07Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1393.61,
    cy: 948.37,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1492.57,932.14v28.68c0,2.73-2.31,4.99-5.15,4.99h-67.79c-1.2,.02-2.19-.94-2.22-2.14v-1.01c0-6.21,4.39-11.47,10.33-13.02v-17.5c0-2.73,2.32-4.99,5.15-4.99h54.56c2.79-.02,5.07,2.2,5.12,4.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1542.49,948.4c0,9.6-7.87,17.41-17.53,17.41s-17.52-7.79-17.52-17.41,7.87-17.41,17.53-17.41,17.52,7.81,17.52,17.41Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1566.97,
    cy: 961.95,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1595.44,
    cy: 961.95,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1619.68,933.04l-16.17,20.34c-.81,1.14-2.12,1.81-3.52,1.8h-35.42c-2.32,0-4.19-1.76-4.19-3.94v-15.35h-3.21c-2.15,0-4.22-.8-5.8-2.26-1.53-1.4-2.41-3.37-2.42-5.44,.03-.69,.61-1.23,1.3-1.21h65.9c3.33,0,5.33,3.45,3.53,6.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1349.23,996.96c0,9.6-7.87,17.41-17.53,17.41s-17.53-7.79-17.53-17.41,7.87-17.4,17.53-17.4,17.53,7.8,17.53,17.4Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1373.7,
    cy: 1010.52,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1402.18,
    cy: 1010.52,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1426.41,981.61l-16.17,20.33c-.81,1.14-2.12,1.82-3.52,1.8h-35.42c-2.32,0-4.19-1.76-4.19-3.94v-15.36h-3.21c-2.15,0-4.22-.8-5.79-2.26-1.53-1.4-2.41-3.38-2.42-5.45,.03-.69,.61-1.23,1.3-1.21h65.9c3.33,.02,5.32,3.47,3.53,6.08Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1459.48,
    cy: 996.93,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1558.44,980.71v28.68c0,2.73-2.32,4.99-5.15,4.99h-67.79c-1.2,.02-2.2-.94-2.22-2.14v-1c0-6.21,4.39-11.48,10.33-13.02v-17.5c0-2.73,2.32-4.99,5.15-4.99h54.55c2.81,0,5.13,2.24,5.13,4.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1608.37,996.96c0,9.6-7.87,17.41-17.53,17.41s-17.53-7.79-17.53-17.41,7.87-17.41,17.53-17.41,17.53,7.81,17.53,17.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1365.18,1029.28v28.68c0,2.73-2.31,4.99-5.15,4.99h-67.79c-1.2,.02-2.2-.94-2.22-2.14v-1.01c0-6.21,4.39-11.47,10.33-13.02v-17.5c0-2.73,2.32-4.99,5.15-4.99h54.55c2.79-.03,5.08,2.2,5.13,4.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1415.1,1045.53c0,9.6-7.87,17.41-17.53,17.41s-17.53-7.79-17.53-17.41,7.87-17.41,17.53-17.41,17.53,7.81,17.53,17.41Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1439.58,
    cy: 1059.09,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1468.06,
    cy: 1059.09,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1492.29,1030.17l-16.17,20.33c-.81,1.14-2.12,1.81-3.52,1.8h-35.42c-2.32,0-4.19-1.76-4.19-3.94v-15.35h-3.21c-2.15,0-4.22-.8-5.8-2.27-1.53-1.4-2.41-3.37-2.42-5.44,.03-.69,.61-1.23,1.3-1.21h65.9c3.32,0,5.32,3.46,3.53,6.07Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1525.36,
    cy: 1045.5,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1624.32,1029.28v28.68c0,2.73-2.32,4.99-5.15,4.99h-67.79c-1.2,.02-2.2-.94-2.22-2.14v-1.01c0-6.21,4.39-11.47,10.33-13.02v-17.5c0-2.73,2.31-4.99,5.15-4.99h54.56c2.8,0,5.12,2.24,5.12,4.99Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1332.09,
    cy: 1094.06,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1431.05,1077.84v28.68c0,2.73-2.31,4.99-5.15,4.99h-67.79c-1.2,.02-2.2-.94-2.22-2.14h0v-1c0-6.21,4.39-11.48,10.33-13.02v-17.5c0-2.73,2.32-4.99,5.15-4.99h54.55c2.82,0,5.13,2.24,5.13,4.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1480.98,1094.1c0,9.6-7.87,17.41-17.53,17.41s-17.53-7.79-17.53-17.41,7.87-17.41,17.53-17.41,17.53,7.81,17.53,17.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1558.17,1078.74l-16.17,20.33c-.81,1.14-2.12,1.81-3.52,1.8h-35.42c-2.32,0-4.2-1.76-4.2-3.94v-15.36h-3.21c-2.15,0-4.21-.8-5.79-2.26-1.53-1.4-2.41-3.38-2.42-5.45,.03-.69,.61-1.23,1.3-1.21h65.9c3.32,.02,5.32,3.47,3.53,6.08Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1591.23,
    cy: 1094.06,
    rx: 17.53,
    ry: 17.41
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1586.75,
    cy: 899.8,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1685.71,883.58v28.68c0,2.73-2.32,4.99-5.15,4.99h-67.79c-1.2,.02-2.2-.94-2.22-2.14v-1c0-6.21,4.39-11.47,10.33-13.02v-17.5c0-2.73,2.32-4.99,5.15-4.99h54.55c2.82,0,5.13,2.23,5.13,4.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1735.64,899.84c0,9.6-7.87,17.41-17.53,17.41s-17.53-7.79-17.53-17.41,7.87-17.41,17.53-17.41,17.53,7.81,17.53,17.41Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1760.11,
    cy: 913.39,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1788.59,
    cy: 913.39,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1812.82,884.48l-16.17,20.33c-.8,1.15-2.12,1.83-3.52,1.82h-35.42c-2.32,0-4.19-1.76-4.19-3.94v-15.37h-3.21c-2.15,0-4.22-.8-5.8-2.26-1.53-1.4-2.41-3.36-2.42-5.43,.03-.69,.61-1.23,1.3-1.21h65.9c3.32-.02,5.32,3.44,3.53,6.06Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1845.89,
    cy: 899.8,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1566.84,
    cy: 961.95,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1595.32,
    cy: 961.95,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1619.56,933.04l-16.17,20.34c-.81,1.14-2.12,1.81-3.52,1.8h-35.42c-2.32,0-4.19-1.76-4.19-3.94v-15.35h-3.21c-2.15,0-4.22-.8-5.8-2.26-1.53-1.4-2.41-3.37-2.42-5.44,.03-.69,.61-1.23,1.3-1.21h65.9c3.32,0,5.32,3.45,3.53,6.07Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1652.62,
    cy: 948.37,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1751.58,932.14v28.68c0,2.73-2.31,4.99-5.15,4.99h-67.79c-1.2,.02-2.19-.94-2.22-2.14v-1.01c0-6.21,4.39-11.47,10.33-13.02v-17.5c0-2.73,2.32-4.99,5.15-4.99h54.56c2.79-.02,5.07,2.2,5.12,4.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1801.51,948.4c0,9.6-7.87,17.41-17.53,17.41s-17.52-7.79-17.52-17.41,7.87-17.41,17.53-17.41,17.52,7.81,17.52,17.41Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1825.99,
    cy: 961.95,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1854.46,
    cy: 961.95,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1878.7,933.04l-16.17,20.34c-.81,1.14-2.12,1.81-3.52,1.8h-35.42c-2.32,0-4.19-1.76-4.19-3.94v-15.35h-3.21c-2.15,0-4.22-.8-5.8-2.26-1.53-1.4-2.41-3.37-2.42-5.44,.03-.69,.61-1.23,1.3-1.21h65.9c3.33,0,5.33,3.45,3.53,6.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1608.25,996.96c0,9.6-7.87,17.41-17.53,17.41s-17.53-7.79-17.53-17.41,7.87-17.4,17.53-17.4,17.53,7.8,17.53,17.4Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1632.72,
    cy: 1010.52,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1661.2,
    cy: 1010.52,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1685.43,981.61l-16.17,20.33c-.81,1.14-2.12,1.82-3.52,1.8h-35.42c-2.32,0-4.19-1.76-4.19-3.94v-15.36h-3.21c-2.15,0-4.22-.8-5.79-2.26-1.53-1.4-2.41-3.38-2.42-5.45,.03-.69,.61-1.23,1.3-1.21h65.9c3.33,.02,5.32,3.47,3.53,6.08Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1718.5,
    cy: 996.93,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1817.46,980.71v28.68c0,2.73-2.32,4.99-5.15,4.99h-67.79c-1.2,.02-2.2-.94-2.22-2.14v-1c0-6.21,4.39-11.48,10.33-13.02v-17.5c0-2.73,2.32-4.99,5.15-4.99h54.55c2.81,0,5.13,2.24,5.13,4.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1867.39,996.96c0,9.6-7.87,17.41-17.53,17.41s-17.53-7.79-17.53-17.41,7.87-17.41,17.53-17.41,17.53,7.81,17.53,17.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1624.2,1029.28v28.68c0,2.73-2.31,4.99-5.15,4.99h-67.79c-1.2,.02-2.2-.94-2.22-2.14v-1.01c0-6.21,4.39-11.47,10.33-13.02v-17.5c0-2.73,2.32-4.99,5.15-4.99h54.55c2.79-.03,5.08,2.2,5.13,4.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1674.12,1045.53c0,9.6-7.87,17.41-17.53,17.41s-17.53-7.79-17.53-17.41,7.87-17.41,17.53-17.41,17.53,7.81,17.53,17.41Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1698.6,
    cy: 1059.09,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1727.08,
    cy: 1059.09,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1751.31,1030.17l-16.17,20.33c-.81,1.14-2.12,1.81-3.52,1.8h-35.42c-2.32,0-4.19-1.76-4.19-3.94v-15.35h-3.21c-2.15,0-4.22-.8-5.8-2.27-1.53-1.4-2.41-3.37-2.42-5.44,.03-.69,.61-1.23,1.3-1.21h65.9c3.32,0,5.32,3.46,3.53,6.07Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1784.38,
    cy: 1045.5,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1883.34,1029.28v28.68c0,2.73-2.32,4.99-5.15,4.99h-67.79c-1.2,.02-2.2-.94-2.22-2.14v-1.01c0-6.21,4.39-11.47,10.33-13.02v-17.5c0-2.73,2.31-4.99,5.15-4.99h54.56c2.8,0,5.12,2.24,5.12,4.99Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1591.11,
    cy: 1094.06,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1690.07,1077.84v28.68c0,2.73-2.31,4.99-5.15,4.99h-67.79c-1.2,.02-2.2-.94-2.22-2.14h0v-1c0-6.21,4.39-11.48,10.33-13.02v-17.5c0-2.73,2.32-4.99,5.15-4.99h54.55c2.82,0,5.13,2.24,5.13,4.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1740,1094.1c0,9.6-7.87,17.41-17.53,17.41s-17.53-7.79-17.53-17.41,7.87-17.41,17.53-17.41,17.53,7.81,17.53,17.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1817.19,1078.74l-16.17,20.33c-.81,1.14-2.12,1.81-3.52,1.8h-35.42c-2.32,0-4.2-1.76-4.2-3.94v-15.36h-3.21c-2.15,0-4.21-.8-5.79-2.26-1.53-1.4-2.41-3.38-2.42-5.45,.03-.69,.61-1.23,1.3-1.21h65.9c3.32,.02,5.32,3.47,3.53,6.08Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1850.25,
    cy: 1094.06,
    rx: 17.53,
    ry: 17.41
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1845.94,
    cy: 899.8,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1944.9,883.58v28.68c0,2.73-2.32,4.99-5.15,4.99h-67.79c-1.2,.02-2.2-.94-2.22-2.14v-1c0-6.21,4.39-11.47,10.33-13.02v-17.5c0-2.73,2.32-4.99,5.15-4.99h54.55c2.82,0,5.13,2.23,5.13,4.99Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1826.04,
    cy: 961.95,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1854.51,
    cy: 961.95,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1878.75,933.04l-16.17,20.34c-.81,1.14-2.12,1.81-3.52,1.8h-35.42c-2.32,0-4.19-1.76-4.19-3.94v-15.35h-3.21c-2.15,0-4.22-.8-5.8-2.26-1.53-1.4-2.41-3.37-2.42-5.44,.03-.69,.61-1.23,1.3-1.21h65.9c3.32,0,5.32,3.45,3.53,6.07Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1911.82,
    cy: 948.37,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1867.44,996.96c0,9.6-7.87,17.41-17.53,17.41s-17.53-7.79-17.53-17.41,7.87-17.4,17.53-17.4,17.53,7.8,17.53,17.4Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1891.91,
    cy: 1010.52,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1920.39,
    cy: 1010.52,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1944.62,981.61l-16.17,20.33c-.81,1.14-2.12,1.82-3.52,1.8h-35.42c-2.32,0-4.19-1.76-4.19-3.94v-15.36h-3.21c-2.15,0-4.22-.8-5.79-2.26-1.53-1.4-2.41-3.38-2.42-5.45,.03-.69,.61-1.23,1.3-1.21h65.9c3.33,.02,5.32,3.47,3.53,6.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1883.39,1029.28v28.68c0,2.73-2.31,4.99-5.15,4.99h-67.79c-1.2,.02-2.2-.94-2.22-2.14v-1.01c0-6.21,4.39-11.47,10.33-13.02v-17.5c0-2.73,2.32-4.99,5.15-4.99h54.55c2.79-.03,5.08,2.2,5.13,4.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1933.31,1045.53c0,9.6-7.87,17.41-17.53,17.41s-17.53-7.79-17.53-17.41,7.87-17.41,17.53-17.41,17.53,7.81,17.53,17.41Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1850.3,
    cy: 1094.06,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1949.26,1077.84v28.68c0,2.73-2.31,4.99-5.15,4.99h-67.79c-1.2,.02-2.2-.94-2.22-2.14h0v-1c0-6.21,4.39-11.48,10.33-13.02v-17.5c0-2.73,2.32-4.99,5.15-4.99h54.55c2.82,0,5.13,2.24,5.13,4.99Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M45.29,608.39c0,9.6-7.87,17.41-17.53,17.41s-17.53-7.79-17.53-17.41,7.87-17.41,17.53-17.41,17.53,7.81,17.53,17.41Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 69.77,
    cy: 621.94,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 98.25,
    cy: 621.94,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M122.48,593.03l-16.17,20.33c-.8,1.15-2.12,1.83-3.52,1.82h-35.42c-2.32,0-4.19-1.76-4.19-3.94v-15.37h-3.21c-2.15,0-4.22-.8-5.8-2.26-1.53-1.4-2.41-3.36-2.42-5.43,.03-.69,.61-1.23,1.3-1.21H118.95c3.32-.02,5.32,3.44,3.53,6.06Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 155.55,
    cy: 608.35,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M61.24,640.69v28.68c0,2.73-2.31,4.99-5.15,4.99H-11.69c-1.2,.02-2.19-.94-2.22-2.14v-1.01c0-6.21,4.39-11.47,10.33-13.02v-17.5c0-2.73,2.32-4.99,5.15-4.99H56.12c2.79-.02,5.07,2.2,5.12,4.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M111.17,656.95c0,9.6-7.87,17.41-17.53,17.41s-17.52-7.79-17.52-17.41,7.87-17.41,17.53-17.41,17.52,7.81,17.52,17.41Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 135.64,
    cy: 670.5,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 164.12,
    cy: 670.5,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M188.36,641.59l-16.17,20.34c-.81,1.14-2.12,1.81-3.52,1.8h-35.42c-2.32,0-4.19-1.76-4.19-3.94v-15.35h-3.21c-2.15,0-4.22-.8-5.8-2.26-1.53-1.4-2.41-3.37-2.42-5.44,.03-.69,.61-1.23,1.3-1.21h65.9c3.33,0,5.33,3.45,3.53,6.07Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 28.16,
    cy: 705.48,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M127.12,689.26v28.68c0,2.73-2.32,4.99-5.15,4.99H54.18c-1.2,.02-2.2-.94-2.22-2.14v-1c0-6.21,4.39-11.48,10.33-13.02v-17.5c0-2.73,2.32-4.99,5.15-4.99h54.55c2.81,0,5.13,2.24,5.13,4.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M177.04,705.51c0,9.6-7.87,17.41-17.53,17.41s-17.53-7.79-17.53-17.41,7.87-17.41,17.53-17.41,17.53,7.81,17.53,17.41Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 8.25,
    cy: 767.64,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 36.73,
    cy: 767.64,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M60.97,738.72l-16.17,20.33c-.81,1.14-2.12,1.81-3.52,1.8H5.86c-2.32,0-4.19-1.76-4.19-3.94v-15.35H-1.54c-2.15,0-4.22-.8-5.8-2.27-1.53-1.4-2.41-3.37-2.42-5.44,.03-.69,.61-1.23,1.3-1.21H57.44c3.32,0,5.32,3.46,3.53,6.07Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 94.04,
    cy: 754.05,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M193,737.83v28.68c0,2.73-2.32,4.99-5.15,4.99H120.06c-1.2,.02-2.2-.94-2.22-2.14v-1.01c0-6.21,4.39-11.47,10.33-13.02v-17.5c0-2.73,2.31-4.99,5.15-4.99h54.56c2.8,0,5.12,2.24,5.12,4.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M49.65,802.65c0,9.6-7.87,17.41-17.53,17.41s-17.53-7.79-17.53-17.41,7.87-17.41,17.53-17.41,17.53,7.81,17.53,17.41Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 74.13,
    cy: 816.2,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 102.61,
    cy: 816.2,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M126.84,787.29l-16.17,20.33c-.81,1.14-2.12,1.81-3.52,1.8h-35.42c-2.32,0-4.2-1.76-4.2-3.94v-15.36h-3.21c-2.15,0-4.21-.8-5.79-2.26-1.53-1.4-2.41-3.38-2.42-5.45,.03-.69,.61-1.23,1.3-1.21H123.32c3.32,.02,5.32,3.47,3.53,6.08Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 159.91,
    cy: 802.61,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M65.61,834.96v28.68c0,2.73-2.32,4.99-5.15,4.99H-7.33c-1.2,.02-2.2-.94-2.22-2.14v-1.01c0-6.21,4.39-11.47,10.33-13.02v-17.5c0-2.73,2.31-4.99,5.15-4.99H60.48c2.81,0,5.13,2.24,5.13,4.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M115.53,851.21c0,9.6-7.87,17.41-17.53,17.41s-17.53-7.79-17.53-17.41,7.87-17.41,17.53-17.41,17.53,7.81,17.53,17.41Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 140.01,
    cy: 864.77,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 168.48,
    cy: 864.77,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M192.72,835.85l-16.17,20.33c-.8,1.15-2.12,1.83-3.52,1.82h-35.42c-2.32,0-4.19-1.76-4.19-3.94v-15.37h-3.21c-2.15,0-4.22-.8-5.8-2.26-1.53-1.4-2.41-3.38-2.42-5.45,.03-.69,.61-1.23,1.3-1.21h65.9c3.33,.02,5.32,3.47,3.53,6.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M-.55,884.42l-16.17,20.33c-.8,1.15-2.12,1.83-3.52,1.82H-55.64c-2.32,0-4.19-1.76-4.19-3.94v-15.37h-3.22c-2.15,0-4.23-.81-5.8-2.27-1.53-1.4-2.41-3.37-2.42-5.44,.03-.69,.61-1.23,1.3-1.21H-4.07c3.32,.02,5.32,3.46,3.53,6.08Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 32.52,
    cy: 899.74,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M131.48,883.52v28.68c0,2.73-2.32,4.99-5.15,4.99H58.55c-1.2,.02-2.2-.94-2.22-2.14v-1c0-6.21,4.39-11.48,10.33-13.02v-17.5c0-2.73,2.31-4.99,5.15-4.99h54.55c2.81,0,5.13,2.24,5.13,4.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M181.41,899.78c0,9.6-7.87,17.41-17.53,17.41s-17.53-7.79-17.53-17.41,7.87-17.41,17.53-17.41,17.53,7.81,17.53,17.41Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 155.42,
    cy: 608.35,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M254.39,592.13v28.68c0,2.73-2.32,4.99-5.15,4.99h-67.79c-1.2,.02-2.2-.94-2.22-2.14v-1c0-6.21,4.39-11.47,10.33-13.02v-17.5c0-2.73,2.32-4.99,5.15-4.99h54.55c2.82,0,5.13,2.23,5.13,4.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M304.31,608.39c0,9.6-7.87,17.41-17.53,17.41s-17.53-7.79-17.53-17.41,7.87-17.41,17.53-17.41,17.53,7.81,17.53,17.41Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 328.78,
    cy: 621.94,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 357.26,
    cy: 621.94,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M381.5,593.03l-16.17,20.33c-.8,1.15-2.12,1.83-3.52,1.82h-35.42c-2.32,0-4.19-1.76-4.19-3.94v-15.37h-3.21c-2.15,0-4.22-.8-5.8-2.26-1.53-1.4-2.41-3.36-2.42-5.43,.03-.69,.61-1.23,1.3-1.21h65.9c3.32-.02,5.32,3.44,3.53,6.06Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 414.57,
    cy: 608.35,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 135.52,
    cy: 670.5,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 164,
    cy: 670.5,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M188.23,641.59l-16.17,20.34c-.81,1.14-2.12,1.81-3.52,1.8h-35.42c-2.32,0-4.19-1.76-4.19-3.94v-15.35h-3.21c-2.15,0-4.22-.8-5.8-2.26-1.53-1.4-2.41-3.37-2.42-5.44,.03-.69,.61-1.23,1.3-1.21h65.9c3.32,0,5.32,3.45,3.53,6.07Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 221.3,
    cy: 656.92,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M320.26,640.69v28.68c0,2.73-2.31,4.99-5.15,4.99h-67.79c-1.2,.02-2.19-.94-2.22-2.14v-1.01c0-6.21,4.39-11.47,10.33-13.02v-17.5c0-2.73,2.32-4.99,5.15-4.99h54.56c2.79-.02,5.07,2.2,5.12,4.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M370.19,656.95c0,9.6-7.87,17.41-17.53,17.41s-17.52-7.79-17.52-17.41,7.87-17.41,17.53-17.41,17.52,7.81,17.52,17.41Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 394.66,
    cy: 670.5,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 423.14,
    cy: 670.5,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M447.38,641.59l-16.17,20.34c-.81,1.14-2.12,1.81-3.52,1.8h-35.42c-2.32,0-4.19-1.76-4.19-3.94v-15.35h-3.21c-2.15,0-4.22-.8-5.8-2.26-1.53-1.4-2.41-3.37-2.42-5.44,.03-.69,.61-1.23,1.3-1.21h65.9c3.33,0,5.33,3.45,3.53,6.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M176.92,705.51c0,9.6-7.87,17.41-17.53,17.41s-17.53-7.79-17.53-17.41,7.87-17.4,17.53-17.4,17.53,7.8,17.53,17.4Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 201.4,
    cy: 719.07,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 229.87,
    cy: 719.07,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M254.11,690.16l-16.17,20.33c-.81,1.14-2.12,1.82-3.52,1.8h-35.42c-2.32,0-4.19-1.76-4.19-3.94v-15.36h-3.21c-2.15,0-4.22-.8-5.79-2.26-1.53-1.4-2.41-3.38-2.42-5.45,.03-.69,.61-1.23,1.3-1.21h65.9c3.33,.02,5.32,3.47,3.53,6.08Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 287.18,
    cy: 705.48,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M386.14,689.26v28.68c0,2.73-2.32,4.99-5.15,4.99h-67.79c-1.2,.02-2.2-.94-2.22-2.14v-1c0-6.21,4.39-11.48,10.33-13.02v-17.5c0-2.73,2.32-4.99,5.15-4.99h54.55c2.81,0,5.13,2.24,5.13,4.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M436.06,705.51c0,9.6-7.87,17.41-17.53,17.41s-17.53-7.79-17.53-17.41,7.87-17.41,17.53-17.41,17.53,7.81,17.53,17.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M192.87,737.83v28.68c0,2.73-2.31,4.99-5.15,4.99H119.94c-1.2,.02-2.2-.94-2.22-2.14v-1.01c0-6.21,4.39-11.47,10.33-13.02v-17.5c0-2.73,2.32-4.99,5.15-4.99h54.55c2.79-.03,5.08,2.2,5.13,4.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M242.8,754.08c0,9.6-7.87,17.41-17.53,17.41s-17.53-7.79-17.53-17.41,7.87-17.41,17.53-17.41,17.53,7.81,17.53,17.41Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 267.27,
    cy: 767.64,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 295.75,
    cy: 767.64,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M319.99,738.72l-16.17,20.33c-.81,1.14-2.12,1.81-3.52,1.8h-35.42c-2.32,0-4.19-1.76-4.19-3.94v-15.35h-3.21c-2.15,0-4.22-.8-5.8-2.27-1.53-1.4-2.41-3.37-2.42-5.44,.03-.69,.61-1.23,1.3-1.21h65.9c3.32,0,5.32,3.46,3.53,6.07Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 353.05,
    cy: 754.05,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M452.02,737.83v28.68c0,2.73-2.32,4.99-5.15,4.99h-67.79c-1.2,.02-2.2-.94-2.22-2.14v-1.01c0-6.21,4.39-11.47,10.33-13.02v-17.5c0-2.73,2.31-4.99,5.15-4.99h54.56c2.8,0,5.12,2.24,5.12,4.99Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 159.79,
    cy: 802.61,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M258.75,786.39v28.68c0,2.73-2.31,4.99-5.15,4.99h-67.79c-1.2,.02-2.2-.94-2.22-2.14h0v-1c0-6.21,4.39-11.48,10.33-13.02v-17.5c0-2.73,2.32-4.99,5.15-4.99h54.55c2.82,0,5.13,2.24,5.13,4.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M308.67,802.65c0,9.6-7.87,17.41-17.53,17.41s-17.53-7.79-17.53-17.41,7.87-17.41,17.53-17.41,17.53,7.81,17.53,17.41Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 333.15,
    cy: 816.2,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 361.63,
    cy: 816.2,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M385.86,787.29l-16.17,20.33c-.81,1.14-2.12,1.81-3.52,1.8h-35.42c-2.32,0-4.2-1.76-4.2-3.94v-15.36h-3.21c-2.15,0-4.21-.8-5.79-2.26-1.53-1.4-2.41-3.38-2.42-5.45,.03-.69,.61-1.23,1.3-1.21h65.9c3.32,.02,5.32,3.47,3.53,6.08Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 418.93,
    cy: 802.61,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 139.88,
    cy: 864.77,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 168.36,
    cy: 864.77,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M192.6,835.85l-16.17,20.33c-.8,1.15-2.12,1.83-3.52,1.82h-35.41c-2.32,0-4.19-1.76-4.19-3.94v-15.37h-3.22c-2.15,0-4.22-.8-5.8-2.26-1.53-1.4-2.41-3.38-2.42-5.45,.03-.69,.61-1.23,1.3-1.21h65.91c3.32,.02,5.32,3.47,3.53,6.08Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 225.66,
    cy: 851.18,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M324.63,834.96v28.68c0,2.73-2.32,4.99-5.15,4.99h-67.79c-1.2,.02-2.2-.94-2.22-2.14v-1.01c0-6.21,4.39-11.47,10.33-13.02v-17.5c0-2.73,2.31-4.99,5.15-4.99h54.55c2.81,0,5.13,2.24,5.13,4.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M374.55,851.21c0,9.6-7.87,17.41-17.53,17.41s-17.53-7.79-17.53-17.41,7.87-17.41,17.53-17.41,17.53,7.81,17.53,17.41Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 399.03,
    cy: 864.77,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 427.5,
    cy: 864.77,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M451.74,835.85l-16.17,20.33c-.8,1.15-2.12,1.83-3.52,1.82h-35.42c-2.32,0-4.19-1.76-4.19-3.94v-15.37h-3.21c-2.15,0-4.22-.8-5.8-2.26-1.53-1.4-2.41-3.38-2.42-5.45,.03-.69,.61-1.23,1.3-1.21h65.9c3.33,.02,5.32,3.47,3.53,6.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M131.36,883.52v28.68c0,2.73-2.31,4.99-5.15,4.99H58.42c-1.2,.02-2.19-.94-2.22-2.14v-1c0-6.21,4.39-11.48,10.33-13.02v-17.5c0-2.73,2.32-4.99,5.15-4.99h54.55c2.82,0,5.13,2.24,5.13,4.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M181.28,899.78c0,9.6-7.87,17.41-17.53,17.41s-17.53-7.79-17.53-17.41,7.87-17.41,17.53-17.41,17.53,7.81,17.53,17.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M258.47,884.42l-16.17,20.33c-.8,1.15-2.12,1.83-3.52,1.82h-35.41c-2.32,0-4.19-1.76-4.19-3.94v-15.37h-3.22c-2.15,0-4.23-.81-5.8-2.27-1.53-1.4-2.41-3.37-2.42-5.44,.03-.69,.61-1.23,1.3-1.21h65.9c3.32,.02,5.32,3.46,3.53,6.08Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 291.54,
    cy: 899.74,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M390.5,883.52v28.68c0,2.73-2.32,4.99-5.15,4.99h-67.79c-1.2,.02-2.2-.94-2.22-2.14v-1c0-6.21,4.39-11.48,10.33-13.02v-17.5c0-2.73,2.31-4.99,5.15-4.99h54.55c2.81,0,5.13,2.24,5.13,4.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M440.43,899.78c0,9.6-7.87,17.41-17.53,17.41s-17.53-7.79-17.53-17.41,7.87-17.41,17.53-17.41,17.53,7.81,17.53,17.41Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 414.44,
    cy: 608.35,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M513.41,592.13v28.68c0,2.73-2.32,4.99-5.15,4.99h-67.79c-1.2,.02-2.2-.94-2.22-2.14v-1c0-6.21,4.39-11.47,10.33-13.02v-17.5c0-2.73,2.32-4.99,5.15-4.99h54.55c2.82,0,5.13,2.23,5.13,4.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M563.33,608.39c0,9.6-7.87,17.41-17.53,17.41s-17.53-7.79-17.53-17.41,7.87-17.41,17.53-17.41,17.53,7.81,17.53,17.41Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 587.8,
    cy: 621.94,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 616.28,
    cy: 621.94,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M640.52,593.03l-16.17,20.33c-.8,1.15-2.12,1.83-3.52,1.82h-35.42c-2.32,0-4.19-1.76-4.19-3.94v-15.37h-3.21c-2.15,0-4.22-.8-5.8-2.26-1.53-1.4-2.41-3.36-2.42-5.43,.03-.69,.61-1.23,1.3-1.21h65.9c3.32-.02,5.32,3.44,3.53,6.06Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 673.58,
    cy: 608.35,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 394.54,
    cy: 670.5,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 423.02,
    cy: 670.5,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M447.25,641.59l-16.17,20.34c-.81,1.14-2.12,1.81-3.52,1.8h-35.42c-2.32,0-4.19-1.76-4.19-3.94v-15.35h-3.21c-2.15,0-4.22-.8-5.8-2.26-1.53-1.4-2.41-3.37-2.42-5.44,.03-.69,.61-1.23,1.3-1.21h65.9c3.32,0,5.32,3.45,3.53,6.07Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 480.32,
    cy: 656.92,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M579.28,640.69v28.68c0,2.73-2.31,4.99-5.15,4.99h-67.79c-1.2,.02-2.19-.94-2.22-2.14v-1.01c0-6.21,4.39-11.47,10.33-13.02v-17.5c0-2.73,2.32-4.99,5.15-4.99h54.56c2.79-.02,5.07,2.2,5.12,4.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M629.2,656.95c0,9.6-7.87,17.41-17.53,17.41s-17.52-7.79-17.52-17.41,7.87-17.41,17.53-17.41,17.52,7.81,17.52,17.41Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 653.68,
    cy: 670.5,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 682.16,
    cy: 670.5,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M706.39,641.59l-16.17,20.34c-.81,1.14-2.12,1.81-3.52,1.8h-35.42c-2.32,0-4.19-1.76-4.19-3.94v-15.35h-3.21c-2.15,0-4.22-.8-5.8-2.26-1.53-1.4-2.41-3.37-2.42-5.44,.03-.69,.61-1.23,1.3-1.21h65.9c3.33,0,5.33,3.45,3.53,6.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M435.94,705.51c0,9.6-7.87,17.41-17.53,17.41s-17.53-7.79-17.53-17.41,7.87-17.4,17.53-17.4,17.53,7.8,17.53,17.4Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 460.42,
    cy: 719.07,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 488.89,
    cy: 719.07,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M513.13,690.16l-16.17,20.33c-.81,1.14-2.12,1.82-3.52,1.8h-35.42c-2.32,0-4.19-1.76-4.19-3.94v-15.36h-3.21c-2.15,0-4.22-.8-5.79-2.26-1.53-1.4-2.41-3.38-2.42-5.45,.03-.69,.61-1.23,1.3-1.21h65.9c3.33,.02,5.32,3.47,3.53,6.08Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 546.2,
    cy: 705.48,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M645.16,689.26v28.68c0,2.73-2.32,4.99-5.15,4.99h-67.79c-1.2,.02-2.2-.94-2.22-2.14v-1c0-6.21,4.39-11.48,10.33-13.02v-17.5c0-2.73,2.32-4.99,5.15-4.99h54.55c2.81,0,5.13,2.24,5.13,4.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M695.08,705.51c0,9.6-7.87,17.41-17.53,17.41s-17.53-7.79-17.53-17.41,7.87-17.41,17.53-17.41,17.53,7.81,17.53,17.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M451.89,737.83v28.68c0,2.73-2.31,4.99-5.15,4.99h-67.79c-1.2,.02-2.2-.94-2.22-2.14v-1.01c0-6.21,4.39-11.47,10.33-13.02v-17.5c0-2.73,2.32-4.99,5.15-4.99h54.55c2.79-.03,5.08,2.2,5.13,4.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M501.81,754.08c0,9.6-7.87,17.41-17.53,17.41s-17.53-7.79-17.53-17.41,7.87-17.41,17.53-17.41,17.53,7.81,17.53,17.41Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 526.29,
    cy: 767.64,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 554.77,
    cy: 767.64,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M579.01,738.72l-16.17,20.33c-.81,1.14-2.12,1.81-3.52,1.8h-35.42c-2.32,0-4.19-1.76-4.19-3.94v-15.35h-3.21c-2.15,0-4.22-.8-5.8-2.27-1.53-1.4-2.41-3.37-2.42-5.44,.03-.69,.61-1.23,1.3-1.21h65.9c3.32,0,5.32,3.46,3.53,6.07Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 612.07,
    cy: 754.05,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M711.03,737.83v28.68c0,2.73-2.32,4.99-5.15,4.99h-67.79c-1.2,.02-2.2-.94-2.22-2.14v-1.01c0-6.21,4.39-11.47,10.33-13.02v-17.5c0-2.73,2.31-4.99,5.15-4.99h54.56c2.8,0,5.12,2.24,5.12,4.99Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 418.81,
    cy: 802.61,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M517.77,786.39v28.68c0,2.73-2.31,4.99-5.15,4.99h-67.79c-1.2,.02-2.2-.94-2.22-2.14h0v-1c0-6.21,4.39-11.48,10.33-13.02v-17.5c0-2.73,2.32-4.99,5.15-4.99h54.55c2.82,0,5.13,2.24,5.13,4.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M567.69,802.65c0,9.6-7.87,17.41-17.53,17.41s-17.53-7.79-17.53-17.41,7.87-17.41,17.53-17.41,17.53,7.81,17.53,17.41Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 592.17,
    cy: 816.2,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 620.64,
    cy: 816.2,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M644.88,787.29l-16.17,20.33c-.81,1.14-2.12,1.81-3.52,1.8h-35.42c-2.32,0-4.2-1.76-4.2-3.94v-15.36h-3.21c-2.15,0-4.21-.8-5.79-2.26-1.53-1.4-2.41-3.38-2.42-5.45,.03-.69,.61-1.23,1.3-1.21h65.9c3.32,.02,5.32,3.47,3.53,6.08Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 677.95,
    cy: 802.61,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 398.9,
    cy: 864.77,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 427.38,
    cy: 864.77,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M451.61,835.85l-16.17,20.33c-.8,1.15-2.12,1.83-3.52,1.82h-35.41c-2.32,0-4.19-1.76-4.19-3.94v-15.37h-3.22c-2.15,0-4.22-.8-5.8-2.26-1.53-1.4-2.41-3.38-2.42-5.45,.03-.69,.61-1.23,1.3-1.21h65.91c3.32,.02,5.32,3.47,3.53,6.08Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 484.68,
    cy: 851.18,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M583.64,834.96v28.68c0,2.73-2.32,4.99-5.15,4.99h-67.79c-1.2,.02-2.2-.94-2.22-2.14v-1.01c0-6.21,4.39-11.47,10.33-13.02v-17.5c0-2.73,2.31-4.99,5.15-4.99h54.55c2.81,0,5.13,2.24,5.13,4.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M633.57,851.21c0,9.6-7.87,17.41-17.53,17.41s-17.53-7.79-17.53-17.41,7.87-17.41,17.53-17.41,17.53,7.81,17.53,17.41Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 658.04,
    cy: 864.77,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 686.52,
    cy: 864.77,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M710.76,835.85l-16.17,20.33c-.8,1.15-2.12,1.83-3.52,1.82h-35.42c-2.32,0-4.19-1.76-4.19-3.94v-15.37h-3.21c-2.15,0-4.22-.8-5.8-2.26-1.53-1.4-2.41-3.38-2.42-5.45,.03-.69,.61-1.23,1.3-1.21h65.9c3.33,.02,5.32,3.47,3.53,6.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M390.38,883.52v28.68c0,2.73-2.31,4.99-5.15,4.99h-67.79c-1.2,.02-2.19-.94-2.22-2.14v-1c0-6.21,4.39-11.48,10.33-13.02v-17.5c0-2.73,2.32-4.99,5.15-4.99h54.55c2.82,0,5.13,2.24,5.13,4.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M440.3,899.78c0,9.6-7.87,17.41-17.53,17.41s-17.53-7.79-17.53-17.41,7.87-17.41,17.53-17.41,17.53,7.81,17.53,17.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M517.49,884.42l-16.17,20.33c-.8,1.15-2.12,1.83-3.52,1.82h-35.41c-2.32,0-4.19-1.76-4.19-3.94v-15.37h-3.22c-2.15,0-4.23-.81-5.8-2.27-1.53-1.4-2.41-3.37-2.42-5.44,.03-.69,.61-1.23,1.3-1.21h65.9c3.32,.02,5.32,3.46,3.53,6.08Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 550.56,
    cy: 899.74,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M649.52,883.52v28.68c0,2.73-2.32,4.99-5.15,4.99h-67.79c-1.2,.02-2.2-.94-2.22-2.14v-1c0-6.21,4.39-11.48,10.33-13.02v-17.5c0-2.73,2.31-4.99,5.15-4.99h54.55c2.81,0,5.13,2.24,5.13,4.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M699.45,899.78c0,9.6-7.87,17.41-17.53,17.41s-17.53-7.79-17.53-17.41,7.87-17.41,17.53-17.41,17.53,7.81,17.53,17.41Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 673.46,
    cy: 608.35,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M772.42,592.13v28.68c0,2.73-2.32,4.99-5.15,4.99h-67.79c-1.2,.02-2.2-.94-2.22-2.14v-1c0-6.21,4.39-11.47,10.33-13.02v-17.5c0-2.73,2.32-4.99,5.15-4.99h54.55c2.82,0,5.13,2.23,5.13,4.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M822.35,608.39c0,9.6-7.87,17.41-17.53,17.41s-17.53-7.79-17.53-17.41,7.87-17.41,17.53-17.41,17.53,7.81,17.53,17.41Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 846.82,
    cy: 621.94,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 875.3,
    cy: 621.94,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M899.53,593.03l-16.17,20.33c-.8,1.15-2.12,1.83-3.52,1.82h-35.42c-2.32,0-4.19-1.76-4.19-3.94v-15.37h-3.21c-2.15,0-4.22-.8-5.8-2.26-1.53-1.4-2.41-3.36-2.42-5.43,.03-.69,.61-1.23,1.3-1.21h65.9c3.32-.02,5.32,3.44,3.53,6.06Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 932.6,
    cy: 608.35,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 653.56,
    cy: 670.5,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 682.03,
    cy: 670.5,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M706.27,641.59l-16.17,20.34c-.81,1.14-2.12,1.81-3.52,1.8h-35.42c-2.32,0-4.19-1.76-4.19-3.94v-15.35h-3.21c-2.15,0-4.22-.8-5.8-2.26-1.53-1.4-2.41-3.37-2.42-5.44,.03-.69,.61-1.23,1.3-1.21h65.9c3.32,0,5.32,3.45,3.53,6.07Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 739.34,
    cy: 656.92,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M838.3,640.69v28.68c0,2.73-2.31,4.99-5.15,4.99h-67.79c-1.2,.02-2.19-.94-2.22-2.14v-1.01c0-6.21,4.39-11.47,10.33-13.02v-17.5c0-2.73,2.32-4.99,5.15-4.99h54.56c2.79-.02,5.07,2.2,5.12,4.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M888.22,656.95c0,9.6-7.87,17.41-17.53,17.41s-17.52-7.79-17.52-17.41,7.87-17.41,17.53-17.41,17.52,7.81,17.52,17.41Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 912.7,
    cy: 670.5,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 941.17,
    cy: 670.5,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M965.41,641.59l-16.17,20.34c-.81,1.14-2.12,1.81-3.52,1.8h-35.42c-2.32,0-4.19-1.76-4.19-3.94v-15.35h-3.21c-2.15,0-4.22-.8-5.8-2.26-1.53-1.4-2.41-3.37-2.42-5.44,.03-.69,.61-1.23,1.3-1.21h65.9c3.33,0,5.33,3.45,3.53,6.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M694.96,705.51c0,9.6-7.87,17.41-17.53,17.41s-17.53-7.79-17.53-17.41,7.87-17.4,17.53-17.4,17.53,7.8,17.53,17.4Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 719.43,
    cy: 719.07,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 747.91,
    cy: 719.07,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M772.14,690.16l-16.17,20.33c-.81,1.14-2.12,1.82-3.52,1.8h-35.42c-2.32,0-4.19-1.76-4.19-3.94v-15.36h-3.21c-2.15,0-4.22-.8-5.79-2.26-1.53-1.4-2.41-3.38-2.42-5.45,.03-.69,.61-1.23,1.3-1.21h65.9c3.33,.02,5.32,3.47,3.53,6.08Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 805.21,
    cy: 705.48,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M904.17,689.26v28.68c0,2.73-2.32,4.99-5.15,4.99h-67.79c-1.2,.02-2.2-.94-2.22-2.14v-1c0-6.21,4.39-11.48,10.33-13.02v-17.5c0-2.73,2.32-4.99,5.15-4.99h54.55c2.81,0,5.13,2.24,5.13,4.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M954.1,705.51c0,9.6-7.87,17.41-17.53,17.41s-17.53-7.79-17.53-17.41,7.87-17.41,17.53-17.41,17.53,7.81,17.53,17.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M710.91,737.83v28.68c0,2.73-2.31,4.99-5.15,4.99h-67.79c-1.2,.02-2.2-.94-2.22-2.14v-1.01c0-6.21,4.39-11.47,10.33-13.02v-17.5c0-2.73,2.32-4.99,5.15-4.99h54.55c2.79-.03,5.08,2.2,5.13,4.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M760.83,754.08c0,9.6-7.87,17.41-17.53,17.41s-17.53-7.79-17.53-17.41,7.87-17.41,17.53-17.41,17.53,7.81,17.53,17.41Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 785.31,
    cy: 767.64,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 813.79,
    cy: 767.64,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M838.02,738.72l-16.17,20.33c-.81,1.14-2.12,1.81-3.52,1.8h-35.42c-2.32,0-4.19-1.76-4.19-3.94v-15.35h-3.21c-2.15,0-4.22-.8-5.8-2.27-1.53-1.4-2.41-3.37-2.42-5.44,.03-.69,.61-1.23,1.3-1.21h65.9c3.32,0,5.32,3.46,3.53,6.07Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 871.09,
    cy: 754.05,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M970.05,737.83v28.68c0,2.73-2.32,4.99-5.15,4.99h-67.79c-1.2,.02-2.2-.94-2.22-2.14v-1.01c0-6.21,4.39-11.47,10.33-13.02v-17.5c0-2.73,2.31-4.99,5.15-4.99h54.56c2.8,0,5.12,2.24,5.12,4.99Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 677.82,
    cy: 802.61,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M776.78,786.39v28.68c0,2.73-2.31,4.99-5.15,4.99h-67.79c-1.2,.02-2.2-.94-2.22-2.14h0v-1c0-6.21,4.39-11.48,10.33-13.02v-17.5c0-2.73,2.32-4.99,5.15-4.99h54.55c2.82,0,5.13,2.24,5.13,4.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M826.71,802.65c0,9.6-7.87,17.41-17.53,17.41s-17.53-7.79-17.53-17.41,7.87-17.41,17.53-17.41,17.53,7.81,17.53,17.41Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 851.19,
    cy: 816.2,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 879.66,
    cy: 816.2,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M903.9,787.29l-16.17,20.33c-.81,1.14-2.12,1.81-3.52,1.8h-35.42c-2.32,0-4.2-1.76-4.2-3.94v-15.36h-3.21c-2.15,0-4.21-.8-5.79-2.26-1.53-1.4-2.41-3.38-2.42-5.45,.03-.69,.61-1.23,1.3-1.21h65.9c3.32,.02,5.32,3.47,3.53,6.08Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 936.96,
    cy: 802.61,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 657.92,
    cy: 864.77,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 686.4,
    cy: 864.77,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M710.63,835.85l-16.17,20.33c-.8,1.15-2.12,1.83-3.52,1.82h-35.41c-2.32,0-4.19-1.76-4.19-3.94v-15.37h-3.22c-2.15,0-4.22-.8-5.8-2.26-1.53-1.4-2.41-3.38-2.42-5.45,.03-.69,.61-1.23,1.3-1.21h65.91c3.32,.02,5.32,3.47,3.53,6.08Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 743.7,
    cy: 851.18,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M842.66,834.96v28.68c0,2.73-2.32,4.99-5.15,4.99h-67.79c-1.2,.02-2.2-.94-2.22-2.14v-1.01c0-6.21,4.39-11.47,10.33-13.02v-17.5c0-2.73,2.31-4.99,5.15-4.99h54.55c2.81,0,5.13,2.24,5.13,4.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M892.59,851.21c0,9.6-7.87,17.41-17.53,17.41s-17.53-7.79-17.53-17.41,7.87-17.41,17.53-17.41,17.53,7.81,17.53,17.41Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 917.06,
    cy: 864.77,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 945.54,
    cy: 864.77,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M969.78,835.85l-16.17,20.33c-.8,1.15-2.12,1.83-3.52,1.82h-35.42c-2.32,0-4.19-1.76-4.19-3.94v-15.37h-3.21c-2.15,0-4.22-.8-5.8-2.26-1.53-1.4-2.41-3.38-2.42-5.45,.03-.69,.61-1.23,1.3-1.21h65.9c3.33,.02,5.32,3.47,3.53,6.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M649.4,883.52v28.68c0,2.73-2.31,4.99-5.15,4.99h-67.79c-1.2,.02-2.19-.94-2.22-2.14v-1c0-6.21,4.39-11.48,10.33-13.02v-17.5c0-2.73,2.32-4.99,5.15-4.99h54.55c2.82,0,5.13,2.24,5.13,4.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M699.32,899.78c0,9.6-7.87,17.41-17.53,17.41s-17.53-7.79-17.53-17.41,7.87-17.41,17.53-17.41,17.53,7.81,17.53,17.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M776.51,884.42l-16.17,20.33c-.8,1.15-2.12,1.83-3.52,1.82h-35.41c-2.32,0-4.19-1.76-4.19-3.94v-15.37h-3.22c-2.15,0-4.23-.81-5.8-2.27-1.53-1.4-2.41-3.37-2.42-5.44,.03-.69,.61-1.23,1.3-1.21h65.9c3.32,.02,5.32,3.46,3.53,6.08Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 809.57,
    cy: 899.74,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M908.54,883.52v28.68c0,2.73-2.32,4.99-5.15,4.99h-67.79c-1.2,.02-2.2-.94-2.22-2.14v-1c0-6.21,4.39-11.48,10.33-13.02v-17.5c0-2.73,2.31-4.99,5.15-4.99h54.55c2.81,0,5.13,2.24,5.13,4.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M958.46,899.78c0,9.6-7.87,17.41-17.53,17.41s-17.53-7.79-17.53-17.41,7.87-17.41,17.53-17.41,17.53,7.81,17.53,17.41Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M-.56,883.91l-16.17,20.33c-.8,1.15-2.12,1.83-3.52,1.82H-55.67c-2.32,0-4.19-1.76-4.19-3.94v-15.37h-3.21c-2.15,0-4.22-.8-5.8-2.26-1.53-1.4-2.41-3.36-2.42-5.43,.03-.69,.61-1.23,1.3-1.21H-4.09c3.32-.02,5.32,3.44,3.53,6.06Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 32.51,
    cy: 899.24,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 12.6,
    cy: 961.39,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 41.08,
    cy: 961.39,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M65.32,932.48l-16.17,20.34c-.81,1.14-2.12,1.81-3.52,1.8H10.21c-2.32,0-4.19-1.76-4.19-3.94v-15.35H2.81c-2.15,0-4.22-.8-5.8-2.26-1.53-1.4-2.41-3.37-2.42-5.44,.03-.69,.61-1.23,1.3-1.21H61.78c3.33,0,5.33,3.45,3.53,6.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M4.08,980.15v28.68c0,2.73-2.32,4.99-5.15,4.99H-68.86c-1.2,.02-2.2-.94-2.22-2.14v-1c0-6.21,4.39-11.48,10.33-13.02v-17.5c0-2.73,2.32-4.99,5.15-4.99H-1.05c2.81,0,5.13,2.24,5.13,4.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M54,996.4c0,9.6-7.87,17.41-17.53,17.41s-17.53-7.79-17.53-17.41,7.87-17.41,17.53-17.41,17.53,7.81,17.53,17.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M69.96,1028.71v28.68c0,2.73-2.32,4.99-5.15,4.99H-2.98c-1.2,.02-2.2-.94-2.22-2.14v-1.01c0-6.21,4.39-11.47,10.33-13.02v-17.5c0-2.73,2.31-4.99,5.15-4.99h54.56c2.8,0,5.12,2.24,5.12,4.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M3.8,1078.18l-16.17,20.33c-.81,1.14-2.12,1.81-3.52,1.8H-51.3c-2.32,0-4.2-1.76-4.2-3.94v-15.36h-3.21c-2.15,0-4.21-.8-5.79-2.26-1.53-1.4-2.41-3.38-2.42-5.45,.03-.69,.61-1.23,1.3-1.21H.28c3.32,.02,5.32,3.47,3.53,6.08Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 36.87,
    cy: 1093.5,
    rx: 17.53,
    ry: 17.41
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 32.38,
    cy: 899.24,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M131.35,883.01v28.68c0,2.73-2.32,4.99-5.15,4.99H58.41c-1.2,.02-2.2-.94-2.22-2.14v-1c0-6.21,4.39-11.47,10.33-13.02v-17.5c0-2.73,2.32-4.99,5.15-4.99h54.55c2.82,0,5.13,2.23,5.13,4.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M181.27,899.27c0,9.6-7.87,17.41-17.53,17.41s-17.53-7.79-17.53-17.41,7.87-17.41,17.53-17.41,17.53,7.81,17.53,17.41Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 205.74,
    cy: 912.82,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 234.22,
    cy: 912.82,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M258.46,883.91l-16.17,20.33c-.8,1.15-2.12,1.83-3.52,1.82h-35.42c-2.32,0-4.19-1.76-4.19-3.94v-15.37h-3.21c-2.15,0-4.22-.8-5.8-2.26-1.53-1.4-2.41-3.36-2.42-5.43,.03-.69,.61-1.23,1.3-1.21h65.9c3.32-.02,5.32,3.44,3.53,6.06Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 291.52,
    cy: 899.24,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 12.48,
    cy: 961.39,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 40.96,
    cy: 961.39,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M65.19,932.48l-16.17,20.34c-.81,1.14-2.12,1.81-3.52,1.8H10.09c-2.32,0-4.19-1.76-4.19-3.94v-15.35H2.68c-2.15,0-4.22-.8-5.8-2.26-1.53-1.4-2.41-3.37-2.42-5.44,.03-.69,.61-1.23,1.3-1.21H61.67c3.32,0,5.32,3.45,3.53,6.07Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 98.26,
    cy: 947.8,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M197.22,931.58v28.68c0,2.73-2.31,4.99-5.15,4.99H124.28c-1.2,.02-2.19-.94-2.22-2.14v-1.01c0-6.21,4.39-11.47,10.33-13.02v-17.5c0-2.73,2.32-4.99,5.15-4.99h54.56c2.79-.02,5.07,2.2,5.12,4.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M247.14,947.84c0,9.6-7.87,17.41-17.53,17.41s-17.52-7.79-17.52-17.41,7.87-17.41,17.53-17.41,17.52,7.81,17.52,17.41Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 271.62,
    cy: 961.39,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 300.1,
    cy: 961.39,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M324.33,932.48l-16.17,20.34c-.81,1.14-2.12,1.81-3.52,1.8h-35.42c-2.32,0-4.19-1.76-4.19-3.94v-15.35h-3.21c-2.15,0-4.22-.8-5.8-2.26-1.53-1.4-2.41-3.37-2.42-5.44,.03-.69,.61-1.23,1.3-1.21h65.9c3.33,0,5.33,3.45,3.53,6.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M53.88,996.4c0,9.6-7.87,17.41-17.53,17.41s-17.53-7.79-17.53-17.41,7.87-17.4,17.53-17.4,17.53,7.8,17.53,17.4Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 78.36,
    cy: 1009.96,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 106.83,
    cy: 1009.96,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M131.07,981.04l-16.17,20.33c-.81,1.14-2.12,1.82-3.52,1.8h-35.42c-2.32,0-4.19-1.76-4.19-3.94v-15.36h-3.21c-2.15,0-4.22-.8-5.79-2.26-1.53-1.4-2.41-3.38-2.42-5.45,.03-.69,.61-1.23,1.3-1.21H127.54c3.33,.02,5.32,3.47,3.53,6.08Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 164.14,
    cy: 996.37,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M263.1,980.15v28.68c0,2.73-2.32,4.99-5.15,4.99h-67.79c-1.2,.02-2.2-.94-2.22-2.14v-1c0-6.21,4.39-11.48,10.33-13.02v-17.5c0-2.73,2.32-4.99,5.15-4.99h54.55c2.81,0,5.13,2.24,5.13,4.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M313.02,996.4c0,9.6-7.87,17.41-17.53,17.41s-17.53-7.79-17.53-17.41,7.87-17.41,17.53-17.41,17.53,7.81,17.53,17.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M69.83,1028.71v28.68c0,2.73-2.31,4.99-5.15,4.99H-3.1c-1.2,.02-2.2-.94-2.22-2.14v-1.01c0-6.21,4.39-11.47,10.33-13.02v-17.5c0-2.73,2.32-4.99,5.15-4.99h54.55c2.79-.03,5.08,2.2,5.13,4.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M119.75,1044.97c0,9.6-7.87,17.41-17.53,17.41s-17.53-7.79-17.53-17.41,7.87-17.41,17.53-17.41,17.53,7.81,17.53,17.41Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 144.23,
    cy: 1058.52,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 172.71,
    cy: 1058.52,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M196.95,1029.61l-16.17,20.33c-.81,1.14-2.12,1.81-3.52,1.8h-35.42c-2.32,0-4.19-1.76-4.19-3.94v-15.35h-3.21c-2.15,0-4.22-.8-5.8-2.27-1.53-1.4-2.41-3.37-2.42-5.44,.03-.69,.61-1.23,1.3-1.21h65.9c3.32,0,5.32,3.46,3.53,6.07Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 230.01,
    cy: 1044.94,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M328.97,1028.71v28.68c0,2.73-2.32,4.99-5.15,4.99h-67.79c-1.2,.02-2.2-.94-2.22-2.14v-1.01c0-6.21,4.39-11.47,10.33-13.02v-17.5c0-2.73,2.31-4.99,5.15-4.99h54.56c2.8,0,5.12,2.24,5.12,4.99Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 36.75,
    cy: 1093.5,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M135.71,1077.28v28.68c0,2.73-2.31,4.99-5.15,4.99H62.77c-1.2,.02-2.2-.94-2.22-2.14h0v-1c0-6.21,4.39-11.48,10.33-13.02v-17.5c0-2.73,2.32-4.99,5.15-4.99h54.55c2.82,0,5.13,2.24,5.13,4.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M185.63,1093.53c0,9.6-7.87,17.41-17.53,17.41s-17.53-7.79-17.53-17.41,7.87-17.41,17.53-17.41,17.53,7.81,17.53,17.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M262.82,1078.18l-16.17,20.33c-.81,1.14-2.12,1.81-3.52,1.8h-35.42c-2.32,0-4.2-1.76-4.2-3.94v-15.36h-3.21c-2.15,0-4.21-.8-5.79-2.26-1.53-1.4-2.41-3.38-2.42-5.45,.03-.69,.61-1.23,1.3-1.21h65.9c3.32,.02,5.32,3.47,3.53,6.08Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 295.89,
    cy: 1093.5,
    rx: 17.53,
    ry: 17.41
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 291.4,
    cy: 899.24,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M390.36,883.01v28.68c0,2.73-2.32,4.99-5.15,4.99h-67.79c-1.2,.02-2.2-.94-2.22-2.14v-1c0-6.21,4.39-11.47,10.33-13.02v-17.5c0-2.73,2.32-4.99,5.15-4.99h54.55c2.82,0,5.13,2.23,5.13,4.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M440.29,899.27c0,9.6-7.87,17.41-17.53,17.41s-17.53-7.79-17.53-17.41,7.87-17.41,17.53-17.41,17.53,7.81,17.53,17.41Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 464.76,
    cy: 912.82,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 493.24,
    cy: 912.82,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M517.47,883.91l-16.17,20.33c-.8,1.15-2.12,1.83-3.52,1.82h-35.42c-2.32,0-4.19-1.76-4.19-3.94v-15.37h-3.21c-2.15,0-4.22-.8-5.8-2.26-1.53-1.4-2.41-3.36-2.42-5.43,.03-.69,.61-1.23,1.3-1.21h65.9c3.32-.02,5.32,3.44,3.53,6.06Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 550.54,
    cy: 899.24,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 271.5,
    cy: 961.39,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 299.97,
    cy: 961.39,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M324.21,932.48l-16.17,20.34c-.81,1.14-2.12,1.81-3.52,1.8h-35.42c-2.32,0-4.19-1.76-4.19-3.94v-15.35h-3.21c-2.15,0-4.22-.8-5.8-2.26-1.53-1.4-2.41-3.37-2.42-5.44,.03-.69,.61-1.23,1.3-1.21h65.9c3.32,0,5.32,3.45,3.53,6.07Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 357.28,
    cy: 947.8,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M456.24,931.58v28.68c0,2.73-2.31,4.99-5.15,4.99h-67.79c-1.2,.02-2.19-.94-2.22-2.14v-1.01c0-6.21,4.39-11.47,10.33-13.02v-17.5c0-2.73,2.32-4.99,5.15-4.99h54.56c2.79-.02,5.07,2.2,5.12,4.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M506.16,947.84c0,9.6-7.87,17.41-17.53,17.41s-17.52-7.79-17.52-17.41,7.87-17.41,17.53-17.41,17.52,7.81,17.52,17.41Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 530.64,
    cy: 961.39,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 559.11,
    cy: 961.39,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M583.35,932.48l-16.17,20.34c-.81,1.14-2.12,1.81-3.52,1.8h-35.42c-2.32,0-4.19-1.76-4.19-3.94v-15.35h-3.21c-2.15,0-4.22-.8-5.8-2.26-1.53-1.4-2.41-3.37-2.42-5.44,.03-.69,.61-1.23,1.3-1.21h65.9c3.33,0,5.33,3.45,3.53,6.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M312.9,996.4c0,9.6-7.87,17.41-17.53,17.41s-17.53-7.79-17.53-17.41,7.87-17.4,17.53-17.4,17.53,7.8,17.53,17.4Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 337.37,
    cy: 1009.96,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 365.85,
    cy: 1009.96,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M390.08,981.04l-16.17,20.33c-.81,1.14-2.12,1.82-3.52,1.8h-35.42c-2.32,0-4.19-1.76-4.19-3.94v-15.36h-3.21c-2.15,0-4.22-.8-5.79-2.26-1.53-1.4-2.41-3.38-2.42-5.45,.03-.69,.61-1.23,1.3-1.21h65.9c3.33,.02,5.32,3.47,3.53,6.08Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 423.15,
    cy: 996.37,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M522.11,980.15v28.68c0,2.73-2.32,4.99-5.15,4.99h-67.79c-1.2,.02-2.2-.94-2.22-2.14v-1c0-6.21,4.39-11.48,10.33-13.02v-17.5c0-2.73,2.32-4.99,5.15-4.99h54.55c2.81,0,5.13,2.24,5.13,4.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M572.04,996.4c0,9.6-7.87,17.41-17.53,17.41s-17.53-7.79-17.53-17.41,7.87-17.41,17.53-17.41,17.53,7.81,17.53,17.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M328.85,1028.71v28.68c0,2.73-2.31,4.99-5.15,4.99h-67.79c-1.2,.02-2.2-.94-2.22-2.14v-1.01c0-6.21,4.39-11.47,10.33-13.02v-17.5c0-2.73,2.32-4.99,5.15-4.99h54.55c2.79-.03,5.08,2.2,5.13,4.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M378.77,1044.97c0,9.6-7.87,17.41-17.53,17.41s-17.53-7.79-17.53-17.41,7.87-17.41,17.53-17.41,17.53,7.81,17.53,17.41Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 403.25,
    cy: 1058.52,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 431.73,
    cy: 1058.52,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M455.96,1029.61l-16.17,20.33c-.81,1.14-2.12,1.81-3.52,1.8h-35.42c-2.32,0-4.19-1.76-4.19-3.94v-15.35h-3.21c-2.15,0-4.22-.8-5.8-2.27-1.53-1.4-2.41-3.37-2.42-5.44,.03-.69,.61-1.23,1.3-1.21h65.9c3.32,0,5.32,3.46,3.53,6.07Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 489.03,
    cy: 1044.94,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M587.99,1028.71v28.68c0,2.73-2.32,4.99-5.15,4.99h-67.79c-1.2,.02-2.2-.94-2.22-2.14v-1.01c0-6.21,4.39-11.47,10.33-13.02v-17.5c0-2.73,2.31-4.99,5.15-4.99h54.56c2.8,0,5.12,2.24,5.12,4.99Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 295.76,
    cy: 1093.5,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M394.72,1077.28v28.68c0,2.73-2.31,4.99-5.15,4.99h-67.79c-1.2,.02-2.2-.94-2.22-2.14h0v-1c0-6.21,4.39-11.48,10.33-13.02v-17.5c0-2.73,2.32-4.99,5.15-4.99h54.55c2.82,0,5.13,2.24,5.13,4.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M444.65,1093.53c0,9.6-7.87,17.41-17.53,17.41s-17.53-7.79-17.53-17.41,7.87-17.41,17.53-17.41,17.53,7.81,17.53,17.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M521.84,1078.18l-16.17,20.33c-.81,1.14-2.12,1.81-3.52,1.8h-35.42c-2.32,0-4.2-1.76-4.2-3.94v-15.36h-3.21c-2.15,0-4.21-.8-5.79-2.26-1.53-1.4-2.41-3.38-2.42-5.45,.03-.69,.61-1.23,1.3-1.21h65.9c3.32,.02,5.32,3.47,3.53,6.08Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 554.9,
    cy: 1093.5,
    rx: 17.53,
    ry: 17.41
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 550.42,
    cy: 899.24,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M649.38,883.01v28.68c0,2.73-2.32,4.99-5.15,4.99h-67.79c-1.2,.02-2.2-.94-2.22-2.14v-1c0-6.21,4.39-11.47,10.33-13.02v-17.5c0-2.73,2.32-4.99,5.15-4.99h54.55c2.82,0,5.13,2.23,5.13,4.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M699.31,899.27c0,9.6-7.87,17.41-17.53,17.41s-17.53-7.79-17.53-17.41,7.87-17.41,17.53-17.41,17.53,7.81,17.53,17.41Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 723.78,
    cy: 912.82,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 752.26,
    cy: 912.82,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M776.49,883.91l-16.17,20.33c-.8,1.15-2.12,1.83-3.52,1.82h-35.42c-2.32,0-4.19-1.76-4.19-3.94v-15.37h-3.21c-2.15,0-4.22-.8-5.8-2.26-1.53-1.4-2.41-3.36-2.42-5.43,.03-.69,.61-1.23,1.3-1.21h65.9c3.32-.02,5.32,3.44,3.53,6.06Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 809.56,
    cy: 899.24,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 530.51,
    cy: 961.39,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 558.99,
    cy: 961.39,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M583.23,932.48l-16.17,20.34c-.81,1.14-2.12,1.81-3.52,1.8h-35.42c-2.32,0-4.19-1.76-4.19-3.94v-15.35h-3.21c-2.15,0-4.22-.8-5.8-2.26-1.53-1.4-2.41-3.37-2.42-5.44,.03-.69,.61-1.23,1.3-1.21h65.9c3.32,0,5.32,3.45,3.53,6.07Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 616.29,
    cy: 947.8,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M715.26,931.58v28.68c0,2.73-2.31,4.99-5.15,4.99h-67.79c-1.2,.02-2.19-.94-2.22-2.14v-1.01c0-6.21,4.39-11.47,10.33-13.02v-17.5c0-2.73,2.32-4.99,5.15-4.99h54.56c2.79-.02,5.07,2.2,5.12,4.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M765.18,947.84c0,9.6-7.87,17.41-17.53,17.41s-17.52-7.79-17.52-17.41,7.87-17.41,17.53-17.41,17.52,7.81,17.52,17.41Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 789.66,
    cy: 961.39,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 818.13,
    cy: 961.39,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M842.37,932.48l-16.17,20.34c-.81,1.14-2.12,1.81-3.52,1.8h-35.42c-2.32,0-4.19-1.76-4.19-3.94v-15.35h-3.21c-2.15,0-4.22-.8-5.8-2.26-1.53-1.4-2.41-3.37-2.42-5.44,.03-.69,.61-1.23,1.3-1.21h65.9c3.33,0,5.33,3.45,3.53,6.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M571.92,996.4c0,9.6-7.87,17.41-17.53,17.41s-17.53-7.79-17.53-17.41,7.87-17.4,17.53-17.4,17.53,7.8,17.53,17.4Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 596.39,
    cy: 1009.96,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 624.87,
    cy: 1009.96,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M649.1,981.04l-16.17,20.33c-.81,1.14-2.12,1.82-3.52,1.8h-35.42c-2.32,0-4.19-1.76-4.19-3.94v-15.36h-3.21c-2.15,0-4.22-.8-5.79-2.26-1.53-1.4-2.41-3.38-2.42-5.45,.03-.69,.61-1.23,1.3-1.21h65.9c3.33,.02,5.32,3.47,3.53,6.08Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 682.17,
    cy: 996.37,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M781.13,980.15v28.68c0,2.73-2.32,4.99-5.15,4.99h-67.79c-1.2,.02-2.2-.94-2.22-2.14v-1c0-6.21,4.39-11.48,10.33-13.02v-17.5c0-2.73,2.32-4.99,5.15-4.99h54.55c2.81,0,5.13,2.24,5.13,4.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M831.06,996.4c0,9.6-7.87,17.41-17.53,17.41s-17.53-7.79-17.53-17.41,7.87-17.41,17.53-17.41,17.53,7.81,17.53,17.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M587.87,1028.71v28.68c0,2.73-2.31,4.99-5.15,4.99h-67.79c-1.2,.02-2.2-.94-2.22-2.14v-1.01c0-6.21,4.39-11.47,10.33-13.02v-17.5c0-2.73,2.32-4.99,5.15-4.99h54.55c2.79-.03,5.08,2.2,5.13,4.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M637.79,1044.97c0,9.6-7.87,17.41-17.53,17.41s-17.53-7.79-17.53-17.41,7.87-17.41,17.53-17.41,17.53,7.81,17.53,17.41Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 662.27,
    cy: 1058.52,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 690.75,
    cy: 1058.52,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M714.98,1029.61l-16.17,20.33c-.81,1.14-2.12,1.81-3.52,1.8h-35.42c-2.32,0-4.19-1.76-4.19-3.94v-15.35h-3.21c-2.15,0-4.22-.8-5.8-2.27-1.53-1.4-2.41-3.37-2.42-5.44,.03-.69,.61-1.23,1.3-1.21h65.9c3.32,0,5.32,3.46,3.53,6.07Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 748.05,
    cy: 1044.94,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M847.01,1028.71v28.68c0,2.73-2.32,4.99-5.15,4.99h-67.79c-1.2,.02-2.2-.94-2.22-2.14v-1.01c0-6.21,4.39-11.47,10.33-13.02v-17.5c0-2.73,2.31-4.99,5.15-4.99h54.56c2.8,0,5.12,2.24,5.12,4.99Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 554.78,
    cy: 1093.5,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M653.74,1077.28v28.68c0,2.73-2.31,4.99-5.15,4.99h-67.79c-1.2,.02-2.2-.94-2.22-2.14h0v-1c0-6.21,4.39-11.48,10.33-13.02v-17.5c0-2.73,2.32-4.99,5.15-4.99h54.55c2.82,0,5.13,2.24,5.13,4.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M703.67,1093.53c0,9.6-7.87,17.41-17.53,17.41s-17.53-7.79-17.53-17.41,7.87-17.41,17.53-17.41,17.53,7.81,17.53,17.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M780.86,1078.18l-16.17,20.33c-.81,1.14-2.12,1.81-3.52,1.8h-35.42c-2.32,0-4.2-1.76-4.2-3.94v-15.36h-3.21c-2.15,0-4.21-.8-5.79-2.26-1.53-1.4-2.41-3.38-2.42-5.45,.03-.69,.61-1.23,1.3-1.21h65.9c3.32,.02,5.32,3.47,3.53,6.08Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 813.92,
    cy: 1093.5,
    rx: 17.53,
    ry: 17.41
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 809.61,
    cy: 899.24,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M908.57,883.01v28.68c0,2.73-2.32,4.99-5.15,4.99h-67.79c-1.2,.02-2.2-.94-2.22-2.14v-1c0-6.21,4.39-11.47,10.33-13.02v-17.5c0-2.73,2.32-4.99,5.15-4.99h54.55c2.82,0,5.13,2.23,5.13,4.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M958.5,899.27c0,9.6-7.87,17.41-17.53,17.41s-17.53-7.79-17.53-17.41,7.87-17.41,17.53-17.41,17.53,7.81,17.53,17.41Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 982.97,
    cy: 912.82,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1011.45,
    cy: 912.82,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1035.68,883.91l-16.17,20.33c-.8,1.15-2.12,1.83-3.52,1.82h-35.42c-2.32,0-4.19-1.76-4.19-3.94v-15.37h-3.21c-2.15,0-4.22-.8-5.8-2.26-1.53-1.4-2.41-3.36-2.42-5.43,.03-.69,.61-1.23,1.3-1.21h65.9c3.32-.02,5.32,3.44,3.53,6.06Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1068.75,
    cy: 899.24,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 789.71,
    cy: 961.39,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 818.18,
    cy: 961.39,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M842.42,932.48l-16.17,20.34c-.81,1.14-2.12,1.81-3.52,1.8h-35.42c-2.32,0-4.19-1.76-4.19-3.94v-15.35h-3.21c-2.15,0-4.22-.8-5.8-2.26-1.53-1.4-2.41-3.37-2.42-5.44,.03-.69,.61-1.23,1.3-1.21h65.9c3.32,0,5.32,3.45,3.53,6.07Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 875.49,
    cy: 947.8,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M974.45,931.58v28.68c0,2.73-2.31,4.99-5.15,4.99h-67.79c-1.2,.02-2.19-.94-2.22-2.14v-1.01c0-6.21,4.39-11.47,10.33-13.02v-17.5c0-2.73,2.32-4.99,5.15-4.99h54.56c2.79-.02,5.07,2.2,5.12,4.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1024.37,947.84c0,9.6-7.87,17.41-17.53,17.41s-17.52-7.79-17.52-17.41,7.87-17.41,17.53-17.41,17.52,7.81,17.52,17.41Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1048.85,
    cy: 961.39,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1077.32,
    cy: 961.39,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1101.56,932.48l-16.17,20.34c-.81,1.14-2.12,1.81-3.52,1.8h-35.42c-2.32,0-4.19-1.76-4.19-3.94v-15.35h-3.21c-2.15,0-4.22-.8-5.8-2.26-1.53-1.4-2.41-3.37-2.42-5.44,.03-.69,.61-1.23,1.3-1.21h65.9c3.33,0,5.33,3.45,3.53,6.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M831.11,996.4c0,9.6-7.87,17.41-17.53,17.41s-17.53-7.79-17.53-17.41,7.87-17.4,17.53-17.4,17.53,7.8,17.53,17.4Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 855.58,
    cy: 1009.96,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 884.06,
    cy: 1009.96,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M908.29,981.04l-16.17,20.33c-.81,1.14-2.12,1.82-3.52,1.8h-35.42c-2.32,0-4.19-1.76-4.19-3.94v-15.36h-3.21c-2.15,0-4.22-.8-5.79-2.26-1.53-1.4-2.41-3.38-2.42-5.45,.03-.69,.61-1.23,1.3-1.21h65.9c3.33,.02,5.32,3.47,3.53,6.08Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 941.36,
    cy: 996.37,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1040.32,980.15v28.68c0,2.73-2.32,4.99-5.15,4.99h-67.79c-1.2,.02-2.2-.94-2.22-2.14v-1c0-6.21,4.39-11.48,10.33-13.02v-17.5c0-2.73,2.32-4.99,5.15-4.99h54.55c2.81,0,5.13,2.24,5.13,4.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1090.25,996.4c0,9.6-7.87,17.41-17.53,17.41s-17.53-7.79-17.53-17.41,7.87-17.41,17.53-17.41,17.53,7.81,17.53,17.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M847.06,1028.71v28.68c0,2.73-2.31,4.99-5.15,4.99h-67.79c-1.2,.02-2.2-.94-2.22-2.14v-1.01c0-6.21,4.39-11.47,10.33-13.02v-17.5c0-2.73,2.32-4.99,5.15-4.99h54.55c2.79-.03,5.08,2.2,5.13,4.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M896.98,1044.97c0,9.6-7.87,17.41-17.53,17.41s-17.53-7.79-17.53-17.41,7.87-17.41,17.53-17.41,17.53,7.81,17.53,17.41Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 921.46,
    cy: 1058.52,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 949.94,
    cy: 1058.52,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M974.17,1029.61l-16.17,20.33c-.81,1.14-2.12,1.81-3.52,1.8h-35.42c-2.32,0-4.19-1.76-4.19-3.94v-15.35h-3.21c-2.15,0-4.22-.8-5.8-2.27-1.53-1.4-2.41-3.37-2.42-5.44,.03-.69,.61-1.23,1.3-1.21h65.9c3.32,0,5.32,3.46,3.53,6.07Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1007.24,
    cy: 1044.94,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1106.2,1028.71v28.68c0,2.73-2.32,4.99-5.15,4.99h-67.79c-1.2,.02-2.2-.94-2.22-2.14v-1.01c0-6.21,4.39-11.47,10.33-13.02v-17.5c0-2.73,2.31-4.99,5.15-4.99h54.56c2.8,0,5.12,2.24,5.12,4.99Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 813.97,
    cy: 1093.5,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M912.93,1077.28v28.68c0,2.73-2.31,4.99-5.15,4.99h-67.79c-1.2,.02-2.2-.94-2.22-2.14h0v-1c0-6.21,4.39-11.48,10.33-13.02v-17.5c0-2.73,2.32-4.99,5.15-4.99h54.55c2.82,0,5.13,2.24,5.13,4.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M962.86,1093.53c0,9.6-7.87,17.41-17.53,17.41s-17.53-7.79-17.53-17.41,7.87-17.41,17.53-17.41,17.53,7.81,17.53,17.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1040.05,1078.18l-16.17,20.33c-.81,1.14-2.12,1.81-3.52,1.8h-35.42c-2.32,0-4.2-1.76-4.2-3.94v-15.36h-3.21c-2.15,0-4.21-.8-5.79-2.26-1.53-1.4-2.41-3.38-2.42-5.45,.03-.69,.61-1.23,1.3-1.21h65.9c3.32,.02,5.32,3.47,3.53,6.08Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1073.11,
    cy: 1093.5,
    rx: 17.53,
    ry: 17.41
  })), /*#__PURE__*/React.createElement("rect", {
    className: "d",
    x: -146.04,
    y: 0,
    width: 1079.94,
    height: 1920
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "e"
  }, /*#__PURE__*/React.createElement("g", {
    className: "i"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1860.25,
    cy: 26.39,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1959.21,10.16v28.68c0,2.73-2.32,4.99-5.15,4.99h-67.79c-1.2,.02-2.2-.94-2.22-2.14v-1c0-6.21,4.39-11.47,10.33-13.02V10.16c0-2.73,2.32-4.99,5.15-4.99h54.55c2.82,0,5.13,2.23,5.13,4.99Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1840.35,
    cy: 88.54,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1868.82,
    cy: 88.54,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1893.06,59.63l-16.17,20.34c-.81,1.14-2.12,1.81-3.52,1.8h-35.42c-2.32,0-4.19-1.76-4.19-3.94v-15.35h-3.21c-2.15,0-4.22-.8-5.8-2.26-1.53-1.4-2.41-3.37-2.42-5.44,.03-.69,.61-1.23,1.3-1.21h65.9c3.32,0,5.32,3.45,3.53,6.07Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1926.13,
    cy: 74.95,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1881.75,123.55c0,9.6-7.87,17.41-17.53,17.41s-17.53-7.79-17.53-17.41,7.87-17.4,17.53-17.4,17.53,7.8,17.53,17.4Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1906.22,
    cy: 137.11,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1958.93,108.2l-16.17,20.33c-.81,1.14-2.12,1.82-3.52,1.8h-35.42c-2.32,0-4.19-1.76-4.19-3.94v-15.36h-3.21c-2.15,0-4.22-.8-5.79-2.26-1.53-1.4-2.41-3.38-2.42-5.45,.03-.69,.61-1.23,1.3-1.21h65.9c3.33,.02,5.32,3.47,3.53,6.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1897.7,155.86v28.68c0,2.73-2.31,4.99-5.15,4.99h-67.79c-1.2,.02-2.2-.94-2.22-2.14v-1.01c0-6.21,4.39-11.47,10.33-13.02v-17.5c0-2.73,2.32-4.99,5.15-4.99h54.55c2.79-.03,5.08,2.2,5.13,4.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1947.62,172.12c0,9.6-7.87,17.41-17.53,17.41s-17.53-7.79-17.53-17.41,7.87-17.41,17.53-17.41,17.53,7.81,17.53,17.41Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1864.61,
    cy: 220.65,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1963.57,204.43v28.68c0,2.73-2.31,4.99-5.15,4.99h-67.79c-1.2,.02-2.2-.94-2.22-2.14h0v-1c0-6.21,4.39-11.48,10.33-13.02v-17.5c0-2.73,2.32-4.99,5.15-4.99h54.55c2.82,0,5.13,2.24,5.13,4.99Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1844.71,
    cy: 282.8,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1873.19,
    cy: 282.8,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1897.42,253.89l-16.17,20.33c-.8,1.15-2.12,1.83-3.52,1.82h-35.41c-2.32,0-4.19-1.76-4.19-3.94v-15.37h-3.22c-2.15,0-4.22-.8-5.8-2.26-1.53-1.4-2.41-3.38-2.42-5.45,.03-.69,.61-1.23,1.3-1.21h65.91c3.32,.02,5.32,3.47,3.53,6.08Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1930.49,
    cy: 269.21,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1836.18,301.56v28.68c0,2.73-2.31,4.99-5.15,4.99h-67.79c-1.2,.02-2.19-.94-2.22-2.14v-1c0-6.21,4.39-11.48,10.33-13.02v-17.5c0-2.73,2.32-4.99,5.15-4.99h54.55c2.82,0,5.13,2.24,5.13,4.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1886.11,317.82c0,9.6-7.87,17.41-17.53,17.41s-17.53-7.79-17.53-17.41,7.87-17.41,17.53-17.41,17.53,7.81,17.53,17.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1963.3,302.46l-16.17,20.33c-.8,1.15-2.12,1.83-3.52,1.82h-35.41c-2.32,0-4.19-1.76-4.19-3.94v-15.37h-3.22c-2.15,0-4.23-.81-5.8-2.27-1.53-1.4-2.41-3.37-2.42-5.44,.03-.69,.61-1.23,1.3-1.21h65.9c3.32,.02,5.32,3.46,3.53,6.08Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1737.21,
    cy: 317.27,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1836.17,301.05v28.68c0,2.73-2.32,4.99-5.15,4.99h-67.79c-1.2,.02-2.2-.94-2.22-2.14v-1c0-6.21,4.39-11.47,10.33-13.02v-17.5c0-2.73,2.32-4.99,5.15-4.99h54.55c2.82,0,5.13,2.23,5.13,4.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1886.09,317.31c0,9.6-7.87,17.41-17.53,17.41s-17.53-7.79-17.53-17.41,7.87-17.41,17.53-17.41,17.53,7.81,17.53,17.41Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1910.57,
    cy: 330.86,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1963.28,301.95l-16.17,20.33c-.8,1.15-2.12,1.83-3.52,1.82h-35.42c-2.32,0-4.19-1.76-4.19-3.94v-15.37h-3.21c-2.15,0-4.22-.8-5.8-2.26-1.53-1.4-2.41-3.36-2.42-5.43,.03-.69,.61-1.23,1.3-1.21h65.9c3.32-.02,5.32,3.44,3.53,6.06Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1717.3,
    cy: 379.43,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1745.78,
    cy: 379.43,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1770.02,350.51l-16.17,20.34c-.81,1.14-2.12,1.81-3.52,1.8h-35.42c-2.32,0-4.19-1.76-4.19-3.94v-15.35h-3.21c-2.15,0-4.22-.8-5.8-2.26-1.53-1.4-2.41-3.37-2.42-5.44,.03-.69,.61-1.23,1.3-1.21h65.9c3.32,0,5.32,3.45,3.53,6.07Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1803.08,
    cy: 365.84,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1902.04,349.62v28.68c0,2.73-2.31,4.99-5.15,4.99h-67.79c-1.2,.02-2.19-.94-2.22-2.14v-1.01c0-6.21,4.39-11.47,10.33-13.02v-17.5c0-2.73,2.32-4.99,5.15-4.99h54.56c2.79-.02,5.07,2.2,5.12,4.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1951.97,365.87c0,9.6-7.87,17.41-17.53,17.41s-17.52-7.79-17.52-17.41,7.87-17.41,17.53-17.41,17.52,7.81,17.52,17.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1758.71,414.44c0,9.6-7.87,17.41-17.53,17.41s-17.53-7.79-17.53-17.41,7.87-17.4,17.53-17.4,17.53,7.8,17.53,17.4Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1783.18,
    cy: 427.99,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1811.66,
    cy: 427.99,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1835.89,399.08l-16.17,20.33c-.81,1.14-2.12,1.82-3.52,1.8h-35.42c-2.32,0-4.19-1.76-4.19-3.94v-15.36h-3.21c-2.15,0-4.22-.8-5.79-2.26-1.53-1.4-2.41-3.38-2.42-5.45,.03-.69,.61-1.23,1.3-1.21h65.9c3.33,.02,5.32,3.47,3.53,6.08Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1868.96,
    cy: 414.41,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1967.92,398.18v28.68c0,2.73-2.32,4.99-5.15,4.99h-67.79c-1.2,.02-2.2-.94-2.22-2.14v-1c0-6.21,4.39-11.48,10.33-13.02v-17.5c0-2.73,2.32-4.99,5.15-4.99h54.55c2.81,0,5.13,2.24,5.13,4.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1774.66,446.75v28.68c0,2.73-2.31,4.99-5.15,4.99h-67.79c-1.2,.02-2.2-.94-2.22-2.14v-1.01c0-6.21,4.39-11.47,10.33-13.02v-17.5c0-2.73,2.32-4.99,5.15-4.99h54.55c2.79-.03,5.08,2.2,5.13,4.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1824.58,463.01c0,9.6-7.87,17.41-17.53,17.41s-17.53-7.79-17.53-17.41,7.87-17.41,17.53-17.41,17.53,7.81,17.53,17.41Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1849.06,
    cy: 476.56,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1877.54,
    cy: 476.56,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1901.77,447.65l-16.17,20.33c-.81,1.14-2.12,1.81-3.52,1.8h-35.42c-2.32,0-4.19-1.76-4.19-3.94v-15.35h-3.21c-2.15,0-4.22-.8-5.8-2.27-1.53-1.4-2.41-3.37-2.42-5.44,.03-.69,.61-1.23,1.3-1.21h65.9c3.32,0,5.32,3.46,3.53,6.07Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1934.84,
    cy: 462.97,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1741.57,
    cy: 511.54,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1840.53,495.31v28.68c0,2.73-2.31,4.99-5.15,4.99h-67.79c-1.2,.02-2.2-.94-2.22-2.14h0v-1c0-6.21,4.39-11.48,10.33-13.02v-17.5c0-2.73,2.32-4.99,5.15-4.99h54.55c2.82,0,5.13,2.24,5.13,4.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1890.46,511.57c0,9.6-7.87,17.41-17.53,17.41s-17.53-7.79-17.53-17.41,7.87-17.41,17.53-17.41,17.53,7.81,17.53,17.41Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1914.93,
    cy: 525.12,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1967.65,496.21l-16.17,20.33c-.81,1.14-2.12,1.81-3.52,1.8h-35.42c-2.32,0-4.2-1.76-4.2-3.94v-15.36h-3.21c-2.15,0-4.21-.8-5.79-2.26-1.53-1.4-2.41-3.38-2.42-5.45,.03-.69,.61-1.23,1.3-1.21h65.9c3.32,.02,5.32,3.47,3.53,6.08Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1721.67,
    cy: 573.69,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1750.15,
    cy: 573.69,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1774.38,544.78l-16.17,20.33c-.8,1.15-2.12,1.83-3.52,1.82h-35.41c-2.32,0-4.19-1.76-4.19-3.94v-15.37h-3.22c-2.15,0-4.22-.8-5.8-2.26-1.53-1.4-2.41-3.38-2.42-5.45,.03-.69,.61-1.23,1.3-1.21h65.91c3.32,.02,5.32,3.47,3.53,6.08Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1807.45,
    cy: 560.1,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1906.41,543.88v28.68c0,2.73-2.32,4.99-5.15,4.99h-67.79c-1.2,.02-2.2-.94-2.22-2.14v-1.01c0-6.21,4.39-11.47,10.33-13.02v-17.5c0-2.73,2.31-4.99,5.15-4.99h54.55c2.81,0,5.13,2.24,5.13,4.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1713.14,592.45v28.68c0,2.73-2.31,4.99-5.15,4.99h-67.79c-1.2,.02-2.19-.94-2.22-2.14v-1c0-6.21,4.39-11.48,10.33-13.02v-17.5c0-2.73,2.32-4.99,5.15-4.99h54.55c2.82,0,5.13,2.24,5.13,4.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1763.07,608.7c0,9.6-7.87,17.41-17.53,17.41s-17.53-7.79-17.53-17.41,7.87-17.41,17.53-17.41,17.53,7.81,17.53,17.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1840.26,593.35l-16.17,20.33c-.8,1.15-2.12,1.83-3.52,1.82h-35.41c-2.32,0-4.19-1.76-4.19-3.94v-15.37h-3.22c-2.15,0-4.23-.81-5.8-2.27-1.53-1.4-2.41-3.37-2.42-5.44,.03-.69,.61-1.23,1.3-1.21h65.9c3.32,.02,5.32,3.46,3.53,6.08Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1873.32,
    cy: 608.67,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1972.29,592.45v28.68c0,2.73-2.32,4.99-5.15,4.99h-67.79c-1.2,.02-2.2-.94-2.22-2.14v-1c0-6.21,4.39-11.48,10.33-13.02v-17.5c0-2.73,2.31-4.99,5.15-4.99h54.55c2.81,0,5.13,2.24,5.13,4.99Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1972.16,592.45v28.68c0,2.73-2.31,4.99-5.15,4.99h-67.79c-1.2,.02-2.19-.94-2.22-2.14v-1c0-6.21,4.39-11.48,10.33-13.02v-17.5c0-2.73,2.32-4.99,5.15-4.99h54.55c2.82,0,5.13,2.24,5.13,4.99Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1873.37,
    cy: 608.35,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1972.34,592.13v28.68c0,2.73-2.32,4.99-5.15,4.99h-67.79c-1.2,.02-2.2-.94-2.22-2.14v-1c0-6.21,4.39-11.47,10.33-13.02v-17.5c0-2.73,2.32-4.99,5.15-4.99h54.55c2.82,0,5.13,2.23,5.13,4.99Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1853.47,
    cy: 670.5,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1881.95,
    cy: 670.5,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1906.18,641.59l-16.17,20.34c-.81,1.14-2.12,1.81-3.52,1.8h-35.42c-2.32,0-4.19-1.76-4.19-3.94v-15.35h-3.21c-2.15,0-4.22-.8-5.8-2.26-1.53-1.4-2.41-3.37-2.42-5.44,.03-.69,.61-1.23,1.3-1.21h65.9c3.32,0,5.32,3.45,3.53,6.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1894.87,705.51c0,9.6-7.87,17.41-17.53,17.41s-17.53-7.79-17.53-17.41,7.87-17.4,17.53-17.4,17.53,7.8,17.53,17.4Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1919.35,
    cy: 719.07,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1972.06,690.16l-16.17,20.33c-.81,1.14-2.12,1.82-3.52,1.8h-35.42c-2.32,0-4.19-1.76-4.19-3.94v-15.36h-3.21c-2.15,0-4.22-.8-5.79-2.26-1.53-1.4-2.41-3.38-2.42-5.45,.03-.69,.61-1.23,1.3-1.21h65.9c3.33,.02,5.32,3.47,3.53,6.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1910.82,737.83v28.68c0,2.73-2.31,4.99-5.15,4.99h-67.79c-1.2,.02-2.2-.94-2.22-2.14v-1.01c0-6.21,4.39-11.47,10.33-13.02v-17.5c0-2.73,2.32-4.99,5.15-4.99h54.55c2.79-.03,5.08,2.2,5.13,4.99Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1877.74,
    cy: 802.61,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1976.7,786.39v28.68c0,2.73-2.31,4.99-5.15,4.99h-67.79c-1.2,.02-2.2-.94-2.22-2.14h0v-1c0-6.21,4.39-11.48,10.33-13.02v-17.5c0-2.73,2.32-4.99,5.15-4.99h54.55c2.82,0,5.13,2.24,5.13,4.99Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1857.83,
    cy: 864.77,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1886.31,
    cy: 864.77,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1910.55,835.85l-16.17,20.33c-.8,1.15-2.12,1.83-3.52,1.82h-35.41c-2.32,0-4.19-1.76-4.19-3.94v-15.37h-3.22c-2.15,0-4.22-.8-5.8-2.26-1.53-1.4-2.41-3.38-2.42-5.45,.03-.69,.61-1.23,1.3-1.21h65.91c3.32,.02,5.32,3.47,3.53,6.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1849.31,883.52v28.68c0,2.73-2.31,4.99-5.15,4.99h-67.79c-1.2,.02-2.19-.94-2.22-2.14v-1c0-6.21,4.39-11.48,10.33-13.02v-17.5c0-2.73,2.32-4.99,5.15-4.99h54.55c2.82,0,5.13,2.24,5.13,4.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1899.23,899.78c0,9.6-7.87,17.41-17.53,17.41s-17.53-7.79-17.53-17.41,7.87-17.41,17.53-17.41,17.53,7.81,17.53,17.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1976.42,884.42l-16.17,20.33c-.8,1.15-2.12,1.83-3.52,1.82h-35.41c-2.32,0-4.19-1.76-4.19-3.94v-15.37h-3.22c-2.15,0-4.23-.81-5.8-2.27-1.53-1.4-2.41-3.37-2.42-5.44,.03-.69,.61-1.23,1.3-1.21h65.9c3.32,.02,5.32,3.46,3.53,6.08Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1750.33,
    cy: 899.24,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1849.29,883.01v28.68c0,2.73-2.32,4.99-5.15,4.99h-67.79c-1.2,.02-2.2-.94-2.22-2.14v-1c0-6.21,4.39-11.47,10.33-13.02v-17.5c0-2.73,2.32-4.99,5.15-4.99h54.55c2.82,0,5.13,2.23,5.13,4.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1899.22,899.27c0,9.6-7.87,17.41-17.53,17.41s-17.53-7.79-17.53-17.41,7.87-17.41,17.53-17.41,17.53,7.81,17.53,17.41Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1923.69,
    cy: 912.82,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1976.41,883.91l-16.17,20.33c-.8,1.15-2.12,1.83-3.52,1.82h-35.42c-2.32,0-4.19-1.76-4.19-3.94v-15.37h-3.21c-2.15,0-4.22-.8-5.8-2.26-1.53-1.4-2.41-3.36-2.42-5.43,.03-.69,.61-1.23,1.3-1.21h65.9c3.32-.02,5.32,3.44,3.53,6.06Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1730.43,
    cy: 961.39,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1758.91,
    cy: 961.39,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1783.14,932.48l-16.17,20.34c-.81,1.14-2.12,1.81-3.52,1.8h-35.42c-2.32,0-4.19-1.76-4.19-3.94v-15.35h-3.21c-2.15,0-4.22-.8-5.8-2.26-1.53-1.4-2.41-3.37-2.42-5.44,.03-.69,.61-1.23,1.3-1.21h65.9c3.32,0,5.32,3.45,3.53,6.07Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1816.21,
    cy: 947.8,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1915.17,931.58v28.68c0,2.73-2.31,4.99-5.15,4.99h-67.79c-1.2,.02-2.19-.94-2.22-2.14v-1.01c0-6.21,4.39-11.47,10.33-13.02v-17.5c0-2.73,2.32-4.99,5.15-4.99h54.56c2.79-.02,5.07,2.2,5.12,4.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1771.83,996.4c0,9.6-7.87,17.41-17.53,17.41s-17.53-7.79-17.53-17.41,7.87-17.4,17.53-17.4,17.53,7.8,17.53,17.4Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1796.31,
    cy: 1009.96,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1824.78,
    cy: 1009.96,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1849.02,981.04l-16.17,20.33c-.81,1.14-2.12,1.82-3.52,1.8h-35.42c-2.32,0-4.19-1.76-4.19-3.94v-15.36h-3.21c-2.15,0-4.22-.8-5.79-2.26-1.53-1.4-2.41-3.38-2.42-5.45,.03-.69,.61-1.23,1.3-1.21h65.9c3.33,.02,5.32,3.47,3.53,6.08Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1882.08,
    cy: 996.37,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1981.05,980.15v28.68c0,2.73-2.32,4.99-5.15,4.99h-67.79c-1.2,.02-2.2-.94-2.22-2.14v-1c0-6.21,4.39-11.48,10.33-13.02v-17.5c0-2.73,2.32-4.99,5.15-4.99h54.55c2.81,0,5.13,2.24,5.13,4.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1787.78,1028.71v28.68c0,2.73-2.31,4.99-5.15,4.99h-67.79c-1.2,.02-2.2-.94-2.22-2.14v-1.01c0-6.21,4.39-11.47,10.33-13.02v-17.5c0-2.73,2.32-4.99,5.15-4.99h54.55c2.79-.03,5.08,2.2,5.13,4.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1837.7,1044.97c0,9.6-7.87,17.41-17.53,17.41s-17.53-7.79-17.53-17.41,7.87-17.41,17.53-17.41,17.53,7.81,17.53,17.41Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1862.18,
    cy: 1058.52,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1890.66,
    cy: 1058.52,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1914.9,1029.61l-16.17,20.33c-.81,1.14-2.12,1.81-3.52,1.8h-35.42c-2.32,0-4.19-1.76-4.19-3.94v-15.35h-3.21c-2.15,0-4.22-.8-5.8-2.27-1.53-1.4-2.41-3.37-2.42-5.44,.03-.69,.61-1.23,1.3-1.21h65.9c3.32,0,5.32,3.46,3.53,6.07Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1754.7,
    cy: 1093.5,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1853.66,1077.28v28.68c0,2.73-2.31,4.99-5.15,4.99h-67.79c-1.2,.02-2.2-.94-2.22-2.14h0v-1c0-6.21,4.39-11.48,10.33-13.02v-17.5c0-2.73,2.32-4.99,5.15-4.99h54.55c2.82,0,5.13,2.24,5.13,4.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1903.58,1093.53c0,9.6-7.87,17.41-17.53,17.41s-17.53-7.79-17.53-17.41,7.87-17.41,17.53-17.41,17.53,7.81,17.53,17.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1980.77,1078.18l-16.17,20.33c-.81,1.14-2.12,1.81-3.52,1.8h-35.42c-2.32,0-4.2-1.76-4.2-3.94v-15.36h-3.21c-2.15,0-4.21-.8-5.79-2.26-1.53-1.4-2.41-3.38-2.42-5.45,.03-.69,.61-1.23,1.3-1.21h65.9c3.32,.02,5.32,3.47,3.53,6.08Z"
  })), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1614.71,
    cy: 608.35,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1713.68,592.13v28.68c0,2.73-2.32,4.99-5.15,4.99h-67.79c-1.2,.02-2.2-.94-2.22-2.14v-1c0-6.21,4.39-11.47,10.33-13.02v-17.5c0-2.73,2.32-4.99,5.15-4.99h54.55c2.82,0,5.13,2.23,5.13,4.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1763.6,608.39c0,9.6-7.87,17.41-17.53,17.41s-17.53-7.79-17.53-17.41,7.87-17.41,17.53-17.41,17.53,7.81,17.53,17.41Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1788.07,
    cy: 621.94,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1816.55,
    cy: 621.94,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1840.79,593.03l-16.17,20.33c-.8,1.15-2.12,1.83-3.52,1.82h-35.42c-2.32,0-4.19-1.76-4.19-3.94v-15.37h-3.21c-2.15,0-4.22-.8-5.8-2.26-1.53-1.4-2.41-3.36-2.42-5.43,.03-.69,.61-1.23,1.3-1.21h65.9c3.32-.02,5.32,3.44,3.53,6.06Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1873.86,
    cy: 608.35,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1594.81,
    cy: 670.5,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1623.29,
    cy: 670.5,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1647.52,641.59l-16.17,20.34c-.81,1.14-2.12,1.81-3.52,1.8h-35.42c-2.32,0-4.19-1.76-4.19-3.94v-15.35h-3.21c-2.15,0-4.22-.8-5.8-2.26-1.53-1.4-2.41-3.37-2.42-5.44,.03-.69,.61-1.23,1.3-1.21h65.9c3.32,0,5.32,3.45,3.53,6.07Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1680.59,
    cy: 656.92,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1779.55,640.69v28.68c0,2.73-2.31,4.99-5.15,4.99h-67.79c-1.2,.02-2.19-.94-2.22-2.14v-1.01c0-6.21,4.39-11.47,10.33-13.02v-17.5c0-2.73,2.32-4.99,5.15-4.99h54.56c2.79-.02,5.07,2.2,5.12,4.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1829.47,656.95c0,9.6-7.87,17.41-17.53,17.41s-17.52-7.79-17.52-17.41,7.87-17.41,17.53-17.41,17.52,7.81,17.52,17.41Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1853.95,
    cy: 670.5,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1882.43,
    cy: 670.5,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1906.66,641.59l-16.17,20.34c-.81,1.14-2.12,1.81-3.52,1.8h-35.42c-2.32,0-4.19-1.76-4.19-3.94v-15.35h-3.21c-2.15,0-4.22-.8-5.8-2.26-1.53-1.4-2.41-3.37-2.42-5.44,.03-.69,.61-1.23,1.3-1.21h65.9c3.33,0,5.33,3.45,3.53,6.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1636.21,705.51c0,9.6-7.87,17.41-17.53,17.41s-17.53-7.79-17.53-17.41,7.87-17.4,17.53-17.4,17.53,7.8,17.53,17.4Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1660.69,
    cy: 719.07,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1689.16,
    cy: 719.07,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1713.4,690.16l-16.17,20.33c-.81,1.14-2.12,1.82-3.52,1.8h-35.42c-2.32,0-4.19-1.76-4.19-3.94v-15.36h-3.21c-2.15,0-4.22-.8-5.79-2.26-1.53-1.4-2.41-3.38-2.42-5.45,.03-.69,.61-1.23,1.3-1.21h65.9c3.33,.02,5.32,3.47,3.53,6.08Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1746.47,
    cy: 705.48,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1845.43,689.26v28.68c0,2.73-2.32,4.99-5.15,4.99h-67.79c-1.2,.02-2.2-.94-2.22-2.14v-1c0-6.21,4.39-11.48,10.33-13.02v-17.5c0-2.73,2.32-4.99,5.15-4.99h54.55c2.81,0,5.13,2.24,5.13,4.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1895.35,705.51c0,9.6-7.87,17.41-17.53,17.41s-17.53-7.79-17.53-17.41,7.87-17.41,17.53-17.41,17.53,7.81,17.53,17.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1652.16,737.83v28.68c0,2.73-2.31,4.99-5.15,4.99h-67.79c-1.2,.02-2.2-.94-2.22-2.14v-1.01c0-6.21,4.39-11.47,10.33-13.02v-17.5c0-2.73,2.32-4.99,5.15-4.99h54.55c2.79-.03,5.08,2.2,5.13,4.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1702.09,754.08c0,9.6-7.87,17.41-17.53,17.41s-17.53-7.79-17.53-17.41,7.87-17.41,17.53-17.41,17.53,7.81,17.53,17.41Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1726.56,
    cy: 767.64,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1755.04,
    cy: 767.64,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1779.28,738.72l-16.17,20.33c-.81,1.14-2.12,1.81-3.52,1.8h-35.42c-2.32,0-4.19-1.76-4.19-3.94v-15.35h-3.21c-2.15,0-4.22-.8-5.8-2.27-1.53-1.4-2.41-3.37-2.42-5.44,.03-.69,.61-1.23,1.3-1.21h65.9c3.32,0,5.32,3.46,3.53,6.07Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1812.34,
    cy: 754.05,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1911.3,737.83v28.68c0,2.73-2.32,4.99-5.15,4.99h-67.79c-1.2,.02-2.2-.94-2.22-2.14v-1.01c0-6.21,4.39-11.47,10.33-13.02v-17.5c0-2.73,2.31-4.99,5.15-4.99h54.56c2.8,0,5.12,2.24,5.12,4.99Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1619.08,
    cy: 802.61,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1718.04,786.39v28.68c0,2.73-2.31,4.99-5.15,4.99h-67.79c-1.2,.02-2.2-.94-2.22-2.14h0v-1c0-6.21,4.39-11.48,10.33-13.02v-17.5c0-2.73,2.32-4.99,5.15-4.99h54.55c2.82,0,5.13,2.24,5.13,4.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1767.96,802.65c0,9.6-7.87,17.41-17.53,17.41s-17.53-7.79-17.53-17.41,7.87-17.41,17.53-17.41,17.53,7.81,17.53,17.41Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1792.44,
    cy: 816.2,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1820.92,
    cy: 816.2,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1845.15,787.29l-16.17,20.33c-.81,1.14-2.12,1.81-3.52,1.8h-35.42c-2.32,0-4.2-1.76-4.2-3.94v-15.36h-3.21c-2.15,0-4.21-.8-5.79-2.26-1.53-1.4-2.41-3.38-2.42-5.45,.03-.69,.61-1.23,1.3-1.21h65.9c3.32,.02,5.32,3.47,3.53,6.08Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1878.22,
    cy: 802.61,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1599.17,
    cy: 864.77,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1627.65,
    cy: 864.77,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1651.89,835.85l-16.17,20.33c-.8,1.15-2.12,1.83-3.52,1.82h-35.41c-2.32,0-4.19-1.76-4.19-3.94v-15.37h-3.22c-2.15,0-4.22-.8-5.8-2.26-1.53-1.4-2.41-3.38-2.42-5.45,.03-.69,.61-1.23,1.3-1.21h65.91c3.32,.02,5.32,3.47,3.53,6.08Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1684.95,
    cy: 851.18,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1783.92,834.96v28.68c0,2.73-2.32,4.99-5.15,4.99h-67.79c-1.2,.02-2.2-.94-2.22-2.14v-1.01c0-6.21,4.39-11.47,10.33-13.02v-17.5c0-2.73,2.31-4.99,5.15-4.99h54.55c2.81,0,5.13,2.24,5.13,4.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1833.84,851.21c0,9.6-7.87,17.41-17.53,17.41s-17.53-7.79-17.53-17.41,7.87-17.41,17.53-17.41,17.53,7.81,17.53,17.41Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1858.32,
    cy: 864.77,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1886.79,
    cy: 864.77,
    rx: 3.88,
    ry: 3.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1911.03,835.85l-16.17,20.33c-.8,1.15-2.12,1.83-3.52,1.82h-35.42c-2.32,0-4.19-1.76-4.19-3.94v-15.37h-3.21c-2.15,0-4.22-.8-5.8-2.26-1.53-1.4-2.41-3.38-2.42-5.45,.03-.69,.61-1.23,1.3-1.21h65.9c3.33,.02,5.32,3.47,3.53,6.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1590.65,883.52v28.68c0,2.73-2.31,4.99-5.15,4.99h-67.79c-1.2,.02-2.19-.94-2.22-2.14v-1c0-6.21,4.39-11.48,10.33-13.02v-17.5c0-2.73,2.32-4.99,5.15-4.99h54.55c2.82,0,5.13,2.24,5.13,4.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1640.57,899.78c0,9.6-7.87,17.41-17.53,17.41s-17.53-7.79-17.53-17.41,7.87-17.41,17.53-17.41,17.53,7.81,17.53,17.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1717.76,884.42l-16.17,20.33c-.8,1.15-2.12,1.83-3.52,1.82h-35.41c-2.32,0-4.19-1.76-4.19-3.94v-15.37h-3.22c-2.15,0-4.23-.81-5.8-2.27-1.53-1.4-2.41-3.37-2.42-5.44,.03-.69,.61-1.23,1.3-1.21h65.9c3.32,.02,5.32,3.46,3.53,6.08Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 1750.83,
    cy: 899.74,
    rx: 17.53,
    ry: 17.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1849.79,883.52v28.68c0,2.73-2.32,4.99-5.15,4.99h-67.79c-1.2,.02-2.2-.94-2.22-2.14v-1c0-6.21,4.39-11.48,10.33-13.02v-17.5c0-2.73,2.31-4.99,5.15-4.99h54.55c2.81,0,5.13,2.24,5.13,4.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1899.72,899.78c0,9.6-7.87,17.41-17.53,17.41s-17.53-7.79-17.53-17.41,7.87-17.41,17.53-17.41,17.53,7.81,17.53,17.41Z"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "d",
    x: 1830.92,
    y: 0,
    width: 1079.94,
    height: 1920
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraybg);
export default __webpack_public_path__ + "static/media/graybg.1c4b1c820a95d036d1900f738dd6a6b6.svg";
export { ForwardRef as ReactComponent };